var version = "1.0.3894.7dbe35c92ed8b837da1beefbc668933bef37b639"
const documentTypeEnum = {
    releve10: 'releve10',
    releve10Special: 'releve10Special',
    releveDePlacements: 'releveDePlacements',
    attestationActionsDetenues: 'attestationActionsDetenues',
    releveRapReep: 'correspondanceRAPREEP',
    releveT4RSP: 'releveT4RSP',
    releve2: 'releve2',
    releveNR4: 'releveNR4',
    confirmationAdhesion: 'confirmationAdhesion',
    releveT5008: 'releveT5008',
    releve18: 'releve18',
    recapitulatifAdhesion: 'recapitulatifAdhesion'
}

﻿const portefeuilleController = function ($scope) {
    $scope.today = new Date()

    $scope.afficherBoutonCotiserEnLigne = () => $scope.portefeuille.adhesions
        .some(a => a.regime !== regimeEnum.reerConjoint)

    const dernier = type => {
        return $scope.documents
            .filter(d => d.type === type)
            .sort((a, b) => new Date(b.date) - new Date(a.date))[0]
    }

    $scope.dernierReleveDePlacements = () => dernier(documentTypeEnum.releveDePlacements)
    $scope.dernierReleve10 = () => dernier(documentTypeEnum.releve10)
    $scope.derniereAttestationDesActionsDetenues = () => dernier(documentTypeEnum.attestationActionsDetenues)

    $scope.estEnAnneeDeSursisRap = () => $scope.rap.estEnSursis

    $scope.showTransactionsEnCours = () => $scope.transactionsEnTraitement?.length > 0 || $scope.demandesRachatNonCompletees?.length > 0
}


const arretRssRaisons = {
    arretTravailTemporaire: 'arretTravailTemporaire',
    retraite: 'retraite',
    changementEmployeur: 'changementEmployeur',
    maxCreditsImpot: 'maxCreditsImpot',
    capaciteEpargneReduite: 'capaciteEpargneReduite',
    diversificationPlacements: 'diversificationPlacements',
    finRap: 'finRap',
    insatisfaction: 'insatisfaction',
    espaceReer: 'espaceReer',
    finEmploi: 'finEmploi',
    nonSpecifie: 'nonSpecifie'
}
let raisons = {
    'arretTravailTemporaire': {'francais': 'Arrêt de travail temporaire', 'english': 'Temporary leave of absence'},
    'retraite': {'francais': 'Départ à la retraite', 'english': 'Retirement'},
    'changementEmployeur': {'francais': 'Changement d\'employeur', 'english': 'New employer'},
    'maxCreditsImpot': {
        'francais': 'Cotisation maximale atteinte pour profiter des crédits d\'impôt pour fonds de travailleurs',
        'english': 'The labour-sponsored funds tax credit limit has been reached'
    },
    'capaciteEpargneReduite': {'francais': 'Capacité d’épargne réduite', 'english': 'Reduced savings capacity'},
    'diversificationPlacements': {
        'francais': 'Diversification des placements',
        'english': 'Diversification of investments'
    },
    'finRap': {'francais': 'Fin du remboursement d\'un RAP ou REEP', 'english': 'End of HBP or LLP repayment'},
    'insatisfaction': {'francais': 'Insatisfaction envers Fondaction', 'english': 'Dissatisfaction with Fondaction '},
    'espaceReer': {
        'francais': 'Plus de droits REER disponibles cette année',
        'english': 'No more RRSP contribution room available this year'
    },
    'finEmploi': {'francais': 'Fin d’emploi', 'english': 'End of employment'},
    'nonSpecifie': {'francais': 'Autre', 'english': 'Other'}
}

let raisonRssFilter = function (raison, lang) {
    return raisons[raison] ? raisons[raison][lang] : '';
}
function creerDemandeRss(rssAvecEmployeur, adhesions) {

    let demande = {
        employeur: rssAvecEmployeur.employeur,
        intention: intentionAPartirDe(rssAvecEmployeur.etat),
        utilisateurNonEligiblePourDeductionReer: !isUtilisateurEligiblePourDeductionReer(adhesions)
    }

    let montantAffichable = function (montant) {
        return montant === 0 ? '' : montant.toFixed(2)
    }

    let pourcentageAffichable = function (nombre) {
        return nombre === 0 ? '' : nombre.toString()
    }

    if (rssAvecEmployeur.etat === rssEtatEnum.active) {
        let cotisationEmploye = rssAvecEmployeur.rss.cotisationEmploye
        demande.cotisationEmploye = {
            montantPaie: montantAffichable(cotisationEmploye.montantPaie),
            montantHoraire: montantAffichable(cotisationEmploye.montantHoraire),
            pourcentagePaie: pourcentageAffichable(cotisationEmploye.pourcentagePaie)
        }
        demande.typeDeductionImpot = rssAvecEmployeur.rss.typeDeductionImpot
    } else {
        demande.cotisationEmploye = {
            montantPaie: '',
            montantHoraire: '',
            pourcentagePaie: ''
        }
    }

    return demande
}
let isUtilisateurEligiblePourDeductionReer = function (adhesions) {
    let premiereAdhesionEnregistree = adhesions.find(function (adhesion) {
        return adhesion.regime !== regimeEnum.nonEnregistre
    })
    return premiereAdhesionEnregistree !== undefined
}
let intentionAPartirDe = function (etat) {
    let intentions = {}
    intentions[rssEtatEnum.active] = intentionDemandeRss.modification
    intentions[rssEtatEnum.jamaisActive] = intentionDemandeRss.activation
    intentions[rssEtatEnum.arretee] = intentionDemandeRss.reactivation

    return intentions[etat]
}

let intentionDemandeRss = {
    modification: 'modification',
    activation: 'activation',
    reactivation: 'reactivation',
    demarrer: 'demarrer'
}

let rssEtatEnum = {
    nonSupporte: 'nonSupporte',
    sansEmployeur: 'sansEmployeur',
    jamaisActive: 'jamaisActive',
    active: 'active',
    arretee: 'arretee',
    gereeParSiteEmployeur: 'gereeParSiteEmployeur'
}

let rssContext = function (rssAvecEmployeur) {
    let isCasNonSupporte = function () {
        return rssAvecEmployeur.etat === rssEtatEnum.nonSupporte
    }

    let isCasSupporte = function () {
        return rssAvecEmployeur.etat !== rssEtatEnum.nonSupporte
    }

    let isEtatArretee = function () {
        return rssAvecEmployeur.etat === rssEtatEnum.arretee
    }

    let isEtatJamaisActive = function () {
        return rssAvecEmployeur.etat === rssEtatEnum.jamaisActive
    }

    let isEtatGereeParSiteEmployeur = function () {
        return rssAvecEmployeur.etat === rssEtatEnum.gereeParSiteEmployeur
    }

    let isEtatActive = function () {
        return rssAvecEmployeur.etat === rssEtatEnum.active
    }

    let hasEmployeur = function () {
        return rssAvecEmployeur.etat !== rssEtatEnum.sansEmployeur
    }

    return {
        isCasNonSupporte: isCasNonSupporte,
        isCasSupporte: isCasSupporte,
        isEtatArretee: isEtatArretee,
        isEtatJamaisActive: isEtatJamaisActive,
        isEtatGereeParSiteEmployeur: isEtatGereeParSiteEmployeur,
        isEtatActive: isEtatActive,
        hasEmployeur: hasEmployeur
    }
}


let cotisationRssFilter = function (cotisation, lang) {
    let texte = []

    if (cotisation.montantPaie > 0)
        texte.push(montantFilter(cotisation.montantPaie, lang) + ' ' + translate(lang, 'par paie', 'per pay'))

    if (cotisation.montantHoraire > 0)
        texte.push(montantFilter(cotisation.montantHoraire, lang) + ' ' + translate(lang, 'par heure', 'per hour'))

    if (cotisation.pourcentagePaie > 0)
        texte.push(percentage(cotisation.pourcentagePaie) + ' ' + translate(lang, 'de mon salaire', 'of my salary'))

    if (texte.length === 0)
        texte.push(translate(lang, 'Aucune', 'None'))

    return texte.join(translate(lang, ' et ', ' and '))
}

let translate = function (lang, texteFrancais, texteAnglais) {
    return lang === 'english' ? texteAnglais : texteFrancais
}

let percentage = function (number) {
    return number.toString().replace('.', ',') + ' %'
}

let typesDeductionsFrancais = {
    'aucune': 'Aucune',
    'creditsSeulement': 'Crédits d\'impôt seulement',
    'reerEtCredits': 'Déduction REER et crédits d\'impôt',
    'reerSeulement': 'Déduction REER seulement'
}

let typesDeductionsAnglais = {
    'aucune': 'None',
    'creditsSeulement': 'Tax credits only',
    'reerEtCredits': 'RRSP deduction and tax credits',
    'reerSeulement': 'RRSP deduction only'
}

let typeDeductionsFilter = function (type, lang) {
    if (lang === 'english')
        return typesDeductionsAnglais[type]
    return typesDeductionsFrancais[type]
}

let valeurAccumuleeParRssFilter = function (adhesion) {
    return adhesion.cotisations
        .filter(function (c) {
            return c.typeCotisation === 'employe' || c.typeCotisation === 'employeur' || c.typeCotisation === 'additionnel'
        })
        .reduce(function (sum, c) {
            return sum + c.montantNet
        }, 0)
}

let langueEnum = {
    francais: 'francais',
    anglais: 'english'
}
globalThis.adhesionRoleEnum =
    {
        actionnaireUniquement: 'actionnaire',
        payeur: 'payeur'
    }
globalThis.regimeEnum = {
    enregistre: 'enregistre',
    reerConjoint: 'reerConjoint',
    nonEnregistre: 'nonEnregistre',
    autogere: 'autogere'
}
globalThis.souscriptionTypeEnum = {
    retenueSalaire: 'retenueSalaire',
    versementUnique: 'versementUnique',
    debitPreAutorise: 'debitPreAutorise'
}
globalThis.typeDeductionEnum = {
    tout: 'reerEtCredits',
    reer: 'reerSeulement',
    creditImpot: 'creditsSeulement',
    aucune: 'aucune'
}
globalThis.typeVersementEnum = {
    versementPeriodiqueParDebitPreAutorise: 'versementPeriodiqueParDebitPreAutorise',
    versementUniqueParDebitPreAutorise: 'versementUniqueParDebitPreAutorise',
    versementPeriodiqueParRetenueSurSalaire: 'versementPeriodiqueParRetenueSurSalaire'
}
var adhesionFilter = function (numeroAdhesion, adhesions, langue) {
  var adhesionCorrespondante = adhesions.find(function (adhesion) { return adhesion.numeroAdhesion === numeroAdhesion })
  var regimeAffichable = adhesionCorrespondante ? ' (' + regimeFilter(adhesionCorrespondante.regime, langue) + ')' : ''

  return numeroAdhesion + regimeAffichable
}
class PafController {
    $sce;
    $window;
    $uibModalStack;
    authenticationService;
    actionnaireService;
    featureSwitchService;
    languageService;
    limiteVersementService;

    static $inject = ['$scope', '$location', '$sce', '$window', '$uibModalStack', 'authenticationService', 'actionnaireService', 'featureSwitchService', 'languageService', 'limiteVersementService']
    constructor($scope, $location, $sce, $window, $uibModalStack, authenticationService, actionnaireService, featureSwitchService, languageService, limiteVersementService) {
        this.$scope = $scope
        this.$location = $location
        this.$sce = $sce
        this.$window = $window
        this.$uibModalStack = $uibModalStack
        this.authenticationService = authenticationService
        this.actionnaireService = actionnaireService
        this.featureSwitchService = featureSwitchService
        this.languageService = languageService
        this.limiteVersementService = limiteVersementService

        this.$scope.getLang = () => languageService.lang

        this.configureDidomi();
        this.configureNavBarScope()
        this.configureLimiteVersementsScope()
        this.configureFeatureSwitchScope()
        this.configurePortefeuilleScope()

        this.$scope.$on('$locationChangeStart', () => this.locationChangeStart())
        this.$scope.$on('$locationChangeSuccess', () => this.locationChangeSuccess())
    }

    configureDidomi() {
        this.$window.didomiConfig = {
            languages: {
                enabled: this.languageService.lang === langueEnum.francais ? ['fr'] : ['en'],
                default: this.languageService.lang === langueEnum.francais ? 'fr' : 'en'
            }
        }
    }

    configureFeatureSwitchScope() {
        this.featureSwitchService.fetchFeatureSwitches()
    }

    // todo: move to service (portefeuille? actionnaire?)
    configurePortefeuilleScope() {
        this.authenticationService.onLogOut(() => this.setPortefeuille({}))

        this.$scope.rechargerPortefeuille = async () => {
            this.actionnaireService.clearCache()
            this.setPortefeuille({})

            if (!this.authenticationService.loggedId())
                return

            await this.chargerPortefeuille()
        }
    }

    // todo: move to nav bar component
    configureNavBarScope() {
        this.$scope.logOut = () => this.authenticationService.userLogOut()
        this.$scope.currentPathMatch = path => this.$location.path() === path
    }

    // todo: move to nav bar component
    updateNavBarScope() {
        this.$scope.isLogged = this.authenticationService.isLogged()
        this.$scope.isRestricted = !this.authenticationService.loggedId() || !this.authenticationService.isEmailVerified()
        this.$scope.location = this.languageService.lang === langueEnum.anglais
            ? this.$location.absUrl().replace('english', 'francais')
            : this.$location.absUrl().replace('francais', 'english')
    }

    // todo: move to limite versement service
    configureLimiteVersementsScope() {
        this.limiteVersementService.isLimiteVersementEnabled()
            .then(limite => {
                this.limiteVersement = {
                    active: limite.limiteActive,
                    [langueEnum.francais]: limite.messageFrancais,
                    [langueEnum.anglais]: limite.messageAnglais
                }
            })
            .catch(() => {
                this.limiteVersement = {active: false}
            })

        this.$scope.isLimiteVersementsActive = () => this.limiteVersement?.active

        this.$scope.limiteVersementsMessage = () => {
            const message = this.limiteVersement?.[this.languageService.lang]
            // is this necessary since we have ngSanitize installed?
            return this.$sce.trustAsHtml(message)
        }
    }

    locationChangeStart() {
        // redirect legacy urls
        if (this.$location.hash().startsWith('/')) {
            this.$location.url(this.$location.hash())
            return
        }

        this.hideAllDialogs()
    }

    // Patch to hide all popups on session timeout
    // Remove once all popups are handled in components and components manage their lifecycle ($onDestroy)
    hideAllDialogs() {
        this.$uibModalStack.dismissAll()
    }

    async locationChangeSuccess() {
        this.$window.scrollTo(0, 0)

        this.updateNavBarScope()

        // these are handled in authenticationService, so acceptation légale interferes
        if (!this.authenticationService.loggedId() || !this.authenticationService.isEmailVerified())
            return

        if (!this.$scope.portefeuille)
            await this.chargerPortefeuille()
        this.gotoAcceptationIfRequired()
    }

    gotoAcceptationIfRequired() {
        if (this.authenticationService.loggedRole())
            return

        if (this.isConsentementPortailAccepted())
            return

        // todo: isRestricted should be computed in a single place
        this.$scope.isRestricted = true

        if (this.$location.path() !== '/acceptationLegale')
            this.$location.search().f = this.$location.path()
        this.$location.path('/acceptationLegale')
    }

    isConsentementPortailAccepted() {
        return this.$scope.actionnaire.consentementUtilisationDuPortailActionnaire
    }

    chargerPortefeuille() {
        this.$scope.loadingPortefeuille = true
        return this.actionnaireService.getActionnaireFull()
            .then(info => this.setPortefeuille(info))
            .catch(() => this.setPortefeuille({}))
    }

    setPortefeuille(info) {
        this.$scope.loadingPortefeuille = false
        this.$scope.portefeuille = info.portefeuille
        this.$scope.transactionsEnTraitement = info.transactionsEnTraitement
        this.$scope.documents = info.documents
        this.$scope.actionnaire = info.actionnaire
        this.$scope.sansAdhesion = info.sansAdhesion
        this.$scope.rap = info.rap
        this.$scope.reep = info.reep
        this.$scope.adhesionEligibleRachatLibreService = info.adhesionEligibleRachatLibreService
        this.$scope.demandesRachatNonCompletees = info.demandesRachatNonCompletees
    }
}
function deepEquals(left, right) {
    if (left === right)
        return true

    if (isPrimitive(left) || isPrimitive(right))
        return false

    if (Object.keys(left).length !== Object.keys(right).length)
        return false

    for (let prop in left) {
        if (!(prop in right)) return false
        if (!deepEquals(left[prop], right[prop])) return false
    }

    return true
}

function isPrimitive(obj) {
    return (obj !== Object(obj))
}
function exceptionHandlerLogger($delegate) {
    function unauthorizedException(e) {
        return typeof e === 'string' && e.includes('TokenUnauthorizedException')
    }

    return (exception, cause) => {
        if (unauthorizedException(exception))
            return

        $delegate(exception, cause)
    }
}

exceptionHandlerLogger.$inject = ['$delegate']
const montantToDecimal = montant => {
    if (typeof montant === 'string')
        return parseFloat(montant.replace(',', '.')) || 0

    if (typeof montant === 'number')
        return montant

    return 0
}

const reponseConsentement = {
    oui: true,
    non: false
}
globalThis.typeCommunicationEnum = {
    papier: 'papier',
    electronique: 'electronique'
}
let typeMessageActionnairesEnum = {
    informatif: 'informatif',
    avertissement: 'avertissement'
}
﻿const actionnaireService = ($http, $q, authenticationService, rapReepService, documentsService, rachatsService) => {

    let informationActionnaire = null

    const fetchActionnaire = id =>
        $q.all([
            $http.get(`/api/actionnaires/${id}`),
            $http.get(`/api/actionnaires/${id}/portefeuille`),
            $http.get(`/api/actionnaires/${id}/transactionsEnTraitement`),
            documentsService.getDocuments(),
            rapReepService.getRap(),
            rapReepService.getReep(),
            rachatsService.adhesionEligibleRachatLibreService(),
            rachatsService.demandesRachatNonCompletees()
        ])
            .then(responses => {
                const actionnaireResponse = responses[0].data
                const portefeuilleResponse = responses[1].data
                const transactionsEnTraitementResponse = responses[2].data
                const documents = responses[3]
                const rap = responses[4]
                const reep = responses[5]
                const adhesionEligibleRachatLibreService = responses[6]
                const demandesRachatNonCompletees = responses[7]

                const sansAdhesion = actionnaireResponse.adhesions.length === 0

                return {
                    actionnaire: buildActionnaire(actionnaireResponse),
                    portefeuille: sansAdhesion ? undefined : buildPortefeuille(portefeuilleResponse),
                    sansAdhesion: sansAdhesion,
                    transactionsEnTraitement: transactionsEnTraitementResponse,
                    documents: documents,
                    rap: rap,
                    reep: reep,
                    adhesionEligibleRachatLibreService: adhesionEligibleRachatLibreService,
                    demandesRachatNonCompletees: demandesRachatNonCompletees
                }
            })

    function changerAdresseCourrielAVerifie(adresseCourriel, id) {
        if (authenticationService.isEmailVerified() && (adresseCourriel.courriel !== authenticationService.loggedEmail() || adresseCourriel.estVerifie !== true)) {
            $http.post('/api/actionnaires/' + id + '/adresseCourrielVerifiee')
        }
    }

    const getActionnaireFull = () => {
        if (informationActionnaire === null) {
            const id = authenticationService.loggedId()

            if (id) {
                informationActionnaire = fetchActionnaire(id).then(information => {
                    if (information.actionnaire.courriels?.length > 0)
                        changerAdresseCourrielAVerifie(information.actionnaire.courriels[0], id)
                    return information
                })
             }
        }

        return informationActionnaire ? $q.resolve(informationActionnaire) : $q.reject()
    }

    const clearCache = () => {
        informationActionnaire = null
    }

    const getCommunicationPreferences = () => {
        return getActionnaireFull().then(function (infoActionnaire) {
            return infoActionnaire.actionnaire.preferencesCommunication
        })
    }

    const saveCommunicationPreferences = (preferences) => {
        const id = authenticationService.loggedId()
        let payload = {
            "consentements": {
                "personnalisees": toConsentementApiValue(preferences.communicationsPersonnalisees),
                "promotionnelles": toConsentementApiValue(preferences.communicationsPromotionnelles),
                "offresPartenaires": toConsentementApiValue(preferences.communicationsOffresPartenaires)
            },
            "preferencesTransmissionsDocuments": {
                "relevesFiscaux": preferences.relevesFiscaux,
                "autresDocuments": preferences.autresDocuments
            }
        }

        return id
            ? $http.patch('/api/epargnants/' + id + '/preferencesCommunication', payload)
            : $q.reject()
    }

    const toConsentementApiValue = (value) => {
        if (value === 'yes') return true
        if (value === 'no') return false
        return null
    }

    authenticationService.onLogOut(clearCache)

    return {
        getActionnaireFull: getActionnaireFull,
        clearCache: clearCache,
        getCommunicationPreferences: getCommunicationPreferences,
        saveCommunicationPreferences: saveCommunicationPreferences,
        createNouveauDpu: function (userId, adhesionId, montantVersement, transit, institution, compte) {
            return $http.post('/api/actionnaires/' + userId + '/nouveauDpu', {
                adhesionId: adhesionId,
                montantVersement: montantVersement,
                transit: transit,
                institution: institution,
                compte: compte
            })
        },
        associer: function (actionnaire) {
            return $http.patch('/api/actionnaires/authentification/associer', actionnaire)
        },
        associerViaUtilisateur: function (id, motDePasse) {
            return $http.patch('/api/actionnaires/authentification/associerViaUtilisateur', {id: id, motDePasse: motDePasse})
        },
        envoyerVerificationAdresseCourriel: function () {
            return $http.post('/api/actionnaires/authentification/verificationAdresseCourriel')
        },
        changeAuthentificationMultiFacteur: function (id, activerMfa) {
            return $http.patch('/api/actionnaires/' + id + '/authentificationMultiFacteur', {activer: activerMfa})
        },
        changeAcceptationLegale: function (actionnaireId, acceptationLegale) {
            // Ce endpoint acceptera uniquement l'acceptation du consentement du portail actionnaire
            return $http.patch('/api/actionnaires/' + actionnaireId + '/caracteristiques', acceptationLegale)
        },
        getReleveTransaction: function (numeroAdhesion, dateDebut, dateFin) {
            const actionnaireId = authenticationService.loggedId()
            return actionnaireId
                ? $http.get('/api/actionnaires/' + actionnaireId + '/adhesions/' + numeroAdhesion + '/transactions?dateDebut=' + dateDebut + '&dateFin=' + dateFin)
                : $q.reject()
        },
        getDpas: function () {
            const actionnaireId = authenticationService.loggedId()
            return actionnaireId
                ? $http.get('/api/actionnaires/' + actionnaireId + '/dpas')
                : $q.reject()
        },
        arretDpa: function (dpaId) {
            const actionnaireId = authenticationService.loggedId()
            return actionnaireId
                ? $http.patch('/api/actionnaires/' + actionnaireId + '/dpas/' + dpaId)
                : $q.reject()
        },
        creerDpa: function (dpa) {
            const actionnaireId = authenticationService.loggedId()
            return actionnaireId
                ? $http.post('/api/actionnaires/' + actionnaireId + '/dpas', dpa)
                : $q.reject()
        }
    }
}

const buildActionnaire = actionnaire => {

    actionnaire.courriel = actionnaire.courriels ? actionnaire.courriels[0].courriel : undefined

    actionnaire.telephone = {
        principal: actionnaire.numerosDeTelephone.find(telephone => telephone.type === 'principal'),
        travail: actionnaire.numerosDeTelephone.find(telephone => telephone.type === 'travail'),
        cellulaire: actionnaire.numerosDeTelephone.find(telephone => telephone.type === 'cellulaire'),
        telecopieur: actionnaire.numerosDeTelephone.find(telephone => telephone.type === 'telecopieur')
    }
    return actionnaire
}

const buildPortefeuille = portefeuille => {
    portefeuille.adhesions.forEach(adhesion => {
        adhesion.totalCotisations = adhesion.cotisations.reduce((total, cotisation) => total + cotisation.montantNet, 0)
    })
    portefeuille.totalCotisations = portefeuille.adhesions.reduce((total, adhesion) => total + adhesion.totalCotisations, 0)

    combineRemboursementRapInDpu(portefeuille)

    return portefeuille
}

const combineRemboursementRapInDpu = portefeuille => {
    portefeuille.adhesions.forEach(adhesion => {
        adhesion.cotisations = adhesion.cotisations.reduce((cotisationsParType, cotisation) => {
            if (cotisation.typeCotisation === 'pageRap' || cotisation.typeCotisation === 'pageReep') {
                let dpu = adhesion.cotisations.find(c => c.typeCotisation === 'dpu')
                if (dpu === undefined) {
                    dpu = {typeCotisation: 'dpu', nombreActions: 0, montantNet: 0}
                    cotisationsParType.push(dpu)
                }
                dpu.nombreActions += cotisation.nombreActions
                dpu.montantNet += cotisation.montantNet
            } else {
                cotisationsParType.push(cotisation)
            }

            return cotisationsParType
        }, [])
    })
}

﻿let adressePosteCanadaFilter = function (address, html) {
    let assembleNonCanadianCountry, assembleRegion, assembleStreet, formatCodePostal, formatNumeroCivique, isCanada,
        lineSeparator, lines;
    if (html == null) {
        html = false;
    }
    assembleRegion = function (address) {
        return address.ville + ", " + address.province + "  " + (formatCodePostal(address.codePostal));
    };
    assembleStreet = function (address) {
        return (formatNumeroCivique(address)) + " " + address.rue;
    };
    assembleNonCanadianCountry = function (country) {
        if (!country || isCanada(country)) {
            return "";
        } else {
            return country;
        }
    };
    isCanada = function (country) {
        return ["Canada", "CA"].indexOf(country) !== -1;
    };
    formatNumeroCivique = function (address) {
        if (!address.appartement) {
            return address.numeroCivique;
        } else {
            return address.appartement + "-" + address.numeroCivique;
        }
    };
    formatCodePostal = function (codePostal) {
        if (!codePostal) {
            return "";
        } else {
            if (codePostal.length !== 6) {
                return codePostal;
            } else {
                return (codePostal.substring(0, 3)) + "&nbsp;" + (codePostal.substring(codePostal.length - 3));
            }
        }
    };
    lines = [];
    lineSeparator = html ? '<br/>' : '\n';
    lines.push(assembleStreet(address));
    lines.push(assembleRegion(address));
    if (!isCanada(address.pays) && address.pays) {
        lines.push(assembleNonCanadianCountry(address.pays));
    }
    return lines.join(lineSeparator);
};
﻿let dateFilter = function (dateValue, lang) {
    let date = dateValue instanceof Date ? dateValue : new Date(dateValue + 'T00:00:00')
    let local = lang === 'francais' ? 'fr-CA' : 'en-CA'
    let options = {year: 'numeric', month: 'long', day: 'numeric'}

    return date.toLocaleDateString(local, options).replace(/ /g, '\u00a0')
}

﻿const frequences = {
    'mensuelle': {'francais': 'Mensuelle', 'english': 'Monthly'},
    'toutesLesSemaines': {'francais': 'Toutes les semaines', 'english': 'Weekly'},
    'toutesLesDeuxSemaines': {'francais': 'Toutes les deux semaines', 'english': 'Every two weeks'},
}

const frequenceFilter = (frequence, lang) => frequences[frequence] ? frequences[frequence][lang] : '';

﻿const montantFilter = (number, lang) => {
    if (number === undefined || number === '') return ''
    if (typeof number === 'string')
        number = number.replace(/,/g, '.')

    const locale = lang === langueEnum.anglais ? 'en-CA' : 'fr-CA'
    return new Intl.NumberFormat(locale, {style: 'currency', currency: 'CAD'}).format(number)
}


﻿let regimeFilter = function (regime, lang) {
    if (lang === 'francais') {
        if (regime === 'enregistre') {
            return 'REER';
        }
        if (regime === 'reerConjoint') {
            return 'REER de conjoint';
        }
        if (regime === 'nonEnregistre') {
            return 'Non‑enregistré';
        }
        if (regime === 'autogere') {
            return 'Autogéré';
        }
        return 'Régime non spécifié';
    } else if (lang === 'english') {
        if (regime === 'enregistre') {
            return 'RRSP';
        }
        if (regime === 'reerConjoint') {
            return 'Spousal RRSP';
        }
        if (regime === 'nonEnregistre') {
            return 'Non-Registered';
        }
        if (regime === 'autogere') {
            return 'Self-directed RRSP';
        }
        return 'Unspecified';
    }
};
﻿let typesCotisation = {
    'employe': {'francais': 'Employé', 'english': 'Employee'},
    'employeur': {'francais': 'Employeur', 'english': 'Employer'},
    'forfaitaire': {'francais': 'Forfaitaire', 'english': 'Lump sum contribution'},
    'additionnel': {'francais': 'Additionnelle', 'english': 'Additional'},
    'dpa': {'francais': 'Versement périodique', 'english': 'Pre-authorized contributions'},
    'dpaCaisseDEconomie': {'francais': 'Versement périodique', 'english': 'Pre-authorized contributions'},
    'spc12': {
        'francais': 'Paiement sur le site de votre institution financière',
        'english': 'Online payment on your financial institution\'s website'
    },
    'dpu': {'francais': 'Versement unique', 'english': 'Lump sum contribution'},
    'pageRap': {'francais': 'Remboursement RAP', 'english': 'HBP reimbursement'},
    'pageReep': {'francais': 'Remboursement REEP', 'english': 'LLP repayment'},
}

let typeCotisationFilter = function (type, lang) {
    return typesCotisation[type] ? typesCotisation[type][lang] : ''
}

﻿const typesFichierMap = {
    [documentTypeEnum.releve10]: {[langueEnum.francais]: 'Relevé 10', [langueEnum.anglais]: 'RL-10 slip'},
    [documentTypeEnum.releveDePlacements]: {
        [langueEnum.francais]: 'Relevé de placements',
        [langueEnum.anglais]: 'Statement of investment'
    },
    [documentTypeEnum.releve10Special]: {[langueEnum.francais]: 'Relevé 10', [langueEnum.anglais]: 'RL-10 slip'},
    [documentTypeEnum.releveT4RSP]: {[langueEnum.francais]: 'Feuillet T4RSP', [langueEnum.anglais]: 'T4RSP slip'},
    [documentTypeEnum.releve2]: {[langueEnum.francais]: 'Relevé 2', [langueEnum.anglais]: 'RL-2 slip'},
    [documentTypeEnum.releveNR4]: {[langueEnum.francais]: 'Feuillet NR4', [langueEnum.anglais]: 'NR4 slip'},
    [documentTypeEnum.releveRapReep]: {
        [langueEnum.francais]: 'Correspondance RAP/REEP',
        [langueEnum.anglais]: 'HBP/LLP Correspondence'
    },
    [documentTypeEnum.confirmationAdhesion]: {
        [langueEnum.francais]: 'Confirmation d\'adhésion',
        [langueEnum.anglais]: 'Application confirmation'
    },
    [documentTypeEnum.releveT5008]: {[langueEnum.francais]: 'Feuillet T5008', [langueEnum.anglais]: 'T5008 slip'},
    [documentTypeEnum.releve18]: {[langueEnum.francais]: 'Relevé 18', [langueEnum.anglais]: 'RL-18 slip'},
    [documentTypeEnum.attestationActionsDetenues]: {
        [langueEnum.francais]: 'Attestation des actions détenues',
        [langueEnum.anglais]: 'Confirmation of shares held'
    },
    [documentTypeEnum.recapitulatifAdhesion]: {
        [langueEnum.francais]: 'Récapitulatif d\'adhésion',
        [langueEnum.anglais]: 'Application summary'
    }
}

const typeFichierFilter = (type, lang) => typesFichierMap[type] ? typesFichierMap[type][lang] : '';

class AngularAuth0Provider {
    config

    constructor() {
        this.config = null
    }

    init(config) {
        if (!config)
            throw new Error('clientId et domain sont requis pour initialiser auth0-spa-js')

        this.config = config
    }

    $get() {
        return new auth0.Auth0Client(this.config);
    }
}
function createApp(name) {
    const deps = ['ngStorage', 'ngRoute', 'ngSanitize', 'ui.bootstrap', 'ui.mask'];
    return angular.module(name, deps)
}

function configureServices(app) {
    app.factory('actionnaireService', actionnaireService)
}

function configureFilters(app) {
    app.filter('regime', () => regimeFilter)
    app.filter('typeCotisation', () => typeCotisationFilter) // portefeuille
    app.filter('typeFichier', () => typeFichierFilter) // portefeuille + documents
    app.filter('montantFilter', () => montantFilter)
    app.filter('frequence', () => frequenceFilter) // todo: conflit avec nouveau filtre??
    app.filter('dateLang', () => dateFilter)
    app.filter('adressePosteCanada', () => adressePosteCanadaFilter) // portefeuille + sidebar
    app.filter('typeDeductions', () => typeDeductionsFilter) // rss
    app.filter('cotisationRss', () => cotisationRssFilter) // rss
    app.filter('adhesion', () => adhesionFilter) // rss
    app.filter('raisonRss', () => raisonRssFilter) // rss
    app.filter('valeurAccumuleeParRss', () => valeurAccumuleeParRssFilter) // rss
}

function configureControllers(app) {
    app.controller('pafController', PafController)
    app.controller('portefeuilleController', portefeuilleController)
}

function configureErrorLogger(app) {
    app.config([
        '$provide',
        $provide => $provide.decorator('$exceptionHandler', exceptionHandlerLogger)
    ])
}

function configureUiMask(app) {
    app.config([
        'uiMask.ConfigProvider',
        uiMaskConfigProvider => uiMaskConfigProvider.clearOnBlur(false)
    ])
}

function configureAuth0(app) {
    app.provider('angularAuth0', AngularAuth0Provider);
    app.config(['angularAuth0Provider', provider =>
        provider.init(Auth0Config.clientOptions)
    ])
}

const app = createApp('paf');
configureServices(app)
configureFilters(app)
configureControllers(app)
configureErrorLogger(app)
configureUiMask(app)
configureAuth0(app)
globalThis.rachatModePaiementEnum = Object.freeze({
    depotBancaire: 'depotBancaire',
    transfert: 'transfert'
})
function marketingCategoryFromAge(age) {
        if (typeof (age) != 'number' || age < 18 || age > 71)
            return 'horsAudience';
        if (age <= 49)
            return 'adulte';
        if (age <= 64)
            return 'mature';
        return 'senior';
}

function marketingCategoryFromBirthDate(birthDate='1000-01-01') {
    if (typeof (birthDate) != 'string') return 'horsAudience';
    return marketingCategoryFromAge(DateUtils.ageToday(DateUtils.from(birthDate)));
}
angular.module('paf').run(normalizePromiseSideEffects);

// https://stackoverflow.com/a/58882217/7931803
normalizePromiseSideEffects.$inject = ['$rootScope'];
function normalizePromiseSideEffects($rootScope) {
    attachScopeApplicationToPromiseMethod('then');
    attachScopeApplicationToPromiseMethod('catch');
    attachScopeApplicationToPromiseMethod('finally');

    function attachScopeApplicationToPromiseMethod(methodName) {
        const NativePromiseAPI = Promise;
        const nativeImplementation = NativePromiseAPI.prototype[methodName];

        NativePromiseAPI.prototype[methodName] = function(...promiseArgs) {
            const newPromiseArgs = promiseArgs.map(wrapFunctionInScopeApplication);
            return nativeImplementation.bind(this)(...newPromiseArgs);
        };
    }

    function wrapFunctionInScopeApplication(fn) {
        if (!(typeof fn === "function") || fn.isScopeApplicationWrapped) {
            return fn;
        }

        const wrappedFn = (...args) => {
            const result = fn(...args);
            // this API is used since it's $q was using in AngularJS src
            $rootScope.$evalAsync();
            return result;
        };
        wrappedFn.isScopeApplicationWrapped = true;
        return wrappedFn;
    }
}
function makeComponent(component) {
    const app = angular.module('paf')
        .component(component.selector, component);

    // We launch a preload of all templates to avoid parent components loading before child components
    // Ideally, we should use 'template' instead of templateUrl whenever possible to avoid this problem
    if (component.templateUrl)
    {
        component.templateUrl += '?v=' + version // bust the cache for all component templates
        app.run([
            '$templateCache', '$http',
            ($templateCache, $http) => $http.get(component.templateUrl, {cache: $templateCache})
        ])
    }
}
// TODO: convert to function exports once we use webpack
class DateUtils {
    static now() {
        return Temporal.Now.instant()
    }

    static today() {
        return Temporal.Now.plainDateISO()
    }

    static ageToday(date) {
        let today = DateUtils.today()
        let age = today.year - date.year

        let birthdayThisYear = date.with({year: today.year})
        if (Temporal.PlainDate.compare(birthdayThisYear, today) > 0)
            age--

        return age
    }

    static ageThisYear(date) {
        return DateUtils.today().year - date.year
    }

    static atStartOfYear() {
        return DateUtils.today()
            .with({month: 1, day: 1})
    }

    static atEndOfYear() {
        return DateUtils.today()
            .with({month: 12, day: 31})
    }

    static atDateOrToday(date) {
        return date ?? DateUtils.today()
    }

    static from(date) {
        try {
            return Temporal.PlainDate.from(date)
        } catch {
            return null
        }
    }

    static isBetween(date, start, end) {
        return Temporal.PlainDate.compare(date, start) >= 0 && Temporal.PlainDate.compare(date, end) < 0
    }
}
﻿class AuthenticationInterceptor {
    #$q;
    #authenticationService;

    static dependency = 'authenticationInterceptor'
    static $inject = ['$q', 'authenticationService']

    constructor($q, authenticationService) {
        this.#$q = $q;

        this.#authenticationService = authenticationService;
    }

    responseError = (response) => {
        if (response.status === 401)
            this.#authenticationService.sessionTimedOut()

        return this.#$q.reject(response)
    }

    request = (config) => {
        if (this.#authenticationService.loggedRole() != null && ['POST', 'PUT', 'DELETE', 'PATCH'].includes(config.method)) {
            return this.#$q.reject('Opération non permise.');
        }

        const token = this.#authenticationService.loggedToken()
        if (token)
            config.headers['Authorization'] = `Bearer ${token}`

        config.headers['X-Version'] = version

        return config
    }
}

angular
    .module('paf')
    .service(AuthenticationInterceptor.dependency, AuthenticationInterceptor)
class AuthenticationService {
    #$location
    #$sessionStorage
    #angularAuth0
    #gtmService
    #sessionTimeout
    #logoutCallBacks
    #languageService
    #$injector
    #credentials

    static dependency = 'authenticationService'

    static unprotectedPaths = ['/actionnaires/connexion', '/actionnaires/droitsRecours', '/callback', '/visiteur/adhesion']
    static loginPath = '/actionnaires/connexion'
    static callbackPath = '/callback'
    static identificationPath = '/actionnaires/identification'
    static validationCourrielPath = '/actionnaires/verificationAdresseCourriel'
    static adhesionVisiteurPath = '/visiteur/nouvelleAdhesion'

    static $inject = ['$location', '$window', '$rootScope', 'angularAuth0', 'languageService', 'gtmService', '$injector']
    constructor($location, $window, $rootScope, angularAuth0, languageService, gtmService, $injector) {
        this.#$location = $location
        this.#$sessionStorage = $window.sessionStorage
        this.#angularAuth0 = angularAuth0
        this.#gtmService = gtmService
        this.#languageService = languageService
        this.#$injector = $injector

        this.#sessionTimeout = false
        this.#logoutCallBacks = []
        this.#credentials = undefined

        $rootScope.$on('$locationChangeSuccess', async () => await this.#locationChangeSuccess())
    }

    #storeCredentials(jwt) {
        this.#updateCredentialsCache(jwt);
        this.#$sessionStorage.setItem('credentials', jwt)
    }

    #getCredentials() {
        if (this.#credentials !== undefined)
            return this.#credentials

        const jwt = this.#$sessionStorage.getItem('credentials')
        this.#updateCredentialsCache(jwt)

        return this.#credentials
    }

    #updateCredentialsCache(jwt) {
        const claims = JwtDecoder.decode(jwt)

        if (!claims) {
            this.#credentials = null
        } else {
            this.#credentials = {
                token: jwt,
                id: claims?.epargnant_id,
                email: claims?.email,
                emailVerified: claims?.email_verified,
                mfaRequired: claims?.mfa_requis,
                associationAncienUtilisateurDesactivee: claims?.association_ancien_utilisateur_desactivee,
                exp: claims?.exp * 1000,
                role: claims?.role
            }
        }
    }

    #isProtectedPath() {
        const path = this.#$location.path()
        return !AuthenticationService.unprotectedPaths.includes(path)
    }

    async #locationChangeSuccess() {
        await this.checkPermissions()
    }

    async checkPermissions() {

        if (!this.#isProtectedPath())
             return

        if (!this.isLogged()) {
            if (this.#isVisiteur())
                await this.#promptSignUp()
            else
                await this.#promptCredentials()
            return
        }

        if (this.isSessionTimeout()) {
            await this.sessionTimedOut()
            return
        }

        if (!this.isEmailVerified()) {
            this.#promptValidateCourriel()
            return
        }

        if (!this.loggedId()) {
            this.#promptIdentification()
        }
    }

    async autoLogin(jwt) {
        await this.#logout()
        this.#storeCredentials(jwt)
    }

    async loginAvecCourriel(courriel, nextPage) {
        const courrielEncoded = encodeURIComponent(courriel)
        await this.#$injector.get('$http').get(`/api/actionnaires/authentification/utilisateur?courriel=${courrielEncoded}`)
            .then(() => this.#redirectToAuth0(courriel, nextPage, false))
            .catch(() => this.#redirectToAuth0(courriel, nextPage, true))
    }

    async signUp(nextPage) {
        await this.#redirectToAuth0(undefined, nextPage, true)
    }

    async handleAuthentication() {
        try {
            const result = await this.#angularAuth0.handleRedirectCallback()
            const id_token = await this.#angularAuth0.getIdTokenClaims()
            const isAuthenticated = await this.#angularAuth0.isAuthenticated()
            const nextPage = result.appState || '/'

            if (isAuthenticated) {
                this.#gtmService.event({event: 'login'})
                this.#storeCredentials(id_token.__raw)
                this.#$location.search('code', null)
                this.#$location.search('state', null)
                this.#$location.search('error', null)
                this.#$location.search('f', null)
                this.#$location.search('p', null)
                this.#$location.path(nextPage)
            } else {
                this.#storeCredentials(null)
            }
        } catch (error) {
            console.log(error)
        }
    }

    async refreshToken() {
        try {
            await this.#angularAuth0.getTokenSilently({cacheMode: 'off'})
            const id_token = await this.#angularAuth0.getIdTokenClaims()
            this.#storeCredentials(id_token.__raw)
        } catch (error) {
            await this.#logout()
        }
    }

    async #redirectToAuth0(courriel, nextPage, signUpOption) {
        await this.#angularAuth0.loginWithRedirect({
            appState: nextPage,
            authorizationParams: {
                redirect_uri: this.#buildRedirectTo(AuthenticationService.callbackPath),
                ui_locales: this.#languageService.lang === langueEnum.anglais ? 'en-CA' : 'fr-CA',
                screen_hint: signUpOption ? 'signup' : undefined,
                prompt: signUpOption ? undefined : 'login',
                login_hint: courriel
            }
        })
    }

    async #logout() {
        this.#callLogoutCallBacks()
        this.#deleteToken()

        try {
            const isAuthenticated = await this.#angularAuth0.isAuthenticated()
            if (isAuthenticated)
                await this.#angularAuth0.logout({ logoutParams: { returnTo: this.#buildRedirectTo(AuthenticationService.loginPath, {p: 'logout'}) }})
            else
                this.#$location.path(AuthenticationService.loginPath)
        } catch {
            this.#$location.path(AuthenticationService.loginPath)
        }
    }

    #buildRedirectTo(path, params = {}) {
        const url = new URL(this.#$location.absUrl())
        // Replace last segment of path - takes into account base href
        url.pathname = url.pathname.replace(this.lastValueRegex(this.#$location.path()), path)

        Object.entries(params)
            .forEach(([key, value]) => url.searchParams.set(key, value))

        return url.toString()
    }

    lastValueRegex(searchValue) {
        return new RegExp(RegExp.escape(searchValue) + "$")
    }

    #deleteToken() {
        if (!this.#getCredentials())
            return

        this.#storeCredentials(null)
    }

    #callLogoutCallBacks() {
        this.#logoutCallBacks.forEach(callback => callback())
    }

    async userLogOut() {
        await this.#logout()
    }

    async sessionTimedOut() {
        if (this.#sessionTimeout || !this.isLogged())
            return

        this.#sessionTimeout = true
        await this.#promptCredentials()
    }

    async #promptSignUp() {
        await this.#redirectToAuth0(undefined, this.#$location.path(), true)
    }

    async #promptCredentials() {
        this.#$location.search('f', this.#$location.path())
        await this.#logout()
    }

    #promptIdentification() {
        if (this.#$location.path() === AuthenticationService.identificationPath || this.#isVisiteur())
            return

        this.#$location.search('f', this.#$location.path())
        this.#$location.path(AuthenticationService.identificationPath)
    }

    #promptValidateCourriel() {
        if (this.#$location.path() === AuthenticationService.validationCourrielPath)
            return

        this.#$location.search('f', this.#$location.path())
        this.#$location.path(AuthenticationService.validationCourrielPath)
    }

    onLogOut(callback) {
        return this.#logoutCallBacks.push(callback)
    }

    #isVisiteur() {
        return this.#$location.path() === AuthenticationService.adhesionVisiteurPath
    }

    isSessionTimeout() {
        return this.#sessionTimeout || Date.now() > this.#getCredentials()?.exp
    }

    isLogged() {
        return !!this.#getCredentials()
    }

    loggedId() {
        return this.#getCredentials()?.id
    }

    loggedToken() {
        return this.#getCredentials()?.token
    }

    loggedEmail() {
        return this.#getCredentials()?.email
    }

    isEmailVerified() {
        return this.#getCredentials()?.emailVerified || false
    }

    isMfaRequired() {
        return this.#getCredentials()?.mfaRequired || false
    }

    isAssociationAncienUtilisateurDesactivee() {
        return this.#getCredentials()?.associationAncienUtilisateurDesactivee || false
    }

    loggedRole() {
        return this.#getCredentials()?.role
    }
}

angular
    .module('paf')
    .service(AuthenticationService.dependency, AuthenticationService)
class CoordonneesService {
    static dependency = "coordonneesService"

    static $inject = ['$http', 'authenticationService']
    constructor($http, authenticationService) {
        this.$http = $http
        this.authenticationService = authenticationService
    }

    // TODO: where does this belong?
    getActionnaire() {
        return this.$http.get(`/api/actionnaires/${this.#actionnaireId}`)
            .then(result => result.data)
    }

    changeCoordonnees(changement) {
        const actionnaireId = this.#actionnaireId
        return this.$http.post(`/api/actionnaires/${actionnaireId}/coordonnees`, changement)
    }

    get #actionnaireId() {
        return this.authenticationService.loggedId()
    }
}

angular
    .module("paf")
    .service(CoordonneesService.dependency, CoordonneesService)
class CreditsImpotService {
    static dependency = "creditsImpot"

    #$http;
    #authenticationService;

    static $inject = ['$http', 'authenticationService']

    constructor($http, authenticationService) {
        this.#$http = $http
        this.#authenticationService = authenticationService
    }

    getSommaire() {
        return ServiceHelper.handleResponse(this.#$http.get(`/api/actionnaires/${this.#actionnaireId}/sommaireCreditsImpot`, {cache: true}))
    }

    get #actionnaireId() {
        return this.#authenticationService.loggedId()
    }
}

angular
    .module("paf")
    .service(CreditsImpotService.dependency, CreditsImpotService)
﻿class DocumentsService {
    #http
    #q
    #authenticationService
    #documents

    static dependency = 'documentsService'
    static $inject = ['$http', '$q', 'authenticationService']

    constructor($http, $q, authenticationService) {
        this.#http = $http
        this.#q = $q
        this.#authenticationService = authenticationService
        this.#documents = null

        this.#authenticationService.onLogOut(() => this.#clearCache())
    }

    getDocuments() {
        return this.#documents === null ? this.#fetchDocuments() : this.#q.resolve(this.#documents)
    }

    #fetchDocuments() {
        const id = this.#authenticationService.loggedId()

        if (!id)
            return this.#q.reject('Non authentifié.')

        return this.#http.get(`/api/actionnaires/${id}/documents`)
            .then(response => {
                this.#documents = this.#buildDocuments(id, response.data)
                return this.#documents
            })
    }

    #buildDocuments(id, documents) {
        return documents.map(d => {
            d.url = `/api/actionnaires/${id}/documents/${d.id}`
            return d
        })
    }

    #clearCache() {
        this.#documents = null
    }
}

angular
    .module('paf')
    .service(DocumentsService.dependency, DocumentsService)
class EmployeursService {
    static dependency = "employeursService"

    static $inject = ['$http']

    constructor($http) {
        this.$http = $http
    }

    findByNumeroEmployeur(numeroEmployeur) {
        return ServiceHelper.handleResponse(this.$http.get(`/api/employeurs?numeroResponsableDeRemise=${numeroEmployeur}`))
    }

    findByNomEtAdresseEmployeur(nomEmployeur, numeroCivique, codePostal) {
        let url = `/api/employeurs?nom=${nomEmployeur}`
        if (numeroCivique)
            url += `&numeroCivique=${numeroCivique}`
        if (codePostal)
            url += `&codePostal=${codePostal}`

        return ServiceHelper.handleResponse(this.$http.get(url))
    }
}

angular
    .module("paf")
    .service(EmployeursService.dependency, EmployeursService)
﻿class FeatureSwitchService {
    static dependency = "featureSwitchService"
    featureSwitches = {}

    static $inject = ['$http', 'authenticationService']

    constructor($http, authenticationService) {
        this.$http = $http
        this.authenticationService = authenticationService
    }

    fetchFeatureSwitches() {
        return this.$http.get('/api/features/enabled')
            .then(res => {
                this.featureSwitches = {}
                for(let featureSwitch of res.data)
                    this.featureSwitches[featureSwitch] = true
            })
    }
}

angular
    .module("paf")
    .service(FeatureSwitchService.dependency, FeatureSwitchService)
class GtmService {

    static dependency = "gtmService"

    static $inject = ['languageService', '$location']
    constructor(languageService, $location) {
        this.languageService = languageService
        this.$location = $location
    }

    event(data) {
        this.#resetDataLayer()

        globalThis.dataLayer.push({
            custom_date: DateUtils.now().toString(),
            url: this.$location.url(),
            user_language: this.languageService.lang === langueEnum.francais ? 'fr' : 'en',
            ...data
        })
    }

    #resetDataLayer() {
        const gtmEventsToKeep = [
            'gtm.js',         // GTM initialization
            'gtm.dom',        // DOM ready
            'gtm.load',       // GTM fully loaded
            'didomi-consent', // GDPR consent state (must persist)
            'didomi-ready',   // Consent manager ready (must persist)
        ]

        const preservedEvents = globalThis.dataLayer.filter(
            ({ event }) => gtmEventsToKeep.includes(event)
        )

        globalThis.dataLayer.length = 0
        globalThis.dataLayer.push(function () {
            this.reset()
        })

        globalThis.dataLayer.push(...preservedEvents);
    }
}

angular
    .module("paf")
    .service(GtmService.dependency, GtmService)
class InstitutionFinanciereService {
    static dependency = "institutionFinanciereService"

    static $inject = ['$http', 'languageService']

    constructor($http, languageService) {
        this.$http = $http
        this.languageService = languageService
    }

    getInstitutionsFinancieres() {
        return this.$http.get('/api/institutionsFinancieres', {cache: true})
            .then(response => this.#mapInstitutionsFinancieres(response.data.institutionsFinancieres))
    }

    getSuccursale(numeroInstitution, numeroTransit) {
        return ServiceHelper.handleResponse(this.$http.get(`/api/succursalesBancaires/${numeroInstitution}/${numeroTransit}`)) // @todo add caching
            .then(data => {
                const nomInstitution = this.languageService.lang === langueEnum.anglais ? data.nomInstitutionAnglais : data.nomInstitutionFrancais
                return {nomInstitution, nomSuccursale: data.nomSuccursale}
            })
    }

    #mapInstitutionsFinancieres(institutions) {
        const nomField = this.languageService.lang === langueEnum.anglais ? 'NomAnglais' : 'Nom'
        return institutions?.map(institution => ({
            numero: institution.Numero,
            nom: institution[nomField],
            id: institution.Id,
        }))
    }
}

angular
    .module("paf")
    .service(InstitutionFinanciereService.dependency, InstitutionFinanciereService)
class JwtDecoder {
    static decode(token) {
        if (!token)
            return null

        try {
            const payload = token.split(".")[1]
            const decoded = JwtDecoder.#base64UrlDecode(payload)
            return JSON.parse(decoded);
        } catch (e) {
            return null
        }
    }

    static encode(claims) {
        if (!claims)
            return null

        try {
            const payload = btoa(JSON.stringify(claims))
                .replace(/=/g, '')
                .replace(/\+/g, '-')
                .replace(/\//g, '_')

            return `header.${payload}.signature`
        } catch (e) {
            return null
        }
    }

    static #base64UrlDecode(base64UrlString) {
        const base64 = base64UrlString
            .replace(/-/g, '+')
            .replace(/_/g, '/')
            .padEnd(Math.ceil(base64UrlString.length / 4) * 4, '=') // Ajoute des '=' pour s'assurer que la longueur est un multiple de 4

        return atob(base64)
    }
}
class LanguageService {
    static dependency = "languageService"
    $location

    static $inject = ['$location']
    constructor($location) {
        this.$location = $location
    }

    get lang() {
        return /english/.test(this.$location.absUrl()) ? langueEnum.anglais : langueEnum.francais
    }
}

angular
    .module("paf")
    .service(LanguageService.dependency, LanguageService)
class LimiteVersementService {
    static dependency = "limiteVersementService"

    static $inject = ['$http', 'authenticationService']

    constructor($http, authenticationService) {
        this.$http = $http
        this.authenticationService = authenticationService
    }

    isLimiteVersementEnabled() {
        return this.$http.get(`/api/features/limiteVersements`)
            .then(result => result.data)
    }

    getLimiteVersements() {
        const actionnaireId = this.#actionnaireId

        if (actionnaireId) {
            return this.$http.get(`/api/actionnaires/${actionnaireId}/dpas/limites`)
                .then(result => result.data)
        } else {
            return Promise.resolve({
                mensuelle: Math.round((5000 / 12) * 100) / 100,
                toutesLesDeuxSemaines: Math.round((5000 / 26) * 100) / 100,
                toutesLesSemaines: Math.round((5000 / 52) * 100) / 100
            })
        }
    }

    get #actionnaireId() {
        return this.authenticationService.loggedId()
    }
}

angular
    .module("paf")
    .service(LimiteVersementService.dependency, LimiteVersementService)
class NouvelleAdhesionService {
    static dependency = "nouvelleAdhesionService"

    static $inject = ['$http', 'authenticationService']

    constructor($http, authenticationService) {
        this.$http = $http
        this.authenticationService = authenticationService
    }

    createNew(formulaire) {
        return ServiceHelper.handleResponse(this.$http.post('/api/adhesions', formulaire))
    }

    createExisting(formulaire) {
        const actionnaireId = this.authenticationService.loggedId()
        return ServiceHelper.handleResponse(this.$http.post(`/api/actionnaires/${actionnaireId}/adhesions`, formulaire))
    }

    list() {
        const actionnaireId = this.authenticationService.loggedId()
        if (!actionnaireId)
            return Promise.resolve([])

        return ServiceHelper.handleResponse(this.$http.get(`/api/actionnaires/${actionnaireId}/adhesions`))
    }
}

angular
    .module("paf")
    .service(NouvelleAdhesionService.dependency, NouvelleAdhesionService)
class RachatsService {
    static dependency = "rachatsService"

    static $inject = ['$http', 'authenticationService']

    constructor($http, authenticationService) {
        this.$http = $http
        this.authenticationService = authenticationService
    }

    getEligibilite() {
        const actionnaireId = this.#actionnaireId
        if (!actionnaireId)
            return

        return ServiceHelper.handleResponse(this.$http.get(`/api/actionnaires/${actionnaireId}/rachats/eligibilite`, {cache: true}))
    }

    adhesionEligibleRachatLibreService() {
        return this.getEligibilite()
            .then(e => {
                const motifs = this.#allMotifsOf(e)
                return motifs.length === 0 ? null : motifs[0].adhesions[0];
            })
            .catch(() => {
                console.error('Erreur lors du chargement des rachats admissibles')
                return null
            })
    }

    #allMotifsOf(e) {
        return Object.values(e.motifsEligibles || {});
    }

    createDemandeRachat(adhesionId, demande, fichiers = [], progressCallback) {
        const formData = new FormData()

        formData.append('demande', JSON.stringify(demande))
        fichiers.forEach(f => formData.append('files', f))

        return ServiceHelper.handleResponse(this.$http.post(
            `/api/actionnaires/${this.#actionnaireId}/adhesions/${adhesionId}/demandesRachat`,
            formData,
            {
                headers: {'Content-Type': undefined},
                transformRequest: angular.identity,
                uploadEventHandlers: {progress: progressCallback}
            }
        ))
    }

    demandesRachatNonCompletees() {
        return ServiceHelper.handleResponse(this.$http.get(`/api/actionnaires/${this.#actionnaireId}/demandesRachat/nonCompletees`))
    }

    getDemandeRachat(demandeRachatId) {
        return ServiceHelper.handleResponse(this.$http.get(`/api/actionnaires/${this.#actionnaireId}/demandesRachat/${demandeRachatId}`))
    }

    getFournisseursServicesFinanciers() {
        return ServiceHelper.handleResponse(this.$http.get(`/api/fournisseursServicesFinanciers`, {cache: true}))
    }

    get #actionnaireId() {
        return this.authenticationService.loggedId()
    }
}

angular
    .module("paf")
    .service(RachatsService.dependency, RachatsService)
class RapReepService {
    static dependency = "rapReepService"

    static $inject = ['$http', 'authenticationService']
    constructor($http, authenticationService) {
        this.$http = $http
        this.authenticationService = authenticationService
    }

    getRap() {
        return ServiceHelper.handleResponse(this.$http.get(`/api/actionnaires/${this.#actionnaireId}/rap`))
    }

    getReep() {
        return ServiceHelper.handleResponse(this.$http.get(`/api/actionnaires/${this.#actionnaireId}/reep`))
    }

    creerRemboursementRap(demandeRemboursement) {
        return this.$http.post(`/api/actionnaires/${this.#actionnaireId}/rap/remboursements`, demandeRemboursement)
    }

    creerRemboursementReep(demandeRemboursement) {
        return this.$http.post(`/api/actionnaires/${this.#actionnaireId}/reep/remboursements`, demandeRemboursement)
    }

    get #actionnaireId() {
        return this.authenticationService.loggedId()
    }
}

angular
    .module("paf")
    .service(RapReepService.dependency, RapReepService)
class RssService {
    #http
    #cache
    #authenticationService

    static dependency = 'rssService'
    static $inject = ['$http', '$cacheFactory', 'authenticationService']

    constructor($http, $cacheFactory, authenticationService) {
        this.#http = $http
        this.#authenticationService = authenticationService
        this.#cache = $cacheFactory.get('$http')

        this.#authenticationService.onLogOut(() => this.clearCache())
    }

    getRss() {
        return this.#http.get(`${this.#routeActionnaire()}/rss`, {cache: true})
            .then(response => response.data)
    }

    creerRss(rss) {
        this.clearCache()
        return this.#http.post(`${this.#routeActionnaire()}/rss`, rss)
    }

    arreterRss(raisonId) {
        this.clearCache()
        return this.#http.patch(`${this.#routeActionnaire()}/rss`, {raison: raisonId})
    }

    getVersementsRss() {
        return this.#http.get(`${this.#routeActionnaire()}/versementsRss`, {cache: true})
            .then(response => response.data)
    }
    clearCache() {
        this.#cache.remove(`${this.#routeActionnaire()}/rss`)
        this.#cache.remove(`${this.#routeActionnaire()}/versementsRss`)
    }

    #routeActionnaire() {
        return `/api/actionnaires/${this.#authenticationService.loggedId()}`
    }
}

angular
    .module('paf')
    .service(RssService.dependency, RssService)

class ServiceHelper {
    static handleResponse(response) {
        return response
            .then(result => result.data)
            .catch(result => ServiceHelper.#unpackAndThrow(result))
    }

    static #unpackAndThrow(result) {
        throw new HttpError(result.status, result.data?.ResponseStatus?.Message ?? result.data?.Message)
    }
}

class HttpError extends Error {
    constructor(status, message) {
        super(message)
        this.name = "HttpError"
        this.status = status
    }
}
class VersionService {
    static dependency = "versionService"

    static $inject = ['$http']
    constructor($http) {
        this.$http = $http
    }

    getCurrentDeployedVersion() {
        return this.$http.get(`/version.json`)
            .then(result => result.data.version)
    }

    hasDeployedVersionChanged() {
        return this.getCurrentDeployedVersion()
            .then(version => globalThis.version !== version);
    }
}

angular
    .module("paf")
    .service(VersionService.dependency, VersionService)
class WarningService {
    #$http

    static dependency = 'warningService'
    static $inject = ['$http']

    constructor($http) {
        this.#$http = $http
    }

    getWarning() {
        return this.#$http.get('/api/admin/messagesActionnaires')
            .then(response => response.data[0])
    }
}

angular
    .module('paf')
    .service(WarningService.dependency, WarningService)
dateFilterFactory.$inject = [LanguageService.dependency]

function dateFilterFactory(languageService) {
    return (dateValue) => {
        if (!dateValue)
            return ''

        const locale = languageService.lang === langueEnum.anglais ? 'en-CA' : 'fr-CA'
        const date = dateValue instanceof Date ? dateValue : new Date(dateValue + 'T00:00:00')
        const options = {year: 'numeric', month: 'long', day: 'numeric'}
        return date.toLocaleDateString(locale, options).replace(/ /g, '\u00a0')
    }
}

function jourFilterFactory(languageService) {
    return (dateValue) => {
        if (!dateValue)
            return ''

        const locale = languageService.lang === langueEnum.anglais ? 'en-CA' : 'fr-CA'
        const options = {day: 'numeric', month: 'long'}
        const plainDate = dateValue instanceof Date ? dateValue : Temporal.PlainDate.from(dateValue)
        return new Intl.DateTimeFormat(locale, options).format(plainDate).replace(/ /g, '\u00a0')
    }
}

angular
    .module('paf')
    .filter('date', dateFilterFactory)
    .filter('jour', jourFilterFactory)
formatFilterFactory.$inject = ['$interpolate']
function formatFilterFactory($interpolate) {
    function changePlaceholders(message) {
        return message.replaceAll('{', '{{').replaceAll('}', '}}')
    }

    return (message, params) => {
        return $interpolate(changePlaceholders(message))(params)
    }
}

angular
    .module('paf')
    .filter('format', formatFilterFactory)

frequenceVersementPeriodiqueFilterFactory.$inject = [LanguageService.dependency]

function frequenceVersementPeriodiqueFilterFactory(languageService) {
    const frequence = {
        'mensuelle': {
            'francais': 'Mensuelle',
            'english': 'Monthly'
        },
        'toutesLesSemaines': {
            'francais': 'Toutes les semaines',
            'english': 'Weekly'
        },
        'toutesLesDeuxSemaines': {
            'francais': 'Toutes les deux semaines',
            'english': 'Every two weeks'
        }
    }

    return (choix) => {
        return !frequence[choix] ? '' : frequence[choix][languageService.lang]
    }
}

angular
    .module('paf')
    .filter('frequence', frequenceVersementPeriodiqueFilterFactory)
genreFilterFactory.$inject = [LanguageService.dependency]

function genreFilterFactory(languageService) {
    const genres = {
        'F': {
            'francais': 'une femme',
            'english': 'Female'
        },
        'H': {
            'francais': 'un homme',
            'english': 'Male'
        },
        'B': {
            'francais': 'une personne non binaire',
            'english': 'Non-binary'
        }
    }

    return (choix) => {
        return !genres[choix] ? '' : genres[choix][languageService.lang]
    }
}

angular
    .module('paf')
    .filter('genre', genreFilterFactory)
montantFilterFactory.$inject = [LanguageService.dependency]

function montantFilterFactory(languageService) {
    return (number) => {
        if (!number && number !== 0)
            return ''

        const locale = languageService.lang === langueEnum.anglais ? 'en-CA' : 'fr-CA'
        return new Intl.NumberFormat(locale, {style: 'currency', currency: 'CAD'}).format(number)
    }
}

angular
    .module('paf')
    .filter('montant', montantFilterFactory)

pourcentageFilterFactory.$inject = [LanguageService.dependency]

function pourcentageFilterFactory(languageService) {
    return (number) => {
        if (!number && number !== 0)
            return ''

        const locale = languageService.lang === langueEnum.anglais ? 'en-CA' : 'fr-CA'
        return new Intl.NumberFormat(locale, {style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(number / 100.0)
    }
}

angular
    .module('paf')
    .filter('pourcentage', pourcentageFilterFactory)

﻿const AcceptationLegaleComponent = {
    selector: 'acceptationLegale',
    templateUrl: 'app/components/acceptation-legale.html',
    bindings: {rechargerPortefeuille: '&'},
    controller: class {
        enCours
        enErreur
        acceptationLegale
        rechargerPortefeuille
        #$location
        #authenticationService
        #actionnaireService

        static $inject = ['$location', 'authenticationService', 'actionnaireService']

        constructor($location, authenticationService, actionnaireService) {
            this.#$location = $location
            this.#authenticationService = authenticationService
            this.#actionnaireService = actionnaireService

            this.acceptationLegale = false
            this.enCours = false
            this.enErreur = false
        }

        consent() {
            this.enCours = true
            this.enErreur = false
            const acceptationLegale = {
                caracteristiques: [
                    {
                        type: 'consentementUtilisationDuPortailActionnaire',
                        valeur: 'oui'
                    }
                ]
            }

            const epargnantId = this.#authenticationService.loggedId()

            this.#actionnaireService.changeAcceptationLegale(epargnantId, acceptationLegale)
                .then(() => this.rechargerPortefeuille())
                .then(() => this.#redirigeALaProchainePage())
                .catch(() => this.#afficheMessageErreur())
        }

        async #redirigeALaProchainePage() {
            this.enCours = false
            const nextPage = this.#$location.search().f || '/'
            this.#$location.search('f', null)
            this.#$location.path(nextPage)
        }

        #afficheMessageErreur() {
            this.enCours = false
            this.enErreur = true
        }
    }
}

makeComponent(AcceptationLegaleComponent)

const AuthenticationComponent = {
    selector: 'authentication',
    templateUrl: 'app/components/authentication/authentication.html',
    controller: class {
        #$window
        #$location
        #authenticationService

        static $inject = ['$window', '$location', AuthenticationService.dependency]

        constructor($window, $location, authenticationService) {
            this.#$window = $window
            this.#$location = $location
            this.#authenticationService = authenticationService
        }

        async $onInit() {
            if (this.#$location.search().error != null) {
                this.#$location.search('error_description', null)
                this.#$location.search('state', null)
                this.#$location.path(AuthenticationService.loginPath)
            } else if (this.#$location.search().code && this.#$location.search().state) {
                await this.#authenticationService.handleAuthentication()
            }
        }
    }
}

makeComponent(AuthenticationComponent)
﻿const ConnexionComponent = {
    selector: 'connexion',
    templateUrl: 'app/components/authentication/connexion.html',
    controller: class {
        courriel
        showWaiting
        showFailure
        warningFondaction
        typeMessageFondaction
        #$location
        #authenticationService
        #warningService
        #languageService

        static $inject = ['$location', AuthenticationService.dependency, WarningService.dependency, LanguageService.dependency]

        constructor($location, authenticationService, warningService, languageService) {
            this.#$location = $location
            this.#authenticationService = authenticationService
            this.#warningService = warningService
            this.#languageService = languageService
        }

        $postLink() {
            this.#auChargement()
        }

        connect() {
            this.showFailure = false
            this.showWaiting = true
            this.#authenticationService.loginAvecCourriel(this.courriel, this.#nextPage())
                .finally(() => {
                    this.showWaiting = false
                })
        }

        #nextPage() {
            return this.#$location.search().f || '/'
        }

        get isSessionTimedOut() {
            return this.#authenticationService.isSessionTimeout()
        }

        get isUserLoggedOut() {
            return this.#$location.search().p === 'logout'
        }

        #auChargement() {
            this.#reset();

            this.#warningService.getWarning()
                .then(warning => {
                    if (warning === undefined)
                        return;
                    this.#assignWarningFondaction(warning);
                })

            const token = this.#$location.search().apiToken
            if (token) {
                this.showWaiting = true
                this.#authenticationService.autoLogin(token)
                    .then(() => {
                        this.#$location.search('apiToken', null)
                        this.#$location.path('/')
                    })
                    .catch(() => this.#showErrorMessage())
            }

            if (this.#$location.search().error === 'unauthorized') {
                this.showUnauthorizedFailure = true
            } else if (this.#$location.search().error != null) {
                this.showFailure = true
            }

            if (this.#authenticationService.isLogged()) {
                this.#$location.path('/')
            }
        }

        #reset() {
            this.showWaiting = false
            this.showFailure = false
            this.showUnauthorizedFailure = false
        }

        #assignWarningFondaction(warning) {
            this.warningFondaction = this.#languageService.lang === langueEnum.anglais
                ? warning['messageAnglais']
                : warning['messageFrancais']
            this.typeMessageFondaction = warning['type'] === typeMessageActionnairesEnum.informatif
                ? 'alert-info'
                : 'alert-warning'
        }

        #showErrorMessage() {
            this.showWaiting = false
            this.showFailure = true
        }
    }
}

makeComponent(ConnexionComponent)
const IdentificationEpargnantComponent = {
    selector: 'identificationEpargnant',
    templateUrl: 'app/components/authentication/identification-epargnant.html',
    bindings: {rechargerPortefeuille: '&'},
    controller: class {
        choix
        actionnaire = {}
        rechargerPortefeuille
        #actionnaireService
        #authenticationService
        #$location
        #$window
        showFailure
        showFillAllFormError
        showWaiting

        static $inject = ['actionnaireService', 'authenticationService', '$location', '$window']

        constructor(actionnaireService, authenticationService, $location, $window) {
            this.#actionnaireService = actionnaireService
            this.#authenticationService = authenticationService
            this.#$location = $location
            this.#$window = $window

            this.showFailure = false
            this.showFillAllFormError = false
            this.showWaiting = false
        }

        get afficheChoix() {
            return !this.#associationAncienUtilisateurDesactivee
        }

        get afficheIdentificationForm() {
            return this.#associationAncienUtilisateurDesactivee === true || this.choix === 'infoPersonnelles'
        }

        get afficheUtilisateurForm() {
            return this.#associationAncienUtilisateurDesactivee === false && this.choix === 'identifiantFon'
        }

        get #associationAncienUtilisateurDesactivee() {
            return this.#authenticationService.isAssociationAncienUtilisateurDesactivee()
        }

        async submit() {
            this.showFailure = false
            this.showFillAllFormError = false

            if (!this.#isFormComplete()) {
                this.showFillAllFormError = true
            } else {
                try {
                    this.showWaiting = true
                    await this.#actionnaireService.associer(this.actionnaire)
                    await this.#authenticationService.refreshToken()
                    await this.rechargerPortefeuille()

                    const nextPage = this.#$location.search().f || '/'
                    this.#$location.search('f', null)
                    this.#$location.path(nextPage)
                } catch (error) {
                    this.showFailure = true
                    this.#$window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
                } finally {
                    this.showWaiting = false
                }
            }
        }

        #isFormComplete() {
            const isValidField = (value) => value !== undefined && value !== ''

            const requiredFields = [
                this.actionnaire.dateNaissance,
                this.actionnaire.nasTerminantPar,
                this.actionnaire.codePostal
            ];

            return requiredFields.every(isValidField)
        }
    }
}

makeComponent(IdentificationEpargnantComponent)
const IdentificationUtilisateurComponent = {
    selector: 'identificationUtilisateur',
    templateUrl: 'app/components/authentication/identification-utilisateur.html',
    bindings: {
        rechargerPortefeuille: '&',
        showFillAllFormError: '=',
        showFailure: '='
    },
    controller: class {
        utilisateur = {}
        rechargerPortefeuille
        #actionnaireService
        #authenticationService
        #$location
        showFailure
        showFillAllFormError

        static $inject = ['actionnaireService', 'authenticationService', '$location']

        constructor(actionnaireService, authenticationService, $location) {
            this.#actionnaireService = actionnaireService
            this.#authenticationService = authenticationService
            this.#$location = $location

            this.showWaiting = false
        }

        async submit() {
            this.showFailure = false
            this.showFillAllFormError = false

            if (!this.#isFormComplete()) {
                this.showFillAllFormError = true
                return
            }

            try {
                this.showWaiting = true
                await this.#actionnaireService.associerViaUtilisateur(`FON${this.utilisateur.nip}`, this.utilisateur.password)
                await this.#authenticationService.refreshToken()
                await this.rechargerPortefeuille()

                const nextPage = this.#$location.search().f || '/'
                this.#$location.search('f', null)
                this.#$location.path(nextPage)
            } catch (error) {
                this.showFailure = true
            } finally {
                this.showWaiting = false
            }
        }

        #isFormComplete() {
            const isValidField = (value) => value !== undefined && value !== ''

            const requiredFields = [
                this.utilisateur.nip,
                this.utilisateur.password
            ];

            return requiredFields.every(isValidField)
        }
    }
}

makeComponent(IdentificationUtilisateurComponent)
const VerificationAdresseCourrielComponent = {
    selector: 'verificationAdresseCourriel',
    templateUrl: 'app/components/authentication/verification-adresse-courriel.html',

    controller: class {
        verificationEnCours
        continueEnCours
        #actionnaireService
        #authenticationService
        #$location

        static $inject = ['actionnaireService', 'authenticationService', '$location']

        constructor(actionnaireService, authenticationService, $location) {
            this.#actionnaireService = actionnaireService
            this.#authenticationService = authenticationService
            this.#$location = $location

            this.verificationEnCours = false
            this.continueEnCours = false
        }

        get email() {
            return this.#authenticationService.loggedEmail()
        }

        async envoyerVerificationAdresseCourriel() {
            this.verificationEnCours = true;

            try {
                await this.#actionnaireService.envoyerVerificationAdresseCourriel();
            } catch (e) {
            } finally {
                this.verificationEnCours = false;
            }
        }

        async continue() {
            this.continueEnCours = true
            try {
                await this.#authenticationService.refreshToken()

                const nextPage = this.#$location.search().f || '/'
                this.#$location.search('f', null)
                this.#$location.path(nextPage)
            } catch (e) {
            } finally {
                this.continueEnCours = false
            }
        }
    }
}

makeComponent(VerificationAdresseCourrielComponent)
function buildChangementsCoordonnees(original, change, dateEntreeEnVigueur) {
    return {
        dateEntreeEnVigueur,
        courriel: buildChangement(original.courriel, change.courriel),
        adresse: buildChangementAdresse(original.adresse, change.adresse),
        telephones: buildChangementTelephones(original.telephones, change.telephones)
    }
}

function buildChangement(original, change) {
    if (deepEquals(original, change)) return null
    return change
}

function buildChangementAdresse(original, change) {
    if (deepEquals(original, change)) return null
    return {
        ... change,
        province: "QC",
        pays: "Canada"
    }
}

function buildChangementTelephones(original, change) {
    if (deepEquals(original, change)) return null
    return {
        principal: buildChangement(original.principal, change.principal),
        secondaire: buildChangement(original.secondaire, change.secondaire)
    }
}

function replaceNullWithEmpty(object) {
    for (let prop in object)
        object[prop] = replaceNullValueWithEmpty(object[prop])

    return object

    function replaceNullValueWithEmpty(value) {
        if (isPrimitive(value))
            return value || ""
        else
            return replaceNullWithEmpty(value)
    }
}


const ChangementCoordonneesComponent = {
    selector: 'changementCoordonnees',
    // language=file-reference
    templateUrl: 'app/components/changement-coordonnees/changement-coordonnees.html',
    bindings: {rechargerPortefeuille: '&'},
    controller: class {
        #confirmationCourriel
        #coordonneesService
        #authenticationService
        province = "QC"
        pays = "Canada"
        dateEntreeEnVigueur
        rechargerPortefeuille

        static $inject = [CoordonneesService.dependency, AuthenticationService.dependency]

        constructor(coordonneesService, authenticationService) {
            this.#coordonneesService = coordonneesService
            this.#authenticationService = authenticationService

            this.#coordonneesService.getActionnaire()
                .then(this.#mapCoordonnees, ( ) => this.#onLoadError())
                .then(coordonnees => {
                    this.original = angular.copy(coordonnees)
                    this.coordonnees = coordonnees
                })
        }

        get confirmationCourriel() {
            return !this.courrielEstIdentique ? this.#confirmationCourriel : ''
        }

        set confirmationCourriel(value) {
            this.#confirmationCourriel = value
        }

        filterAdresseQuebec(adresse) {
            return adresse.province === "QC"
        }

        get courrielEstIdentique() {
            return this.original?.courriel === this.coordonnees?.courriel
        }

        get courrielEstConfirme() {
            return this.courrielEstIdentique || this.coordonnees.courriel === this.confirmationCourriel
        }

        get changed() {
            return !deepEquals(this.original, this.coordonnees) && this.courrielEstConfirme
        }

        async save() {
            this.#resetFlags()
            this.#startLoading()

            try {
                await this.#coordonneesService.changeCoordonnees(this.#changements)
                this.#onSaveSuccess()
            } catch {
                this.#onSaveError()
            } finally {
                this.#stopLoading()
            }
        }

        #resetFlags() {
            this.showSaveSuccess = false
            this.showSaveError = false
            this.showLoadError = false
        }

        #startLoading() {
            this.submitting = true
        }

        #onSaveSuccess() {
            const courrielChanged = !this.courrielEstIdentique
            if (courrielChanged)
            {
                this.showSaveSuccess = true
                this.#authenticationService.refreshToken()
            }
            else
            {
                this.rechargerPortefeuille()
                this.original = angular.copy(this.coordonnees)
                this.showSaveSuccess = true
            }
        }

        #onSaveError() {
            this.showSaveError = true
        }

        #onLoadError() {
            this.showLoadError = true
        }

        #stopLoading() {
            this.submitting = false
        }

        #mapCoordonnees(actionnaire) {
            return replaceNullWithEmpty({
                adresse: {
                    appartement: actionnaire.adresse.appartement,
                    codePostal: actionnaire.adresse.codePostal,
                    numeroCivique: actionnaire.adresse.numeroCivique,
                    pays: actionnaire.adresse.pays,
                    province: actionnaire.adresse.province,
                    rue: actionnaire.adresse.rue,
                    ville: actionnaire.adresse.ville,
                },
                telephones: actionnaire.telephones,
                courriel: actionnaire.courriels?.[0].courriel
            })
        }

        get #changements() {
            return buildChangementsCoordonnees(this.original, this.coordonnees, this.dateEntreeEnVigueur)
        }
    }
}

makeComponent(ChangementCoordonneesComponent)
const OTHER_INSTITUTION_VALUE = 'other'

const CompteBancaireComponent = {
    selector: 'compteBancaire',
    templateUrl: 'app/components/compte-bancaire.html',
    bindings: {
        compte: '='
    },
    controller: class {
        compte

        internalInstitutionChoice

        institutionChoices
        nomSuccursale
        #institutionFinanciereService
        #languageService

        static $inject = [InstitutionFinanciereService.dependency, LanguageService.dependency]

        constructor(institutionFinanciereService, languageService) {
            this.#institutionFinanciereService = institutionFinanciereService
            this.#languageService = languageService
        }

        $onInit() {
            this.#fillInstitutionOptions()
        }

        set institutionChoice(value) {
            this.internalInstitutionChoice = value

            if (value === OTHER_INSTITUTION_VALUE)
                this.institution = undefined
            else
                this.institution = value
        }

        get institutionChoice() {
            if (this.#institutionIsAChoice(this.compte.institution) || this.#noInstitutionSelectedYet(this.compte.institution))
                this.internalInstitutionChoice = this.compte.institution
            else
                this.internalInstitutionChoice = OTHER_INSTITUTION_VALUE

            return this.internalInstitutionChoice
        }

        #noInstitutionSelectedYet(institution) {
            return institution === undefined && this.internalInstitutionChoice === undefined
        }

        #institutionIsAChoice(institution) {
            return this.institutionChoices?.find(c => c.value === institution)
        }

        get isAutreInstitution() {
            return this.institutionChoice === OTHER_INSTITUTION_VALUE
        }

        set institution(value) {
            this.compte.institution = value
            this.#validateCompte()
        }

        get institution() {
            return this.compte.institution
        }

        set transit(value) {
            this.compte.transit = value
            this.#validateCompte()
        }

        get transit() {
            return this.compte.transit
        }

        #fillInstitutionOptions() {
            this.#institutionFinanciereService.getInstitutionsFinancieres()
                .then(result => {
                    this.institutionChoices = this.#mapInstitutionChoices(result)
                    this.institutionChoices.push({value: OTHER_INSTITUTION_VALUE, label: this.#otherInstitutionLabel()})
                })
        }

        #otherInstitutionLabel() {
            return this.#languageService.lang === langueEnum.anglais ? 'Other institution' : 'Autre institution';
        }

        #mapInstitutionChoices(result) {
            return result.map(institution => ({
                value: institution.numero,
                label: `(${institution.numero}) - ${institution.nom}`
            }))
                .sort(this.#byField(institution => institution.value))
        }

        #byField(field) {
            return (a, b) => field(a).localeCompare(field(b))
        }

        async #validateCompte() {
            this.compte.valid = undefined
            this.compte.reference = undefined

            if (!this.compte.transit || !this.compte.institution)
                return

            try {
                const result = await this.#institutionFinanciereService.getSuccursale(this.compte.institution, this.compte.transit)
                this.compte.valid = true
                this.compte.reference = this.#buildReference(result)
            } catch (e) {
                this.compte.valid = false
            }
        }

        // @todo remove this when the component is not used in a non-form context anymore
        noFormValidate() {
            return {
                institution: this.compte.institution === undefined,
                transit: this.compte.transit === undefined,
                numeroCompte: this.compte.numero === undefined,
                transitDansInstitution: this.compte.valid !== true
            }
        }

        #buildReference(result) {
            return result.nomSuccursale ? `${result.nomInstitution} &ndash; ${result.nomSuccursale}` : result.nomInstitution;
        }
    }
}

makeComponent(CompteBancaireComponent)
const DiagrammeAnneauComponent = {
    selector: 'diagrammeAnneau',
    templateUrl: 'app/components/credits-impot/diagramme-anneau.html',
    bindings: {
        segments: '<',
        couleurNonAffectee: '@'
    },
    controller: class {
        #canvas
        segments
        couleurNonAffectee

        static $inject = ['$element']

        constructor($element) {
            this.#canvas = $element[0].querySelector('canvas[data-beigne]')
        }

        $onChanges(changes) {
            if (changes.segments && changes.segments.currentValue !== changes.segments.previousValue) {
                this.#afficherDiagramme()
            }
        }

        #afficherDiagramme() {
            const segments = [...this.segments ?? []]
            const ctx = this.#canvas.getContext('2d')
            const dimension = this.#calculerDimension()

            const angleReference = 3 * Math.PI / 2
            const ratiosCumulatifs = segments.reduce((ratiosCumulatifs, segment) => ratiosCumulatifs + segment.ratio, 0)
            const ratioNonAffecte = 1 - ratiosCumulatifs
            segments.push({ratio: ratioNonAffecte, couleur: this.couleurNonAffectee})

            ctx.clearRect(0, 0, this.#canvas.width, this.#canvas.height)
            this.#dessinerSegments(ctx, dimension, angleReference, segments)
            this.#dessinerEmbouts(ctx, dimension, angleReference, segments)
            this.#dessinerTexte(ctx, dimension, ratiosCumulatifs)
        }

        #dessinerSegments(ctx, dimension, angleDebut, segments) {
            segments.reduce((curseur, segment) => {
                const angle = segment.ratio * 2 * Math.PI
                const angleFin = curseur + angle
                this.#dessinerSegment(ctx, dimension, curseur, angleFin, segment.couleur)

                return angleFin
            }, angleDebut)
        }

        #dessinerSegment(ctx, dimension, angleDebut, angleFin, couleur) {
            const segment = new Path2D()
            segment.arc(dimension.centreX, dimension.centreY, dimension.outerRadius, angleDebut, angleFin)
            segment.arc(dimension.centreX, dimension.centreY, dimension.innerRadius, angleFin, angleDebut, true)
            segment.closePath()

            ctx.fillStyle = couleur
            ctx.fill(segment)
        }

        #dessinerEmbouts(ctx, dimension, angleDebut, segments) {
            const segmentsAvecEmbout = segments.filter(segment => segment.ratio > 0)

            segmentsAvecEmbout.reduce((curseur, segment, index) => {
                const angle = segment.ratio * 2 * Math.PI
                const angleFin = curseur + angle

                if (index < segmentsAvecEmbout.length - 1)
                    this.#dessinerEmbout(ctx, dimension, curseur, angleFin, segment.couleur)

                return angleFin
            }, angleDebut)
        }

        #dessinerEmbout(ctx, dimension, angleDebut, angleFin, couleur) {
            const capRadius = (dimension.outerRadius - dimension.innerRadius) / 2
            const capDistance = (dimension.outerRadius + dimension.innerRadius) / 2
            const x = dimension.centreX + capDistance * Math.cos(angleFin)
            const y = dimension.centreY + capDistance * Math.sin(angleFin)

            const cap = new Path2D()
            cap.arc(x, y, capRadius, 0, Math.PI * 2)
            cap.closePath()

            ctx.fillStyle = couleur
            ctx.fill(cap)
        }

        #dessinerTexte(ctx, dimension, ratio) {
            const pourcentage = `${Math.round(ratio * 100)} %`
            ctx.textAlign = 'center'
            ctx.textBaseline = 'middle'

            ctx.fillStyle = '#111'
            ctx.font = `700 ${Math.round(dimension.size * 0.20)}px Arial`
            ctx.fillText(pourcentage, dimension.centreX, dimension.centreY)
        }

        #calculerDimension() {
            const size = Math.min(this.#canvas.width, this.#canvas.height)
            const outerRadius = size * 0.42
            const innerRadius = outerRadius * 0.78

            return {
                size,
                centreX: this.#canvas.width / 2,
                centreY: this.#canvas.height / 2,
                outerRadius,
                innerRadius,
            }
        }

    }
}

makeComponent(DiagrammeAnneauComponent)
const ObjectifCreditsImpotComponent = {
    selector: 'objectifCreditsImpot',
    templateUrl: 'app/components/credits-impot/objectif-credits-impot.html',
    bindings: {
        avecProgramme: '<',
        dateDeNaissance: '<',
    },
    controller: class {
        #creditsImpotService

        dateDeNaissance
        avecProgramme

        #strategie
        #creditsImpotMontant
        #creditsImpotMontantRestant
        #creditsImpotMontantMax
        #dateDebutPeriode = ""
        #dateFinPeriode = ""
        #dateDebutPeriodePrecedente = ""
        #dateFinPeriodePrecedente = ""
        #creditsImpotMontantPrecedent
        #creditObtenuPrecedent
        #anneePrecedente = ""
        #anneeLimite= ""
        #anneeSuivante= ""
        #segments = []

        #showDetailsAnneePrecedente = false
        #eligibleDeductionReer = true

        static $inject = [CreditsImpotService.dependency]

        constructor(creditsImpotService) {
            this.#creditsImpotService = creditsImpotService
        }

        async $onInit() {
            const sommaire = await this.#creditsImpotService.getSommaire()
            this.#strategie = sommaire.strategie
            this.#creditsImpotMontant = sommaire.montant
            this.#creditsImpotMontantMax = sommaire.montantMaximum
            this.#creditsImpotMontantRestant = sommaire.montantMaximum - sommaire.montant
            this.#dateDebutPeriode = sommaire.dateDebutPeriode
            this.#dateFinPeriode = sommaire.dateFinPeriode
            this.#dateDebutPeriodePrecedente = sommaire.dateDebutPeriodePrecedente
            this.#dateFinPeriodePrecedente = sommaire.dateFinPeriodePrecedente
            this.#creditsImpotMontantPrecedent = sommaire.montantAnneePrecedente
            this.#creditObtenuPrecedent = sommaire.montantAnneePrecedente * 30 / 100
            this.#anneePrecedente = DateUtils.from(sommaire.dateFinPeriode).year - 2
            this.#anneeLimite = DateUtils.from(sommaire.dateFinPeriode).year - 1
            this.#anneeSuivante = DateUtils.from(sommaire.dateFinPeriode).year
            this.#eligibleDeductionReer = sommaire.eligibleDeductionReer

            const ratio = this.#creditsImpotMontant / this.#creditsImpotMontantMax
            this.#segments = [
                {ratio: ratio > 1 ? 1 : ratio, couleur: '#4caf50'}
            ]
        }

        get segments() {
            return this.#segments
        }

        get couleurNonAffectee() {
            return '#dff5f4'
        }

        get show() {
            return (
                this.#strategie === "versementUnique" &&
                !this.avecProgramme &&
                this.#ageEstAdmissible
            )
        }

        get #ageEstAdmissible() {
            const age = DateUtils.ageToday(DateUtils.from(this.dateDeNaissance))
            return age < 65
        }

        get montantVerse() {
            return this.#creditsImpotMontant
        }

        get montantRestant() {
            return this.#creditsImpotMontantRestant
        }

        get montantMax() {
            return this.#creditsImpotMontantMax
        }

        get dateDebut() {
            return this.#dateDebutPeriode
        }

        get dateLimite() {
            return this.#dateFinPeriode
        }

        get anneeLimite() {
            return this.#anneeLimite
        }

        get anneeSuivante() {
            return this.#anneeSuivante
        }

        get dateDebutPrecedente() {
            return this.#dateDebutPeriodePrecedente
        }

        get dateLimitePrecedente() {
            return this.#dateFinPeriodePrecedente
        }

        get anneePrecedente() {
            return this.#anneePrecedente
        }

        get montantVersePrecedent() {
            return this.#creditsImpotMontantPrecedent
        }

        get creditObtenuPrecedent() {
            return this.#creditObtenuPrecedent
        }

        get creditRestant() {
            return this.montantRestant > 0
        }

        get limiteAtteinte60PremiersJours() {
            return !this.creditRestant && DateUtils.today().year === this.#anneeSuivante
        }

        get limiteAtteinteEnCoursDAnnee(){
            return !this.creditRestant && DateUtils.today().year === this.#anneeLimite
        }

        toggleDetailsAnneePrecedente() {
            this.#showDetailsAnneePrecedente = !this.#showDetailsAnneePrecedente
        }

        get showDetailsAnneePrecedente() {
            return this.#showDetailsAnneePrecedente
        }

        get estEligibleDeductionReer() {
            return this.#eligibleDeductionReer
        }
    }
}

makeComponent(ObjectifCreditsImpotComponent)
const DocumentLienComponent = {
    selector: 'documentLien',
    bindings: {
        document: '<',
        titre: '@?',
        class: '@?'
    },
    transclude: true,
    template: `
        <a class="{{$ctrl.class}}"
            data-ng-href="{{$ctrl.document.url}}"
            data-ng-click="$ctrl.onClick($event);"
            title="{{$ctrl.titre}}"
            target="_blank"
            data-ng-transclude>
        </a>`,

    controller: class {
        #$http
        #gtmService
        document

        static $inject = ['$http', GtmService.dependency]

        constructor($http, gtmService) {
            this.#$http = $http
            this.#gtmService = gtmService
        }

        #extraireFilename(contentDisposition) {
            return contentDisposition.split(';')
                .map(part => part.trim())
                .find(part => part.startsWith('filename='))
                .substring(9).replaceAll('"', '')
        }

        #telecharger() {
            this.#$http.get(this.document.url, {
                responseType: 'blob',
            }).then(response => {
                const blob = new Blob([response.data])

                const link = window.document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = this.#extraireFilename(response.headers('Content-Disposition'))
                link.click()

                window.URL.revokeObjectURL(link.href)
                link.remove()
            }).catch(() => {
                // Ignore
            })
        }

        onClick(event) {
            event.preventDefault()

            this.#gtmService.event({event: 'generate_lead', step: 'Téléchargement de documents archivés'})

            this.#telecharger()
        }
    }
}

makeComponent(DocumentLienComponent)
﻿const DocumentsComponent = {
    selector: 'documents',
    templateUrl: 'app/components/document/documents.html',
    controller: class {
        documentsParAnnee
        afficherAnnee
        annees
        documents
        #languageService

        static $inject = [DocumentsService.dependency, LanguageService.dependency]

        constructor(documentsService, languageService) {
            this.#languageService = languageService

            this.documentsParAnnee = {}
            this.afficherAnnee = {}
            this.annees = []
            this.documents = null

            documentsService.getDocuments().then(docs => {
                this.documents = docs
                this.#grouperDocuments()
            })
        }

        getLang() {
            return this.#languageService.lang
        }

        #grouperDocuments() {
            if (!this.documents?.length) return

            const yearOf = doc => doc.date.slice(0, 4)

            this.documents.forEach(doc => {
                const year = yearOf(doc)
                this.documentsParAnnee[year] ??= []
                this.documentsParAnnee[year].push(doc)
                this.afficherAnnee[year] ??= false
            })

            this.annees = Object.keys(this.documentsParAnnee).sort()

            if (this.annees.length > 0)
                this.afficherAnnee[this.annees.at(-1)] = true
        }
    }
}

makeComponent(DocumentsComponent)
let DpaArretComponent = {
    selector: 'dpaArret',
    templateUrl: 'app/components/dpa/dpaArret.html',
    bindings: {
        resolve: '<',
        close: '&'
    },
    controller: class DpaArretController {
        error = false
        submitted = false
        today = new Date()

        static $inject = ['$window', 'actionnaireService', 'gtmService', 'languageService']
        constructor($window, actionnaireService, gtmService, languageService) {
            this.$window = $window
            this.actionnaireService = actionnaireService
            this.gtmService = gtmService
            this.languageService = languageService
        }

        $onInit() {
            this.dpa = this.resolve.dpa
        }

        getLang() {
            return this.languageService.lang
        }

        arreterDpa() {
            this.submitted = true
            this.actionnaireService.arretDpa(this.dpa.id)
                .then(() => {
                    this.gtmService.event({
                        event: 'stop_contribution',
                        step: 'Arrêter ce versement périodique',
                        contribution_plan: 'périodique'
                    })
                    this.close()
                    this.$window.location.reload()
                })
                .catch(() => this.error = true)
                .finally(() => this.submitted = false)
        }
    }
}

makeComponent(DpaArretComponent)

﻿let DpaCreationComponent = {
    selector: 'dpaCreation',
    templateUrl: 'app/components/dpa/dpaCreation.html',
    bindings: {
        resolve: '<',
        close: '&'
    },
    controller: class DpaCreationController {
        error = false
        resolve

        static $inject = ['$location', 'actionnaireService', 'gtmService', 'languageService']
        constructor($location, actionnaireService, gtmService, languageService) {
            this.$location = $location
            this.actionnaireService = actionnaireService
            this.gtmService = gtmService
            this.languageService = languageService
        }

        $onInit() {
            this.dpa = this.resolve.dpa
        }

        // exposes getLang for filters in the
        getLang() {
            return this.languageService.lang
        }

        creerDpa() {
            this.submitted = true

            let apiDpa = {
                adhesionId: this.dpa.numeroAdhesion,
                montant: montantToDecimal(this.dpa.montant),
                frequence: this.dpa.frequence,
                datePremierPrelevement: this.dpa.datePremierPrelevement,
                institution: this.dpa.compte.institution,
                transit: this.dpa.compte.transit,
                compte: this.dpa.compte.numero
            }

            this.actionnaireService.creerDpa(apiDpa)
                .then(() => {
                    this.fermerModal()
                    this.gtmService.event({
                        event: 'purchase',
                        step: 'Confirmation de versement périodique',
                        contribution_plan: 'périodique',
                        amount: montantToDecimal(this.dpa.montant),
                        frequency: this.dpa.frequence
                    })
                    this.#redirectToDpasPage()
                })
                .catch(error => this.error = true)
                .finally(() => this.submitted = false)
        }

        fermerModal() {
            this.close()
        }

        #redirectToDpasPage = function () {
            return this.$location.path('/actionnaires/dpas')
        }
    }
}

makeComponent(DpaCreationComponent)
﻿let DpaFormulaireComponent = {
    selector: 'dpaFormulaire',
    templateUrl: 'app/components/dpa/dpaFormulaire.html',
    bindings: {
        portefeuille: '=',
        isLimiteVersementsActive: '&',
        limiteVersementsMessage: '&'
    },
    controller: class DpaFormulaireController {
        dpa = {erreurs: {}, compte: {}}
        portefeuille
        modalInstance

        static $inject = ['$uibModal', 'languageService']
        constructor($uibModal, languageService) {
            this.$uibModal = $uibModal
            this.languageService = languageService
        }

        $onDestroy() {
            // dismiss when navigating away and modal still open (session timeout)
            // remove when passing to auth0 (if leaving the spa!)
            this.modalInstance?.dismiss()
        }

        // exposes getLang for filters in the template
        getLang() {
            return this.languageService.lang
        }

        adhesionsPourVersementPeriodique() {
            return this.portefeuille.adhesions.filter(adhesion => adhesion.regime !== 'autogere')
        }

        validerNouveauDpa() {
            this.#validerAdhesion(this.dpa.numeroAdhesion)

            let isInvalid = this.formulaireDpa.validerNouveauDpa()

            if (!isInvalid) {
                this.#confirmerDpa()
            }
        }

        #validerAdhesion(numeroAdhesion) {
            this.dpa.erreurs.adhesion = numeroAdhesion === undefined
        }

        #confirmerDpa() {
            this.modalInstance = this.$uibModal.open({
                component: DpaCreationComponent.selector,
                windowClass: 'confirmation-modal',
                resolve: {
                    dpa: () => this.dpa
                }
            })
        }
    }
}

makeComponent(DpaFormulaireComponent)
let DpaFormulairePartialComponent = {
    selector: 'dpaFormulairePartial',
    templateUrl: 'app/components/dpa/dpaFormulairePartial.html',
    bindings: {
        dpa: '=',
        isLimiteVersementsActive: '&',
        limiteVersementsMessage: '&'
    },
    controller: class DpaFormulairePartialController {
        limiteVersementsParFrequence
        confirmationTitulaireCompte
        compteBancaireComponent

        dpa
        isLimiteVersementsActive

        static $inject = [LimiteVersementService.dependency, LanguageService.dependency]

        constructor(limiteVersementService, languageService) {
            this.limiteVersementService = limiteVersementService
            this.languageService = languageService
        }

        $postLink() {
            this.limiteVersementService.getLimiteVersements().then(limite => {
                this.limiteVersementsParFrequence = {
                    'mensuelle': limite.mensuelle,
                    'toutesLesDeuxSemaines': limite.toutesLesDeuxSemaines,
                    'toutesLesSemaines': limite.toutesLesSemaines
                }
            })
        }

        // exposes getLang for filters in the
        getLang() {
            return this.languageService.lang
        }

        get imageCheque() {
            return this.languageService.lang === langueEnum.anglais ? '/img/cheque-EN.jpg' : '/img/cheque-FR.jpg'
        }

        formatMontant() {
            let match = this.dpa.montant.match(/^\d+[\\.|,]?\d{0,2}/)
            this.dpa.montant = match === null ? undefined : match[0]
        }

        onPrelevementChange() {
            let nombrePrelevementSelonFrequence = {
                'mensuelle': 12,
                'toutesLesDeuxSemaines': 26,
                'toutesLesSemaines': 52
            }

            let nombrePrelevementParAnnee = nombrePrelevementSelonFrequence[this.dpa.frequence] || 1
            let montant = (this.dpa.montant || '').replace(',', '.')

            this.projectionAnnuelle = montantFilter(montant * nombrePrelevementParAnnee, this.languageService.lang)
            this.limiteVersements = this.limiteVersementsParFrequence[this.dpa.frequence]
        }

        validerNouveauDpa() {
            this.#validerMontant(this.dpa.montant)
            this.#validerFrequence(this.dpa.frequence)
            this.validerDatePremierPrelevement(this.dpa.datePremierPrelevement, new Date())
            this.#validerCompteBancaire()
            this.#validerConfirmation(this.confirmationTitulaireCompte)

            return this.formulaireEnErreur()
        }

        #validerCompteBancaire() {
            const compteBancaireErreurs = this.compteBancaireComponent.noFormValidate()
            this.dpa.erreurs = {...this.dpa.erreurs, ...compteBancaireErreurs}
        }

        #validerMontant(montant) {
            this.dpa.erreurs.montant = montant === undefined
            this.dpa.erreurs.montantMin = montant !== undefined && this.#montantToDecimal(montant) < 10
            this.dpa.erreurs.montantMax = montant !== undefined && this.#montantToDecimal(montant) >= 100000
        }

        #montantToDecimal(montant) {
            return typeof montant === 'string' ? parseFloat(montant.replace(',', '.')) : montant
        }

        #validerFrequence(frequence) {
            this.dpa.erreurs.frequence = frequence === null || frequence === undefined
        }

        validerDatePremierPrelevement(date, dateMin) {
            let isDateInvalid = date === null || isNaN(new Date(date).getTime())
            this.dpa.erreurs.datePremierPrelevement = isDateInvalid

            let dateDeDebut = this.#withoutHours(new Date(date + 'T00:00:00'))
            let dateMinimum = this.#withoutHours(dateMin)
            let dateMaximum = this.#withoutHours(this.#dateIn6Months())

            this.dpa.erreurs.datePremierPrelevementMin = !isDateInvalid && dateDeDebut <= dateMinimum
            this.dpa.erreurs.datePremierPrelevementMax = !isDateInvalid && dateDeDebut > dateMaximum
        }

        #dateIn6Months() {
            let date = new Date()
            date.setMonth(date.getMonth() + 6)
            return date
        }

        #withoutHours(date) {
            date.setHours(0, 0, 0, 0)
            return date
        }

        #validerConfirmation(confirmation) {
            this.dpa.erreurs.confirmationTitulaireCompte = (confirmation === undefined || confirmation === false)
        }

        formulaireEnErreur() {
            return this.dpa.erreurs.adhesion
                || this.dpa.erreurs.montant || this.dpa.erreurs.montantMin || this.dpa.erreurs.montantMax || this.dpa.erreurs.montantLimite
                || this.dpa.erreurs.frequence
                || this.dpa.erreurs.datePremierPrelevement || this.dpa.erreurs.datePremierPrelevementMin || this.dpa.erreurs.datePremierPrelevementMax
                || this.dpa.erreurs.institution || this.dpa.erreurs.transit || this.dpa.erreurs.transitDansInstitution
                || this.dpa.erreurs.numeroCompte || this.dpa.erreurs.confirmationTitulaireCompte
        }
    }
}

makeComponent(DpaFormulairePartialComponent)
let DpasComponent = {
    selector: 'dpas',
    // language=file-reference
    templateUrl: 'app/components/dpa/dpas.html',
    bindings: {
        loadingPortefeuille: '<',
        portefeuille: '<',
        sansAdhesion : '<',
        isLimiteVersementsActive: '&',
        limiteVersementsMessage: '&'
    },
    controller: class DpasController {
        error = false

        static $inject = ['$uibModal', 'actionnaireService', 'languageService']
        constructor($uibModal, actionnaireService, languageService) {
            this.$uibModal = $uibModal
            this.actionnaireService = actionnaireService
            this.languageService = languageService
        }

        $onInit() {
            this.actionnaireService.getDpas()
                .then(response => this.dpas = response.data)
                .catch(function (error) {})
        }

        // exposes getLang for filters in the
        getLang() {
            return this.languageService.lang
        }

        arreter(dpa) {
            this.$uibModal.open({
                component: DpaArretComponent.selector,
                windowClass: 'confirmation-modal',
                resolve: {
                    dpa: () => dpa
                }
            })
        }

        regimeOfAdhesion(numeroAdhesion) {
            return this.portefeuille.adhesions
                .find(adhesion => adhesion.numeroAdhesion === numeroAdhesion)
                ?.regime
        }

        dpaFormulaireUrl() {
            if (this.getLang() === langueEnum.anglais)
                return 'https://www.fondaction.com/document/4835/form_application_contribution'

            return 'https://www.fondaction.com/document/4834/formulaire-demande-versement'
        }
    }
}

makeComponent(DpasComponent)
const DpuAnnulerTransactionComponent = {
    selector: 'dpuAnnulerTransaction',
    templateUrl: 'app/components/dpu/dpu-annuler-transaction.html',
}

makeComponent(DpuAnnulerTransactionComponent)

﻿let DpuCreationComponent = {
    selector: 'dpuCreation',
    // language=file-reference
    templateUrl: 'app/components/dpu/dpu-creation.html',
    bindings: {
        loadingPortefeuille: '<',
        portefeuille: '<',
        sansAdhesion: '<',
        isLimiteVersementsActive: '&',
        limiteVersementsMessage: '&',
        rechargerPortefeuille: '&'
    },

    controller: class DpuCreationController {
        dpu
        montantMinimum
        connectionError
        numeroAdhesion
        transit
        montantVersementUnique
        institution
        compte
        rechargerPortefeuille
        nouveauDpu

        static $inject = ['$location', 'actionnaireService', 'authenticationService', 'gtmService', 'languageService'];

        constructor($location, actionnaireService, authenticationService, gtmService, languageService) {
            this.$location = $location
            this.actionnaireService = actionnaireService
            this.authenticationService = authenticationService
            this.gtmService = gtmService
            this.languageService = languageService

            this.dpu = this.dpu || {compte: {}}
        }

        $onInit() {
            this.#setupInitialValues()
        }

        // exposes getLang for filters
        getLang() {
            return this.languageService.lang
        }

        validateMoneyInput(input, value) {
            if (!input) return

            input.$setValidity("formatInvalid", !value || this.isMoneyPattern(value))

            if (this.#valueGreaterThenMaxCredit(value)) {
                input.WarningOver5000 = true
                input.$setValidity("maximumInvalid", true)
                if (this.#valueGreaterThenMaxCotisable(value)) {
                    input.$setValidity("maximumInvalid", false)
                }
            } else {
                input.$setValidity("maximumInvalid", true)
                input.WarningOver5000 = false
            }
        }

        isMoneyPattern(amount) {
            const moneyPattern = /^(?:[0-9]{1,5}(?:[.,][0-9]{0,2})?|0(?:[.,][0-9]{0,2})?)$/
            return moneyPattern.test(amount.toString())
        }

        dpuSupported(regime) {
            return !(regime === 'reerConjoint' || regime === 'autogere')
        }

        submit(form) {
            this.attemptedSubmit = true

            this.validateMoneyInput(form.montantVersementUnique, this.montantVersementUnique)

            if (form.$invalid) {
                return
            }

            if (this.confirmation) {
                this.showWaiting = true
                return this.createNouveauDpu()
            } else {
                this.confirmation = true
            }
        }

        createNouveauDpu() {
            const loggedId = this.authenticationService.loggedId()
            this.actionnaireService.createNouveauDpu(
                loggedId,
                this.dpu.numeroAdhesion,
                this.dpu.montantVersementUnique,
                this.dpu.compte.transit,
                this.dpu.compte.institution,
                this.dpu.compte.numero
            ).then(response => {
                this.nouveauDpu = response.data
                this.showWaiting = false

                this.rechargerPortefeuille()

                this.gtmService.event({
                    event: 'purchase',
                    step: 'Confirmation de versement unique',
                    contribution_plan: 'unique',
                    amount: this.dpu.montantVersementUnique,
                    frequency: 'unique'
                })
            }).catch(this.#handleCreateNouveauDpuError.bind(this))
        }

        previous() {
            return this.confirmation = false
        }

        cancel() {
            const text = this.getLang() === langueEnum.anglais
                ? 'Are you sure you want to cancel? \nAll your data will be erased.'
                : 'Désirez-vous vraiment annuler? \nToutes vos données seront effacées.'

            if (confirm(text)) {
                this.dpu = {}
                return this.$location.path(`/actionnaires/creationDpu/annuler`)
            }
        }

        #setupInitialValues() {
            this.montantMinimum = 10
            this.dpu.datePrelevement = DateUtils.today().toString()
        }

        #valueGreaterThenMaxCredit(value) {
            return value > 5000
        }

        #valueGreaterThenMaxCotisable(value) {
            return value > 99999.99
        }

        #handleCreateNouveauDpuError(response) {
            const data = response.data
            this.showWaiting = false
            this.connectionError = true

            if (response.status === 403 && data.type === "nouveauDpu.deactivated") {
                this.serverError = this.getLang() === langueEnum.anglais
                    ? 'Lump-sum contributions are now ceased.'
                    : 'Les cotisations par montant forfaitaire sont maintenant suspendues.'
            } else {
                this.serverError = response.data?.ResponseStatus?.Message
            }
        }
    }
}

makeComponent(DpuCreationComponent)
const DpuFormulairePaiementUniqueComponent = {
    selector: 'dpuFormulairePaiementUnique',
    templateUrl: 'app/components/dpu/dpu-formulaire-paiement-unique.html',
    bindings: {
        montantMinimum: '<',
        form: '=',
        dpu: '=',
        attemptedSubmit: '<',
        onUpdate: '&'
    },
    controller: class DpuFormulairePaiementUniqueController {

        static $inject = ['languageService'];

        constructor(languageService) {
            this.languageService = languageService
        }

        getLang() {
            return this.languageService.lang
        }
    }
}

makeComponent(DpuFormulairePaiementUniqueComponent)
const DpuTermineComponent = {
    selector: 'dpuTermine',
    templateUrl: 'app/components/dpu/dpu-termine.html',
    bindings: {
        dpu: '<',
        portefeuille: '<'
    },
    controller: class DpuTermineController{
        #authenticationService

        static $inject = ['languageService', 'authenticationService']
        constructor(languageService, authenticationService) {
            this.languageService = languageService
            this.#authenticationService = authenticationService
        }

        $onInit() {
            this.loggedEmail = this.#authenticationService.loggedEmail()
        }

        // note: pas sur pourquoi on veut effacer la valeur du binding - surtout unidirectionnel (<)
        $onDestroy() {
            this.dpu = undefined
            this.portefeuille = undefined
        }

        getLang() {
            return this.languageService.lang
        }
    }
}

makeComponent(DpuTermineComponent)

const EditAddressComponent = {
    selector: 'editAddress',
    // language=file-reference
    templateUrl: 'app/components/edit-address.html',
    bindings: {
        adresse: "=",
        filter: "<",
        searchPlaceholder: "@?",
        label: "@?",
        errorMessage: "<?",
        required: "<?"
    },
    controller: class {
    }
}

makeComponent(EditAddressComponent)
﻿const FooterComponent = {
    selector: 'footer',
    templateUrl: 'app/components/footer.html',
    controller: class {
        copyright = `© ${new Date().getFullYear()} Fondaction`
    }
}

makeComponent(FooterComponent)
let GererCommunicationsComponent = {
    selector: 'gererCommunications',
    templateUrl: 'app/components/gerer-communications.html',
    bindings: {rechargerPortefeuille: '&'},
    controller:
        class GererCommunicationsController {
            communicationPreferences = {}
            conditionAccepted = false
            rechargerPortefeuille

            static $inject = [GtmService.dependency, 'actionnaireService']

            constructor(gtmService, actionnaireService) {
                this.gtmService = gtmService
                this.actionnaireService = actionnaireService

                this.init()
            }

            #resetFlags() {
                this.showSaveSuccess = false
                this.showSaveError = false
                this.showLoadError = false
                this.showFillAllFormError = false
            }

            #fromApi(data) {
                let pref = {...data}
                pref.communicationsPersonnalisees = this.#toHtmlValue(pref.communicationsPersonnalisees)
                pref.communicationsPromotionnelles = this.#toHtmlValue(pref.communicationsPromotionnelles)
                pref.communicationsOffresPartenaires = this.#toHtmlValue(pref.communicationsOffresPartenaires)
                return pref
            }

            #toHtmlValue(preference) {
                if (preference === true)
                    return "yes"
                if (preference === false)
                    return "no"
                return null
            }

            #onLoadSuccess(data) {
                this.communicationPreferences = this.#fromApi(data)
            }

            #onLoadError() {
                this.showLoadError = true
            }

            #onSaveSuccess() {
                this.showSaveSuccess = true
                this.gtmService.event({
                    event: 'generate_lead',
                    step: 'Gérer mes communications',
                    ... this.communicationPreferences
                })
                this.rechargerPortefeuille()
            }

            #onSaveError() {
                this.showSaveError = true
            }

            #startLoading() {
                this.showWaiting = true
            }

            #stopLoading() {
                this.showWaiting = false
            }

            save() {
                this.#resetFlags()

                if (!this.isFormValid()) {
                    this.showFillAllFormError = true
                    return
                }

                this.#startLoading()

                this.actionnaireService
                    .saveCommunicationPreferences(this.communicationPreferences)
                    .then(() => this.#onSaveSuccess(), () => this.#onSaveError())
                    .finally(() => this.#stopLoading())
            }

            isFormValid() {
                return this.communicationPreferences.communicationsPersonnalisees != null &&
                    this.communicationPreferences.communicationsPromotionnelles != null &&
                    this.communicationPreferences.communicationsOffresPartenaires != null &&
                    this.communicationPreferences.autresDocuments != null &&
                    this.communicationPreferences.relevesFiscaux != null &&
                    this.conditionAccepted === true
            }

            init() {
                this.actionnaireService.getCommunicationPreferences()
                    .then(data => this.#onLoadSuccess(data), () => this.#onLoadError())
            }
        },
}

makeComponent(GererCommunicationsComponent)
let GererSecuriteComponent = {
    selector: 'gererSecurite',
    templateUrl: 'app/components/gestion-securite/gerer-securite.html',

    controller:
        class GererSecuriteController {
            formulaire = {}
            mfaRequiredInToken
            showWaiting
            showSaveError

            static $inject = ['authenticationService', 'actionnaireService']

            constructor(authenticationService, actionnaireService) {
                this.authenticationService = authenticationService
                this.actionnaireService = actionnaireService
            }

            $postLink() {
                this.mfaRequiredInToken = this.#mfaValueInToken
                this.formulaire.activerMfa = this.mfaRequiredInToken ? "yes" : "no"
            }

            get changed() {
                return this.#mfaValueInForm !== this.#mfaValueInToken
            }

            async submit() {
                this.#resetFlags()

                const mfaValue = this.#mfaValueInForm
                const id = this.authenticationService.loggedId()

                this.#startLoading()

                try {
                    await this.actionnaireService.changeAuthentificationMultiFacteur(id, mfaValue)
                    await this.#onSaveSuccess()
                } catch (error) {
                    this.#onSaveError()
                } finally {
                    this.#stopLoading()
                }
            }

            #resetFlags() {
                this.showSaveError = false
                this.showWaiting = false
            }

            get #mfaValueInForm() {
                return this.formulaire.activerMfa === "yes"
            }

            get #mfaValueInToken() {
                return this.authenticationService.isMfaRequired()
            }

            async #onSaveSuccess() {
                await this.authenticationService.refreshToken()
            }

            #onSaveError() {
                this.showSaveError = true
            }

            #startLoading() {
                this.showWaiting = true
            }

            #stopLoading() {
                this.showWaiting = false
            }
        }
}

makeComponent(GererSecuriteComponent)
const InfoTooltipComponent = {
    selector: 'infoTooltip',
    transclude: true,
    // Pas d'espace avant l'icône : placée dans un libellé, elle reste collée au dernier mot
    template:
        `<i data-ng-ref="$ctrl.tooltip" class='bi bi-question-circle-fill'></i>
            <ng-transclude data-ng-ref="$ctrl.content"></ng-transclude>
        `,
    controller:
        class InfoTooltipController {
            tooltip
            content

            $postLink() {
                globalThis.tippy(this.tooltip[0], {
                    content: this.content[0],
                    interactive: true,
                    theme: 'light',
                    allowHTML: true,
                    arrow: false
                })
            }
        }
}

makeComponent(InfoTooltipComponent)
const AddressSearchComponent = {
    selector: 'addressSearch',
    bindings: {
        options: '<?',
        filter: '<?',
        placeholder: '@?',
        errorMessage: '<?'
    },
    require: {
        model: 'ngModel'
    },
    template:
        `
            <input
                type="text"
                data-ng-ref="$ctrl.searchInput"
                placeholder="{{ $ctrl.placeholder }}"
                class="form-control">
            <div data-ng-if="$ctrl.errorMessage" class="feedback-error">{{ $ctrl.errorMessage }}</div>    
        `,
    controller:
        class AddressSearchController {
            searchInput
            model
            options = {}
            filter
            #errorMessage

            static $inject = ['$element']
            constructor($element) {
                $element.addClass('form-group')
            }

            $postLink() {
                this.model.$validators.filter = (address) => this.#doFilter(address)

                this.#buildControl()
                    .listen('populate', address => this.#onAddressChanged(address))
            }

            set errorMessage(value) {
                this.#errorMessage = value
                this.#updateValidity()
            }

            get errorMessage() {
                return this.#errorMessage
            }

            #updateValidity() {
                this.searchInput
                    ?.controller('ng-model')
                    .$setValidity('errorMessage', !this.#errorMessage)
            }

            #buildControl() {
                const control =
                    new pca.Address([{element: this.searchInput[0], field: '', mode: pca.fieldMode.SEARCH}],
                        {
                            key: 'EA35-AE58-DD14-UR81',
                            GeoLocationEnabled: false,
                            suppressAutocomplete: false,
                            ...this.options,
                            bar: {
                                visible: true,
                                ...this.options.bar
                            }
                        })

                control.setCountry('CAN')
                return control;
            }

            #onAddressChanged(address) {
                this.model.$setViewValue(this.#mapAddress(address))
            }

            // TODO: extract this mapping function as a binding (when necessary)
            #mapAddress(address) {
                return {
                    numeroCivique: address.BuildingNumber,
                    rue: address.Street,
                    appartement: address.SubBuilding,
                    ville: address.City,
                    codePostal: address.PostalCode,
                    province: address.Province,
                    pays: address.CountryName,
                    type: address.Type
                }
            }

            #doFilter(address) {
                if (address && this.filter)
                    return this.filter(address)
                return true
            }
        }
}

makeComponent(AddressSearchComponent)
const FileUploadComponent = {
    selector: 'fileUpload',
    bindings: {
        model: '=',
        label: '@',
        accept: '@?',
        maxSizeMb: '<?',
        required: '<?'
    },
    templateUrl: 'app/components/input/file-upload.html',
    controller: class FileUploadController {
        model
        label
        accept
        maxSizeMb
        required
        erreursTaille = []
        erreursType = []

        $onInit() {
            this.model ??= []
        }

        get filesValue() {
            return this.model && this.model.length > 0 ? this.model : null
        }

        get acceptedTypes() {
            return this.accept ? this.accept.split(',').map(t => t.trim()) : []
        }

        onFilesSelected(files) {
            this.erreursTaille = []
            this.erreursType = []

            for (const file of files) {
                if (!this.#isTypeValid(file)) {
                    this.erreursType.push(file.name)
                    continue
                }
                if (!this.#isSizeValid(file)) {
                    this.erreursTaille.push(file.name)
                    continue
                }
                if (!this.model.find(f => f.name === file.name && f.size === file.size))
                    this.model.push(file)
            }
        }

        delete(file) {
            this.model.splice(this.model.indexOf(file), 1)
        }

        #isTypeValid(file) {
            if (this.acceptedTypes.length === 0) return true
            return this.acceptedTypes.some(type => {
                if (type.startsWith('.'))
                    return file.name.toLowerCase().endsWith(type.toLowerCase())
                return file.type === type
            })
        }

        #isSizeValid(file) {
            if (!this.maxSizeMb) return true
            return file.size <= this.maxSizeMb * 1024 * 1024
        }
    }
}

makeComponent(FileUploadComponent)

const LabeledCurrencyInputComponent = {
    selector: 'labeledCurrencyInput',
    transclude: true,
    bindings: {
        id: '@',
        name: '@',
        label: '@',
        min: '@',
        max: '@',
        required: '<?',
        warningMessage: '<?',
        errorMessage: '<?',
        model: '='
    },
    template:
        `
        <labeled-numeric-input
            id="{{ $ctrl.id }}"
            name="{{ $ctrl.name }}"
            label="{{ $ctrl.label }}"
            min="{{ $ctrl.min }}"
            max="{{ $ctrl.max }}"
            step="0.01"
            icon-class="fa-usd"
            required="$ctrl.required"
            warning-message="$ctrl.warningMessage"
            error-message="$ctrl.errorMessage"
            model="$ctrl.model">
            <ng-transclude></ng-transclude>
        </labeled-numeric-input>
        `
}

makeComponent(LabeledCurrencyInputComponent)
const LabeledDatepickerComponent = {
    selector: 'labeledDatepicker',
    transclude: true,
    bindings: {
        id: '@',
        label: '@?',
        name: '@',
        language: '@',
        required: '<?',
        placeholder: '@?',
        options: '<?',
        warningMessage: '<?',
        errorMessage: '<?',
        model: '='
    },
    template:
        `
        <div class="has-feedback" data-ng-class="{'form-group': $ctrl.label}">
            <label data-ng-if="$ctrl.label" for="{{ $ctrl.id }}" data-ng-bind-html="$ctrl.label"></label>
            <ng-transclude></ng-transclude>
            <input
                data-provide="datepicker"
                data-ng-ref="$ctrl.datepicker"
                id="{{ $ctrl.id }}"
                name="{{ $ctrl.name }}"
                type="text"
                data-ui-mask="9999-99-99"
                data-model-view-value="true"
                data-ng-required="$ctrl.required"
                data-ng-model="$ctrl.model"
                class="form-control"
                placeholder="{{ $ctrl.placeholder }}">
            <i class="bi bi-calendar form-control-feedback"></i>
            <div data-ng-if="$ctrl.errorMessage" class="feedback-error">{{ $ctrl.errorMessage }}</div>
            <div data-ng-if="$ctrl.warningMessage" class="feedback-warning">{{ $ctrl.warningMessage }}</div>
        </div>
        `,
    controller:
        class LabeledDatepickerController {
            datepicker
            #errorMessage

            constructor() {
                this.required = false
                this.options = {}
            }

            $postLink() {
                this.#configureDatepicker()
                this.#updateValidity()
            }

            #configureDatepicker() {
                const camelToKebab = str => str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase() // @todo move out and test
                const toDatepickerOption = str => `data-date-${camelToKebab(str)}`

                Object.entries(this.options).forEach(([key, value]) => {
                    this.datepicker.attr(toDatepickerOption(key), value)
                })
            }

            set errorMessage(value) {
                this.#errorMessage = value
                this.#updateValidity()
            }

            get errorMessage() {
                return this.#errorMessage
            }

            #updateValidity() {
                this.datepicker
                    ?.controller('ng-model')
                    .$setValidity('errorMessage', !this.#errorMessage)
            }
        }
}

makeComponent(LabeledDatepickerComponent)
const LabeledInputComponent = {
    selector: 'labeledInput',
    transclude: true,
    bindings: {
        id: '@',
        name: '@',
        type: '@?',
        mask: '@?',
        digitsOnly: '<?',
        placeholder: '@?',
        label: '@',
        required: '<?',
        readonly: '<?',
        disabled: '<?',
        maxlength: '@?',
        invalid: '<?',
        model: '=',
        prefix: '@'
    },
    template:
        `
        <div class="form-group">
            <label for="{{ $ctrl.id }}" data-ng-bind-html="$ctrl.label"></label>
            <ng-transclude></ng-transclude>
            <div class='input-line'>
                <span class='prefix' data-ng-if="$ctrl.prefix">{{$ctrl.prefix}}</span>
                <input
                    id="{{ $ctrl.id }}"
                    name="{{ $ctrl.name }}"
                    type="{{ $ctrl.type }}"
                    data-ng-ref="$ctrl.input"
                    data-ng-ref-read="ng-model"
                    data-ng-required="$ctrl.required"
                    data-ng-readonly="$ctrl.readonly"
                    data-ng-disabled="$ctrl.disabled"
                    data-ng-model="$ctrl.model"
                    data-ng-change="$ctrl.onModelChange()"
                    data-ui-mask="{{ $ctrl.mask }}"
                    maxlength="{{ $ctrl.maxlength }}"
                    placeholder="{{ $ctrl.placeholder }}"
                    class="form-control">
            </div>
        </div>
        `,
    controller:
        class LabeledInputController {
            input
            #invalid

            constructor() {
                this.type = "text"
                this.maxlength = undefined
                this.required = false
                this.readonly = false
                this.disabled = false
                this.digitsOnly = false
            }

            $postLink() {
                this.#updateValidity()
            }

            set invalid(value) {
                this.#invalid = value
                this.#updateValidity()
            }

            get invalid() {
                return this.#invalid
            }

            onModelChange() {
                if (!this.digitsOnly || !this.model)
                    return

                this.model = this.model.replace(/\D/g, '')
            }

            #updateValidity() {
                this.input?.$setValidity('customValidity', !this.#invalid)
            }
        }
}

makeComponent(LabeledInputComponent)
const LabeledNumericInputComponent = {
    selector: 'labeledNumericInput',
    transclude: true,
    bindings: {
        id: '@',
        iconClass: '@',
        name: '@',
        label: '@',
        min: '@',
        max: '@',
        step: '@',
        required: '<?',
        warningMessage: '<?',
        errorMessage: '<?',
        model: '='
    },
    template:
        `
        <div class="form-group has-feedback">
            <label for="{{ $ctrl.id }}" data-ng-bind-html="$ctrl.label"></label>
            <ng-transclude></ng-transclude>
            <div class="champ-avec-icone">
                <input
                    data-ng-ref="$ctrl.numericInput"
                    id="{{ $ctrl.id }}"
                    name="{{ $ctrl.name }}"
                    type="number"
                    step="{{ $ctrl.step }}"
                    min="{{ $ctrl.min }}"
                    max="{{ $ctrl.max }}"
                    data-ng-required="$ctrl.required"
                    data-ng-model="$ctrl.model"
                    class="form-control">
                <i class="fa {{ $ctrl.iconClass }} form-control-feedback"></i>
            </div>
            <div data-ng-if="$ctrl.errorMessage" class="feedback-error">{{ $ctrl.errorMessage }}</div>
            <div data-ng-if="$ctrl.warningMessage" class="feedback-warning">{{ $ctrl.warningMessage }}</div>
        </div>
        `,
    controller:
        class LabeledInputController {
            numericInput
            #errorMessage

            constructor() {
                this.required = false
            }

            $postLink() {
                this.#updateValidity()
            }

            set errorMessage(value) {
                this.#errorMessage = value
                this.#updateValidity()
            }

            get errorMessage() {
                return this.#errorMessage
            }

            #updateValidity() {
                this.numericInput
                    ?.controller('ng-model')
                    ?.$setValidity('errorMessage', !this.#errorMessage)
            }
        }
}

makeComponent(LabeledNumericInputComponent)

const LabeledPercentInputComponent = {
    selector: 'labeledPercentInput',
    transclude: true,
    bindings: {
        id: '@',
        name: '@',
        label: '@',
        min: '@',
        max: '@',
        required: '<?',
        warningMessage: '<?',
        errorMessage: '<?',
        model: '='
    },
    template:
        `
        <labeled-numeric-input
            id="{{ $ctrl.id }}"
            name="{{ $ctrl.name }}"
            label="{{ $ctrl.label }}"
            min="{{ $ctrl.min }}"
            max="{{ $ctrl.max }}"
            step="0.01"
            icon-class="fa-percent"
            required="$ctrl.required"
            warning-message="$ctrl.warningMessage"
            error-message="$ctrl.errorMessage"
            model="$ctrl.model">
            <ng-transclude></ng-transclude>
        </labeled-numeric-input>
        `
}

makeComponent(LabeledPercentInputComponent)
const LabeledSelectComponent = {
    selector: 'labeledSelect',
    transclude: true,
    bindings: {
        id: '@',
        label: '@',
        name: '@',
        placeholder: '@?',
        choices: '<',
        required: '<?',
        model: '='
    },
    template:
        `
            <div class="form-group has-feedback">
                <label for="{{ $ctrl.id }}" data-ng-bind-html="$ctrl.label"></label>
                <ng-transclude></ng-transclude>
                <select id="{{ $ctrl.id }}"
                        name="{{ $ctrl.name }}"
                        data-ng-required="$ctrl.required"
                        data-ng-model="$ctrl.model"
                        class="form-control">
                    <option data-ng-if="$ctrl.placeholder" value="" disabled hidden>{{ $ctrl.placeholder }}</option>
                    <option data-ng-repeat="choice in $ctrl.choices track by choice.value" value="{{ choice.value }}">{{ choice.label }}</option>
                </select>
                <i class="fa fa-chevron-down form-control-feedback"></i>
            </div>
        `,
    controller:
        class LabeledSelectController {
            constructor() {
                this.required = false
            }
        }
}

makeComponent(LabeledSelectComponent)
const RadioGroupComponent = {
    selector: 'radioGroup',
    bindings: {
        name: '@',
        model: '=',
        choices: '<',
        required: '<?',
        errorMessage: '<?',
        radioClass: '@?'
    },
    template:
        `
        <ng-form class="radio-group" name="{{ $ctrl.name }}" ng-ref="$ctrl.form" ng-ref-read="form">
            <radio
                data-ng-repeat="choice in $ctrl.choices track by choice.value" 
                name="{{ $ctrl.name }}"
                model="$ctrl.model"
                required="$ctrl.required"
                class="{{ $ctrl.radioClass }}"
                
                label="{{ choice.label }}"
                description="{{ choice.description }}"
                value="choice.value"
                disabled="choice.disabled">
                <info-tooltip data-ng-if="choice.tooltip">
                    <ng-bind-html data-ng-bind-html="choice.tooltip"></ng-bind-html>
                </info-tooltip>
            </radio>
        </ng-form>
        <p data-ng-if="$ctrl.errorMessage" class="feedback-error">{{ $ctrl.errorMessage }}</p>
        `,
    controller:
        class RadioGroupController {
            form
            required = false
            #errorMessage

            $postLink() {
                this.#updateValidity()
            }

            set errorMessage(value) {
                this.#errorMessage = value
                this.#updateValidity()
            }

            get errorMessage() {
                return this.#errorMessage
            }

            #updateValidity() {
                this.form?.$setValidity('errorMessage', !this.#errorMessage)
            }
        }
}

makeComponent(RadioGroupComponent)
const RadioComponent = {
    transclude: true,
    selector: 'radio',
    bindings: {
        id: '@?',
        name: '@',
        value: '<',
        label: '@',
        description: '@?',
        required: '<?',
        disabled: '<?',
        model: '='
    },
    template:
        `
            <div class="colored-radio radio">
                <label>
                    <input
                        type="radio"
                        id="{{ $ctrl.id }}"
                        name="{{ $ctrl.name }}"
                        data-ng-value="$ctrl.value"
                        data-ng-required="$ctrl.required"
                        data-ng-disabled="$ctrl.disabled"
                        data-ng-model="$ctrl.model"/>
                    <span class="radio-labels">
                        <span>
                            <span class="radio-label">{{ $ctrl.label }}</span>
                            <span data-ng-transclude></span>
                        </span>
                        <span data-ng-if="$ctrl.description" class="radio-description" style="font-size: 0.85em;">{{ $ctrl.description }}</span>
                    </span>
                </label>
            </div>
        `,
    controller:
        class RadioController {
            required = false
            disabled = false
        }
}

makeComponent(RadioComponent)
const ModalDroitsRecoursComponent = {
    selector: 'modalDroitsRecours',
    templateUrl: 'app/components/legal/modal-droits-recours.html',
    bindings: {
        name: '@'
    },
    controller:
        class ModalDroitsRecoursController {
            constructor() {
            }
        }
}

makeComponent(ModalDroitsRecoursComponent)
const LienDocumentIcon = {
    selector: 'lienDocumentIcon',
    templateUrl: 'app/components/lien-document-icon.html',
    bindings: {
        text: '@',
        lien: '@'
    }
}

makeComponent(LienDocumentIcon)
const LoadingComponent = {
    selector: 'loading',
    transclude: true,
    template:
        `
            <div data-ng-if="$ctrl.task.pending || $ctrl.task.rejected" class="overlay">
                <div class="center">
                    <input type="hidden" ng-model="$ctrl.alwaysInvalid" required>
                    <div data-ng-if="$ctrl.task.pending" class="spinner"></div>
                    <div data-ng-if="$ctrl.task.rejected" class="error">{{ $ctrl.errorMessage }}</div>
                </div>
            </div>
            <ng-transclude></ng-transclude>
        `,
    bindings: {
        task: '<',
        errorMessage: '@'
    },
    controller: class {
        alwaysInvalid = undefined // used to produce an invalid input that will invalidate any form we may be part of
    }
}

makeComponent(LoadingComponent)
let BandeauEspaceCroissanceComponent = {
    selector: 'bandeauEspaceCroissance',
    templateUrl: 'app/components/marketing/bandeau-espace-croissance.html',
    bindings: {
        titre: '@',
        text: '@',
        btnText: '@',
        btnHref: '@',
        btnCss: '@',
        imagePath: '@',
        precision: '@',
        hide: '<'
    },
    controller: class BandeauEspaceCroissanceController {
        hide=false;
        get showBandeauEspaceDeCroissance() {
            return !this.hide
        }
    }
}

makeComponent(BandeauEspaceCroissanceComponent)
let OrganiseurEspaceCroissanceComponent = {
    selector: 'organiseurEspaceCroissance',
    templateUrl: 'app/components/marketing/organiseur-espace-croissance.html',
    bindings: {
        dateDeNaissance: '@'
    },
    controller: class OrganiseurEspaceCroissanceController {
        dateDeNaissance="1000-01-01";
        hide = {
            adulte : true,
            mature : true,
            senior : true
        }

        static $inject = [LanguageService.dependency,'featureSwitchService'];
        constructor(languageService, featureSwitchService) {
            this.languageService = languageService
            this.featureSwitchService = featureSwitchService
        }

        $onInit() {
            this.selectContentToDisplay();
        }

        get showBandeauEspaceDeCroissance() {
            return this.featureSwitchService.featureSwitches.ShowBandeauEspaceDeCroissance
        }

        selectContentToDisplay() {
            this.hide[marketingCategoryFromBirthDate(this.dateDeNaissance)] = false;
        }
    }
}

makeComponent(OrganiseurEspaceCroissanceComponent)
const MessageBoxComponent = {
    selector: 'messageBox',
    transclude: true,
    bindings: {
        alertType: '@',
        otherIcon: '@?',
        dismissable: '<?'
    },
    template:
        `
        <div role="alert" class="message-box alert {{ $ctrl.alertType }}">
            <button data-ng-if="$ctrl.dismissable" type='button' data-dismiss='alert' aria-hidden='true' class='close'>&times;</button>

            <div class="alert-icon" data-ng-if="$ctrl.icon !== undefined">
                <i class="bi {{ $ctrl.icon }}"></i>
            </div>

            <div class="alert-body">
                <ng-transclude></ng-transclude>
            </div>
        </div>
        `,
    controller: class {
        alertType
        otherIcon

        get icon() {
            if (this.otherIcon)
                return this.otherIcon

            switch (this.alertType?.toLowerCase()) {
                case 'alert-success':
                    return 'bi-check-circle'
                case 'alert-warning':
                    return 'bi-exclamation-triangle'
                case 'alert-danger':
                    return 'bi-exclamation-octagon'
                case 'alert-info':
                    return 'bi-megaphone'
            }
        }
    }
}

makeComponent(MessageBoxComponent)
const ModalConfirmationDialogComponent = {
    selector: 'modalConfirmationDialog',
    transclude: true,
    bindings: {
        id: '@',
        name: '@',
        title: '@',
        confirmButtonLabel: '@',
        confirmButtonAction: '&',
        cancelButtonLabel: '@'
    },
    template:
        `
            <div id="{{ $ctrl.name }}" class="modal fade" data-ng-ref="$ctrl.dialog" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                            <h4 class="modal-title">{{ $ctrl.title }}</h4>
                        </div>
                        <div class="modal-body">
                            <ng-transclude></ng-transclude>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default" data-dismiss="modal">{{ $ctrl.cancelButtonLabel }}</button>
                            <button data-ng-if="$ctrl.confirmButtonLabel" type="button" class="btn btn-primary" data-ng-click="$ctrl.confirm()">{{ $ctrl.confirmButtonLabel }}</button>
                        </div>
                    </div>
                </div>
            </div>
        `,
    controller:
        class ModalConfirmationDialogController {
            confirmButtonAction
            dialog

            $onDestroy() {
                // patch to remove the dialog in case the entire component is being destroyed
                this.dialog?.modal('hideModal')
            }

            confirm() {
                this.confirmButtonAction()
                this.#hide()
            }

            show() {
                this.dialog.modal('show')
            }

            #hide() {
                this.dialog.modal('hide')
            }
        }
}

makeComponent(ModalConfirmationDialogComponent)
let NavbarRefreshComponent = {
    selector: 'navbarRefresh',
    templateUrl: 'app/components/navbar/navbarRefresh.html',
    controller: class NavbarRefreshController {
        newVersionAvailable = false
        checkVersionTask= null
        checkVersionExecutionInterval = 60000

        static $inject = ['$interval', '$window', 'versionService']

        constructor($interval, $window, versionService) {
            this.$interval = $interval
            this.$window = $window
            this.versionService = versionService
        }

        $onInit() {
            this.checkVersionTask = this.$interval(() => this.#checkVersion(), this.checkVersionExecutionInterval)
        }

        $onDestroy() {
            this.#stopCheckVersion()
        }

        refresh() {
            this.$window.location.reload()
        }

        async #checkVersion() {
            if (await this.versionService.hasDeployedVersionChanged()) {
                this.newVersionAvailable = true
                this.#stopCheckVersion()
            }
        }

        #stopCheckVersion() {
            if (this.checkVersionTask === null) return

            this.$interval.cancel(this.checkVersionTask)
            this.checkVersionTask = null
        }
    },
}

makeComponent(NavbarRefreshComponent)
const ConfirmationActionnairesComponent = {
    selector: 'nouvelleAdhesionConfirmationActionnaires',
    templateUrl: 'app/components/nouvelle-adhesion/actionnaire/confirmation-actionnaires.html',
    bindings: {
        confirmation: "<"
    },
    controller: class {
        confirmation

        get isVersementUnique() {
            return this.confirmation?.souscriptionChoisi === souscriptionTypeEnum.versementUnique
        }

        get isDebitPreautorise() {
            return this.confirmation?.souscriptionChoisi === souscriptionTypeEnum.debitPreAutorise
        }

        get isRss() {
            return this.confirmation?.souscriptionChoisi === souscriptionTypeEnum.retenueSalaire
        }

        get downloadRequestUrl() {
            const documentId = this.confirmation?.confirmationAdhesionDocumentId;
            const documentKey = encodeURIComponent(this.confirmation?.confirmationAdhesionDocumentKey);
            return `/api/documents/confirmationAdhesion/${documentId}?documentKey=${documentKey}`
        }
    }
}

makeComponent(ConfirmationActionnairesComponent)
const NouvelleAdhesionActionnaireComponent = {
    selector: 'nouvelleAdhesionActionnaire',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/actionnaire/nouvelle-adhesion-actionnaire.html',
    bindings: {
        rechargerPortefeuille: '&'
    },
    controller: class {
        confirmation
        erreur
        #nouvelleAdhesionService
        #gtmService
        #languageService
        #sessionStorage
        #rssService
        rechargerPortefeuille

        static $inject = [NouvelleAdhesionService.dependency, GtmService.dependency, LanguageService.dependency, RssService.dependency, '$sessionStorage', '$location']
        constructor(nouvelleAdhesionService, gtmService, languageService, rssService, sessionStorage, $location) {
            this.#nouvelleAdhesionService = nouvelleAdhesionService
            this.#gtmService = gtmService
            this.#languageService = languageService
            this.#sessionStorage = sessionStorage
            this.#rssService = rssService
            this.$location = $location
            this.#sessionStorage.$default({formulaire: this.#getDefaultFormulaire()})

            this.resetConfirmationSiFrancais()
        }

        async $onInit() {
            this.#rssService.getRss().then(response => {
                if(response.rss != null && !response.rss.dateObsolete)
                    this.formulaire.rssPrecedente = response
            })
        }

        #getDefaultFormulaire() {
            return {stepIndex: 0, confirmationAnglais: false, versement: {compte: {}}}
        }

        get formulaire() {
            return this.#sessionStorage.formulaire
        }

        resetConfirmationSiFrancais() {
            if (this.#languageService.lang === langueEnum.francais)
                this.formulaire.confirmationAnglais = false
        }

        afficherPageConfirmationAnglais() {
            return this.formulaire?.confirmationAnglais === false && this.#languageService.lang === langueEnum.anglais
        }

        cancel() {
            this.#sessionStorage.formulaire = this.#getDefaultFormulaire()
            this.$location.path('')
        }

        async submit() {
            try {
                this.erreur = null

                this.confirmation = await this.#nouvelleAdhesionService.createExisting(buildFormulaire(this.formulaire, this.#languageService.lang))
                this.#gtmService.event(purchaseEvent(this.formulaire.versement))
                this.rechargerPortefeuille()
                delete this.#sessionStorage.formulaire
                this.#rssService.clearCache()

                return true
            } catch (e) {
                this.erreur = e.message
                return false
            }
        }
    }
}

makeComponent(NouvelleAdhesionActionnaireComponent)
function buildFormulaire(formulaire, langue) {
    return {
        langue: langue === langueEnum.anglais ? 'A' : 'F',
        confirmationAnglais: buildConfirmationLangue(formulaire, langue),
        version: 'web_2024',
        regime: formulaire.regime,
        canafe: buildCanafe(formulaire),
        actionnaire: buildActionnaire(formulaire.actionnaire),
        versement: buildVersement(formulaire.versement),
        preferenceCommunication: buildPreferenceCommunication(formulaire.preferenceCommunication),
        signatures: buildSignatures(),
        estSuccession: formulaire.regime !== regimeEnum.nonEnregistre,
    }

    function buildConfirmationLangue(formulaire, langue) {
        if (langue !== langueEnum.anglais) return
        return formulaire.confirmationAnglais
    }

    function buildCanafe(formulaire) {
        if (formulaire.regime !== regimeEnum.nonEnregistre) return
        return {
            isPpv: formulaire.canafe.isPpv,
            ppvRaison: formulaire.canafe.isPpv ? formulaire.canafe.ppvRaison : undefined,
            profession: formulaire.canafe.profession
        }
    }

    function buildActionnaire(actionnaire) {
        if (!actionnaire) return
        return {
            courriel: actionnaire.courriel,
            prenom: actionnaire.prenom,
            nom: actionnaire.nom,
            nas: actionnaire.nas,
            dateDeNaissance: actionnaire.dateDeNaissance,
            sexe: actionnaire.sexe,
            telephonePrincipal: actionnaire.telephonePrincipal,
            telephoneSecondaire: actionnaire.telephoneSecondaire,
            adresse: buildAdresse(actionnaire.adresse)
        }
    }

    function buildAdresse(adresse) {
        return {
            numeroCivique: adresse.numeroCivique,
            rue: adresse.rue,
            appartement: adresse.appartement,
            ville: adresse.ville,
            codePostal: adresse.codePostal,
            province: adresse.province,
            pays: adresse.pays
        }
    }

    function buildVersement(versement) {
        if (versement.type === typeVersementEnum.versementPeriodiqueParDebitPreAutorise)
            return {
                type: versement.type,
                frequence: versement.frequence,
                datePremierPrelevement: versement.datePremierPrelevement,
                ...buildVersementParDebit(versement)

            }
        else if (versement.type === typeVersementEnum.versementUniqueParDebitPreAutorise)
            return {
                type: versement.type,
                ...buildVersementParDebit(versement)
            }
        else if (versement.type === typeVersementEnum.versementPeriodiqueParRetenueSurSalaire)
            return {
                type: versement.type,
                recherche: versement.recherche ?? undefined,
                ...buildVersementParRss(versement)
            }
    }

    function buildVersementParDebit(versement) {
        return {
            montant: versement.montant,
            institution: versement.compte.institution,
            transit: versement.compte.transit,
            compte: versement.compte.numero,
            titulaire: versement.titulaire,
            titulaireConjoint: versement.titulaireConjoint
        }
    }

    function buildVersementParRss(versement) {
        if (versement.recherche && versement.recherche.resultatAccepte)
            return {
                responsableRemisesId: versement.responsableRemiseId ,
                dollarPaieEmploye: versement.contributionParPaie ?? undefined,
                pourcentagePaieEmploye: versement.contributionParPourcentageSalaire ?? undefined,
                dollarHeureEmploye: versement.contributionParHeure ?? undefined,
                typeDeductions: typeDeductionEnum[versement.deduction]
            }
    }

    function buildPreferenceCommunication(preferenceCommunication) {
        if (!preferenceCommunication) return
        return {
            resterEnContact: preferenceCommunication.resterEnContact,
            relevesFiscaux: preferenceCommunication.relevesFiscaux,
            autreDocuments: preferenceCommunication.autreDocuments
        }
    }

    function buildSignatures() {
        return {
            signatureActionnaire: true,
            dateSignatureActionnaire: DateUtils.today().toString()
        }
    }
}
const ChangementLangueComponent = {
    selector: 'changementLangue',
    templateUrl: 'app/components/nouvelle-adhesion/changement-langue.html',
    bindings: {
        confirmationAnglais: "="
    },
    controller: class {
        #location

        static $inject = ['$location']

        constructor($location) {
            this.#location = $location
        }

        continuerEnAnglais() {
            this.confirmationAnglais = true
        }

        estVisiteur() {
            return this.#getPrefix() === "visiteur"
        }

        estActionnaire() {
            return this.#getPrefix() === "actionnaires"
        }

        #getPrefix() {
            return /actionnaires/.test(this.#location.path()) ? 'actionnaires' : 'visiteur'
        };

    }
}

makeComponent(ChangementLangueComponent)
const ChoixRegimeComponent = {
    selector: 'nouvelleAdhesionChoixRegime',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/choix-regime.html',
    bindings: {
        formulaire: "="
    },
    controller: class {
        #adhesionService
        #gtmService
        formulaire
        errorRerConjoint
        errorAdhesionLimit
        errorRerLimit
        errorAucunChoix
        loading
        adhesions = []

        static $inject = [NouvelleAdhesionService.dependency, GtmService.dependency]

        constructor(adhesionService, gtmService) {
            this.#adhesionService = adhesionService
            this.#gtmService = gtmService

            this.loading = new Task(this.#load())
        }

        $onDestroy() {
            // todo: differentiate between navigating away due to success or abandon
            this.#gtmService.event({
                event: 'account_opening',
                step: 'Choix du régime',
                plan: this.isHorsRer ? 'hors RÉR' : 'RÉR personnel'
            })
        }

        async #load() {
            const adhesions = await this.#adhesionService.list()
            this.adhesions = adhesions.filter(adhesion => adhesion.etat !== 'annule')
        }

        get isHorsRer() {
            return this.#isRegime(regimeEnum.nonEnregistre)
        }

        get errorRegime() {
            if (this.#isRegime(regimeEnum.reerConjoint))
                return this.errorRerConjoint

            if (this.adhesions.length >= 3)
                return this.errorAdhesionLimit

            if (this.#hasMultipleRegime(regimeEnum.enregistre))
                return this.errorRerLimit

            if (!this.formulaire.regime)
                return this.errorAucunChoix
        }

        #isRegime(regime) {
            return this.formulaire.regime === regime
        }

        #hasExistingRegime(regime) {
            return this.adhesions.some(adhesion => adhesion.regime === regime)
        }

        #hasMultipleRegime(regime) {
            return this.#isRegime(regime) && this.#hasExistingRegime(regime)
        }
    }
}

makeComponent(ChoixRegimeComponent)
const CommunicationComponent = {
    selector: 'nouvelleAdhesionCommunication',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/communication.html',
    bindings: {
        formulaire: "="
    },
    controller: class {
        static $inject = [GtmService.dependency]
        constructor(gtmService) {
            this.gtmService = gtmService
        }

        $onDestroy() {
            // todo: differentiate between navigating away due to success or abandon
            this.gtmService.event({
                event: 'account_opening',
                step: 'Communications',
            })
        }
    }
}

makeComponent(CommunicationComponent)
const ConfirmationVersementComponent = {
    selector: 'nouvelleAdhesionConfirmationVersement',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/confirmation-versement.html',
    bindings: {
        isRss: '<',
        isVersementUnique: '<',
        isDebitPreautorise: '<'
    },
    controller: class {
        static $inject = ['featureSwitchService']

        constructor(featureSwitchService) {
            this.featureSwitchService = featureSwitchService
        }

        get masquerConfirmationRss() {
            return !!this.featureSwitchService.featureSwitches.RssEnUnCoupNouvelleAdhesionVisiteur
        }
    }
}

makeComponent(ConfirmationVersementComponent)
const ConsentementsComponent = {
    selector: 'nouvelleAdhesionConsentements',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/consentements.html',
    bindings: {
        formulaire: "="
    },
    controller: class {
        formulaire

        static $inject = [GtmService.dependency]
        constructor(gtmService) {
            this.gtmService = gtmService
        }

        $onDestroy() {
            // todo: differentiate between navigating away due to success or abandon
            this.gtmService.event({
                event: 'account_opening',
                step: 'Autorisation et consentement',
            })
        }

        get isRegimeNonEnregistre() {
            return this.formulaire.regime === regimeEnum.nonEnregistre
        }
    }
}

makeComponent(ConsentementsComponent)
function purchaseEvent(versement) {
    return {
        event: 'purchase',
        step: 'Vérification des données',
        contribution_plan: versement.type,
        amount: versement.montant,
        frequency: versement.frequence,
        value: 'amount'
    }
}
const IdentificationComponent = {
    selector: 'nouvelleAdhesionIdentification',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/identification.html',
    bindings: {
        formulaire: "="
    },
    controller: class {
        formulaire
        warningNoTaxCredits
        errorTooYoung
        errorTooOld
        #loggedEmail
        #authenticationService

        static $inject = [GtmService.dependency, AuthenticationService.dependency]

        constructor(gtmService, authenticationService ) {
            this.gtmService = gtmService
            this.#authenticationService = authenticationService
        }

        $postLink() {
            this.loadCourriel()
        }

        $onDestroy() {
            // todo: differentiate between navigating away due to success or abandon
            this.gtmService.event({
                event: 'account_opening',
                step: 'Identification',
            })
        }

        filterAdresseQuebec(adresse) {
            return adresse.province === "QC"
        }

        get warningDateDeNaissance() {
            if (!this.dateDeNaissance) return

            if (this.formulaire.regime === regimeEnum.enregistre && DateUtils.ageThisYear(this.dateDeNaissance) >= 71)
                return

            if (DateUtils.ageThisYear(this.dateDeNaissance) >= 65)
                return this.warningNoTaxCredits
        }

        get errorDateDeNaissance() {
            if (!this.dateDeNaissance) return

            if (DateUtils.ageToday(this.dateDeNaissance) < 18)
                return this.errorTooYoung

            if (this.formulaire.regime === regimeEnum.enregistre && DateUtils.ageThisYear(this.dateDeNaissance) >= 71)
                return this.errorTooOld
        }

        get dateDeNaissance() {
            return DateUtils.from(this.formulaire.actionnaire?.dateDeNaissance)
        }

        loadCourriel() {
            this.#loggedEmail = this.#authenticationService.loggedEmail()

            if (this.#loggedEmail) {
                if (this.formulaire.actionnaire)
                    this.formulaire.actionnaire.courriel = this.#loggedEmail
                else
                    this.formulaire.actionnaire = {courriel: this.#loggedEmail}
            }
        }
    }
}

makeComponent(IdentificationComponent)
const NouvelleAdhesionIntro = {
    selector: 'nouvelleAdhesionIntro',
    templateUrl: 'app/components/nouvelle-adhesion/nouvelle-adhesion-intro.html',
    bindings: {
    },
    controller: class {
        #authenticationService
        static $inject = [AuthenticationService.dependency]

        constructor(authenticationService) {
            this.#authenticationService = authenticationService
        }

        navigateNext() {
            this.#authenticationService.signUp('/visiteur/nouvelleAdhesion')
        }
    }
}

makeComponent(NouvelleAdhesionIntro)
const QuestionsCanafeComponent = {
    selector: 'questionsCanafe',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/regime/questions-canafe.html',
    bindings: {
        model: '='
    }
}
makeComponent(QuestionsCanafeComponent)

const TypeDeVersementComponent = {
    selector: 'nouvelleAdhesionTypeDeVersement',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/type-de-versement.html',
    bindings: {
        formulaire: "=",
        rssUneEtape: "<"
    },
    controller: class {
        formulaire
        #limiteVersementService
        errorAucunChoix
        loading

        static $inject = [LimiteVersementService.dependency, GtmService.dependency, 'featureSwitchService']
        constructor(limiteVersementService, gtmService, featureSwitchService) {
            this.#limiteVersementService = limiteVersementService
            this.gtmService = gtmService
            this.featureSwitchService = featureSwitchService
            this.loading = new Task(this.#load())
        }

        $onDestroy() {
            // todo: differentiate between navigating away due to success or abandon
            this.gtmService.event({
                event: 'account_opening',
                step: 'Type de versement',
            })
        }

        #load() {
            return this.#limiteVersementService.isLimiteVersementEnabled()
                .then(limite => this.isLimiteVersementActive = limite.limiteActive)
        }

        get activerRssEnUnCoupNouvelleAdhesionVisiteur() {
            return this.featureSwitchService.featureSwitches.RssEnUnCoupNouvelleAdhesionVisiteur
        }

        get aUneRssActive() {
            return !!this.formulaire.rssPrecedente
        }

        get errorTypeVersement() {
            if (this.formulaire.versement?.type === undefined)
                return this.errorAucunChoix
        }
    }
}

makeComponent(TypeDeVersementComponent)
const VerificationActionnaireComponent = {
    selector: 'verificationActionnaire',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-actionnaire.html',
    bindings: {
        formulaire: "<"
    }
}

makeComponent(VerificationActionnaireComponent)
const VerificationBeneficiaireComponent = {
    selector: 'verificationBeneficiaire',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-beneficiaire.html'
}

makeComponent(VerificationBeneficiaireComponent)
const VerificationFooterComponent =  {
    selector: 'verificationFooter',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-footer.html',
}

makeComponent(VerificationFooterComponent)

const VerificationInformationComponent = {
    selector: 'verificationInformation',
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-information.html',
    bindings: {
        actionnaire: "<"
    },
    controller: class {
        actionnaire

        get nomComplet() {
            const prenom = this.actionnaire.prenom
            const nom = this.actionnaire.nom
            return `${prenom} ${nom}`
        }

        get nas() {
            const nas = this.actionnaire.nas
            return `${nas.slice(0, 3)} ${nas.slice(3, 6)} ${nas.slice(6, 9)}`
        }

        get displayTelephone() {
            return verificationDisplayTelephone(
                this.actionnaire.telephonePrincipal,
                this.actionnaire.telephoneSecondaire
            )
        }

        get displayAddress() {
            return verificationDisplayAddress(this.actionnaire.adresse)
        }
    }
}

function verificationDisplayAddress(address) {
    const appartementIfPresent = (apartment) => {
        const hasAppartement = address.appartement && address.appartement.trim()
        return hasAppartement ? `${apartment}-` : ''
    }
    const noWrap = (input) => `<span class="text-nowrap">${input}</span>`

    const noCiviqueEtAppartement = `${appartementIfPresent(address.appartement)}${address.numeroCivique}`

    const firstLinePart1 = noWrap(`${noCiviqueEtAppartement} ${address.rue},`)
    const firstLinePart2 = noWrap(address.ville)
    const secondLine = noWrap(`${address.province}, ${address.codePostal}`)

    return `${firstLinePart1} ${firstLinePart2}<br>${secondLine}`
}

function verificationDisplayTelephone(telephonePrincipal, telephoneSecondaire) {
    const format = (telephone) => `${telephone.slice(0, 3)} ${telephone.slice(3, 6)}-${telephone.slice(6, 10)}`

    if (telephoneSecondaire?.length > 0)
        return `${format(telephonePrincipal)}<br>${format(telephoneSecondaire)}`

    return format(telephonePrincipal)
}

makeComponent(VerificationInformationComponent)
const VerificationRegimeEnregistreComponent = {
    selector: 'verificationRegimeEnregistre',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-regime-enregistre.html'
}

makeComponent(VerificationRegimeEnregistreComponent)
const VerificationRegimeHorsReerComponent = {
    selector: 'verificationRegimeHorsReer',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-regime-hors-reer.html',
    bindings: {
        model: "="
    }
}

makeComponent(VerificationRegimeHorsReerComponent)
const VerificationRegimesComponent = {
    selector: 'verificationRegimes',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-regimes.html',
    bindings: {
        formulaire: "<"
    },
    controller: class {
        formulaire

        get isRegimeEnregistre() {
            return this.formulaire.regime === regimeEnum.enregistre
        }

        get isRegimeHorsReer() {
            return this.formulaire.regime === regimeEnum.nonEnregistre
        }
    }
}

makeComponent(VerificationRegimesComponent)
const VerificationSignatureComponent = {
    selector: 'verificationSignature',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-signature.html'
}

makeComponent(VerificationSignatureComponent)
const VerificationVersementPeriodiqueComponent = {
    selector: 'nouvelleAdhesionVerificationVersementPeriodique',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-versement-periodique.html',
    bindings: {
        versement: "<"
    },
    controller: class {
        versement

        get montant() {
            return this.versement.montant
        }

        get frequence() {
            return this.versement.frequence
        }

        get datePremierPrelevement() {
            return this.versement.datePremierPrelevement
        }

        get institution() {
            return this.versement.compte.reference
        }

        get transitCompte() {
            return `${this.versement.compte.transit} ${this.versement.compte.numero}`
        }

        get titulaire() {
            return this.versement.titulaire
        }

        get titulaireConjoint() {
            return this.versement.titulaireConjoint
        }
    }
}

makeComponent(VerificationVersementPeriodiqueComponent)
const VerificationVersementRssComponent = {
    selector: 'nouvelleAdhesionVerificationVersementRss',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-versement-rss.html',
    bindings: {
        versement: "<",
        regime: "<"
    },
    controller: class {
        versement
        regime
        deductionTout
        deductionReer
        deductionCreditImpot
        deductionAucune
        deductioncreditImpotHorsReer
        deductionaucunCreditImpot

        get detailsFournis() {
            return this.versement.responsableRemiseId
        }

        get employeur() {
            return this.versement.employeur
        }

        get numeroEmployeur() {
            return this.versement.numeroResponsableDeRemise
        }

        get dollarParPaie() {
            return this.versement.contributionParPaie
        }

        get afficherDollarParPaie() {
            return this.dollarParPaie > 0
        }

        get dollarParHeure() {
            return this.versement.contributionParHeure
        }

        get afficherDollarParHeure() {
            return this.dollarParHeure > 0
        }

        get pourcentageParPaie() {
            return this.versement.contributionParPourcentageSalaire
        }

        get afficherPourcentageParPaie() {
            return this.pourcentageParPaie > 0
        }

        get estRegimeNonEnregistre() {
            return this.regime === regimeEnum.nonEnregistre
        }

        get typeDeduction() {
            if (this.estRegimeNonEnregistre)
                switch (this.versement.deduction) {
                    case 'creditImpot':
                        return this.deductioncreditImpotHorsReer
                    case 'aucune':
                        return this.deductionaucunCreditImpot
                    default:
                        return ''
                }
            else
                switch (this.versement.deduction) {
                    case 'tout':
                        return this.deductionTout
                    case 'reer':
                        return this.deductionReer
                    case 'creditImpot':
                        return this.deductionCreditImpot
                    case 'aucune':
                        return this.deductionAucune
                    default:
                        return ''
                }
        }
    }
}

makeComponent(VerificationVersementRssComponent)
const VerificationVersementUniqueComponent = {
    selector: 'nouvelleAdhesionVerificationVersementUnique',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-versement-unique.html',
    bindings: {
        versement: "<"
    },
    controller: class {
        versement

        get montant() {
            return this.versement.montant
        }

        get institution() {
            return this.versement.compte.reference
        }

        get transitCompte() {
            return `${this.versement.compte.transit} ${this.versement.compte.numero}`
        }

        get titulaire() {
            return this.versement.titulaire
        }

        get titulaireConjoint() {
            return this.versement.titulaireConjoint
        }
    }
}

makeComponent(VerificationVersementUniqueComponent)
const VerificationVersementsComponent = {
    selector: 'verificationVersements',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-versements.html',
    bindings: {
        versement: "<",
        regime: "<"
    },
    controller: class {
        versement

        get isVersementRss() {
            return this.versement.type === typeVersementEnum.versementPeriodiqueParRetenueSurSalaire
        }

        get isVersementUnique() {
            return this.versement.type === typeVersementEnum.versementUniqueParDebitPreAutorise
        }

        get isVersementPeriodique() {
            return this.versement.type === typeVersementEnum.versementPeriodiqueParDebitPreAutorise
        }
    }
}

makeComponent(VerificationVersementsComponent)
const VerificationVisiteurComponent = {
    selector: 'verificationVisiteur',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/verification/verification-visiteur.html',
    bindings: {
        formulaire: "<"
    }
}

makeComponent(VerificationVisiteurComponent)
const ConfirmationVisiteurComponent = {
    selector: 'nouvelleAdhesionConfirmationVisiteur',
    templateUrl: 'app/components/nouvelle-adhesion/visiteur/confirmation-visiteur.html',
    bindings: {
        confirmation: "<"
    },
    controller: class {
        confirmation

        get isVersementUnique() {
            return this.confirmation?.souscriptionChoisi === souscriptionTypeEnum.versementUnique
        }

        get isDebitPreautorise() {
            return this.confirmation?.souscriptionChoisi === souscriptionTypeEnum.debitPreAutorise
        }

        get isRss() {
            return this.confirmation?.souscriptionChoisi === souscriptionTypeEnum.retenueSalaire
        }

        get downloadRequestUrl() {
            const documentId = this.confirmation?.confirmationAdhesionDocumentId;
            const documentKey = encodeURIComponent(this.confirmation?.confirmationAdhesionDocumentKey);
            return `/api/documents/confirmationAdhesion/${documentId}?documentKey=${documentKey}`
        }
    }
}

makeComponent(ConfirmationVisiteurComponent)
const NouvelleAdhesionVisiteurComponent = {
    selector: 'nouvelleAdhesionVisiteur',
    // language=file-reference
    templateUrl: 'app/components/nouvelle-adhesion/visiteur/nouvelle-adhesion-visiteur.html',
    controller: class {
        confirmation
        erreur
        #nouvelleAdhesionService
        #gtmService
        #languageService
        #sessionStorage
        #authenticationService
        #$location

        static $inject = [NouvelleAdhesionService.dependency, GtmService.dependency, LanguageService.dependency, '$sessionStorage', AuthenticationService.dependency, '$location']

        constructor(nouvelleAdhesionService, gtmService, languageService, sessionStorage, authenticationService, location) {
            this.#nouvelleAdhesionService = nouvelleAdhesionService
            this.#gtmService = gtmService
            this.#languageService = languageService
            this.#sessionStorage = sessionStorage
            this.#sessionStorage.$default({formulaire: this.#getDefaultFormulaire()})
            this.#authenticationService = authenticationService
            this.#$location = location

            this.resetConfirmationSiFrancais()
        }

        #getDefaultFormulaire() {
            return {stepIndex: 0, confirmationAnglais: false, versement: {compte: {}}}
        }

        get formulaire() {
            return this.#sessionStorage.formulaire
        }

        get maskErrorMessage() {
            return /AD999/.test(this.erreur)
        }

        resetConfirmationSiFrancais() {
            if (this.#languageService.lang === langueEnum.francais)
                this.formulaire.confirmationAnglais = false
        }

        afficherPageConfirmationAnglais() {
            return this.formulaire?.confirmationAnglais === false && this.#languageService.lang === langueEnum.anglais
        }

        cancel() {
            this.#sessionStorage.formulaire = this.#getDefaultFormulaire()
        }

        async submit() {
            try {
                this.erreur = null

                this.confirmation = await this.#nouvelleAdhesionService.createNew(buildFormulaire(this.formulaire, this.#languageService.lang))
                this.#gtmService.event(purchaseEvent(this.formulaire.versement))
                await this.#authenticationService.refreshToken()
                delete this.#sessionStorage.formulaire

                return true
            } catch (e) {
                this.erreur = e.message
                return false
            }
        }
    }
}

makeComponent(NouvelleAdhesionVisiteurComponent)
const PortefeuilleTransactionsEnCours = {
    selector: 'portefeuilleTransactionsEnCours',
    templateUrl: 'app/components/portefeuille/transactions-en-cours.html',
    bindings: {
        transactionsEnTraitement: '=',
        demandesRachatNonCompletees: '='
    }
}

makeComponent(PortefeuilleTransactionsEnCours)
const ProjectionVersementPeriodiqueComponent = {
    selector: "projectionVersementPeriodique",
    bindings: {
        montant: '<',
        frequence: '<'
    },
    // language=file-reference
    templateUrl: 'app/components/projection-versement-periodique.html',
    controller:
        class ProjectionVersementPeriodiqueController {
            montant
            frequence
            #facteurMap

            constructor() {
                this.#facteurMap = new Map()
                this.#facteurMap.set('toutesLesSemaines', 52)
                this.#facteurMap.set('toutesLesDeuxSemaines', 26)
                this.#facteurMap.set('mensuelle', 12)
            }

            get projection() {
                return this.#facteur && this.montant ? this.montant * this.#facteur : 0
            }

            get #facteur() {
                return this.#facteurMap.get(this.frequence)
            }
        }
}

makeComponent(ProjectionVersementPeriodiqueComponent)
class CalculateurImpotsRachat {

    ajoutInformationsImpot(adhesions) {
        adhesions.forEach(adhesion => {
            if (!adhesion || adhesion.regime !== regimeEnum.enregistre)
                return;

            const montant = adhesion.montantAdmissible || 0
            const palierFederal = this.#trouverPalierApplicable(adhesion.tauxImpositionFederal, montant)
            const palierProvincial = this.#trouverPalierApplicable(adhesion.tauxImpositionProvincial, montant)

            adhesion.palierFederalApplicable = palierFederal
            adhesion.palierProvincialApplicable = palierProvincial
            
            const tauxFederal = palierFederal?.taux || 0
            const tauxProvincial = palierProvincial?.taux || 0

            adhesion.impotFederal = this.#calculerImpot(montant, tauxFederal)
            adhesion.impotProvincial = this.#calculerImpot(montant, tauxProvincial)
            adhesion.impotTotal = adhesion.impotFederal + adhesion.impotProvincial
            adhesion.montantNet = montant - adhesion.impotTotal
        });
    }

    #trouverPalierApplicable(paliers, solde) {
        if (!Array.isArray(paliers)) return null

        return paliers
            .filter(p => p.montantPalier <= solde)
            .sort((a, b) => b.montantPalier - a.montantPalier)[0] || null
    }

    #calculerImpot(montant, taux) {
        return montant * taux
    }
}
const demandeRachatStepsSansPreuves = [
    '1|Option de rachat',
    '2|Transferer/Encaisser',
    '3|Renseignements',
    '4|Verification'
]

const demandeRachatStepsAvecPreuves = [
    '1|Preuves - premier rachat',
    '2|Option de rachat - premier rachat',
    '3|Transferer/Encaisser - premier rachat',
    '4|Renseignements - premier rachat',
    '5|Verification - premier rachat',
]

function asDemandeRachatEvent(formulaire, action, nombreEtapes = 4) {
    const demandeRachatSteps = nombreEtapes === 5 ? demandeRachatStepsAvecPreuves : demandeRachatStepsSansPreuves
    return {
        event: 'rachats_actions',
        link_text: action,
        step: demandeRachatSteps[formulaire.stepIndex],
        type_page: formulaire.option,
        choix_du_compte: formulaire.regime,
        montant_rachat: formulaire.choixMontant,
        nombre_action: formulaire.montantSaisi,
        proceder_au_rachat: formulaire.moment,
        motif: formulaire.motif?.key,
        rachat_subsequent: formulaire.motif?.subsequent,
        ...getRachatOptions()
    }

    function getRachatOptions() {
        if (formulaire.option === 'compteBancaire')
            return {
                nom_institution: formulaire.depotBancaire?.institutionNom
            }
        if (formulaire.option === 'autreInstitution')
            return {
                nom_institution: formulaire.transfert?.nomInstitutionFinanciere,
                adresse_institution: formulaire.transfert?.adresse
            }
        if (formulaire.option === 'batirente')
            return {
                statut_batirente: formulaire.batirente?.statut
            }
    }
}


const CollectePreuvesRachatComponent = {
    selector: 'rachatsEtapesCollectePreuves',
    templateUrl: 'app/components/rachats/etapes/collecte-preuves.html',
    bindings: {
        formulaire: '<',
        fichiers: '<'
    },

    controller: class {
        formulaire
        #coordonneesService

        dateDeNaissance = "4000-01-01"
        loading
        situation

        #motifByValue = {
            '06': 'retraite45AnsOuPlus',
            '07': 'retraite50AnsOuPlusDecoulantCessationDeTravail',
            '02': 'retraite55Ans',
            '09': 'retraite60AnsEtPlus'
        }

        static $inject = ['coordonneesService']
        constructor(coordonneesService) {
            this.#coordonneesService = coordonneesService

            this.loading = new Task(this.#load())
        }

        $onInit() {
            if(this.formulaire?.motif?.raison)
                this.situation = this.#situationFromRaison()
        }

        async #load() {
            this.dateDeNaissance = await this.#coordonneesService.getActionnaire()
                .then(actionnaire => actionnaire?.dateDeNaissance)
        }

        get ageActionnaire() {
            return DateUtils.ageToday(DateUtils.from(this.dateDeNaissance))
        }

        get raison() {
            return this.formulaire.motif.raison
        }

        set raison(value) {
            this.formulaire.motif.raison = value
            this.formulaire.motif.key = this.#motifFromRaison()
            this.situation = this.#situationFromRaison()
        }

        get situation() {
            return this.situation
        }

        #motifFromRaison() {
            const motifDigit = this.formulaire.motif.raison?.slice(0,2)
            return this.#motifByValue[motifDigit]
        }

        #situationFromRaison() {
            return this.formulaire.motif.raison?.slice(3)
        }
    }
}

makeComponent(CollectePreuvesRachatComponent)
class DemandeRachatBridge {
    static get adresseBatirente() {
        return {
            auxSoinsDe: "a/s Desjardins Sécurité financière",
            numeroCivique: "C.P. 1355",
            rue: "Succursale Desjardins",
            ville: "Montréal",
            codePostal: "H5B 1C4",
            province: "QC",
            pays: "Canada"
        }
    }

    static toDemandeRachat(formulaire) {
        return {
            motif: formulaire.motif?.key,
            choixMontant: {
                toutesActionsAdmissibles: formulaire.choixMontant === 'actionsAdmissibles' ? true : undefined,
                montantBrut: formulaire.choixMontant === 'montant' || formulaire.choixMontant === 'montantAvantImpots' ? formulaire.montantSaisi : undefined,
                montantNet: formulaire.choixMontant === 'montantApresImpots' ? formulaire.montantSaisi : undefined,
            },
            meilleureValeur: formulaire.moment === 'meilleureValeur',
            depotBancaire: formulaire.option === 'compteBancaire' ? formulaire.depotBancaire : undefined,
            transfert: this.toTransfert(formulaire),
        }
    }

    static toTransfert(formulaire) {
        switch (formulaire.option) {
            case 'autreInstitution':
                return this.toTransfertAutreInstitution(formulaire.transfert)
            case 'batirente':
                return this.toTransfertBatirente(formulaire.batirente)
            default:
                return undefined
        }
    }

    static toTransfertAutreInstitution(transfert) {
        return {
            beneficiaire: {
                nom: transfert.nomInstitutionFinanciere,
                numeroCompte: transfert.numeroCompte,
                adresse: transfert.adresse
            }
        };
    }

    static toTransfertBatirente(batirente) {
        let transfert = {
            beneficiaire: {
                nom: 'BÂTIRENTE',
                adresse: DemandeRachatBridge.adresseBatirente
            }
        }
        if (batirente.statut === 'membre')
            transfert.beneficiaire.numeroCompte = batirente.numeroCompte
        else
            transfert.numeroTelephoneOuvertureCompteBatirente = batirente.telephone

        return transfert
    }

    static asPresentable(demandeRachat, languageService, institutionsFinancieres) {
        return {
            regime: getRegime(),
            montantBrut: getMontantBrut(),
            montantNet: getMontantNet(),
            destination: getDestination(),
            dateDemande: getDateDemande(),
            typeRachat: getOptionForTypeRachat(),
        }

        function getRegime() {
            return languageService.lang === langueEnum.anglais ? 'RRSP' : 'REER'
        }

        function getMontantBrut() {
            if (demandeRachat.modeDePaiement === rachatModePaiementEnum.depotBancaire && demandeRachat.montantBrut !== undefined)
                return demandeRachat.montantBrut

            if (demandeRachat.modeDePaiement === rachatModePaiementEnum.transfert)
                return demandeRachat.montantBrut
        }

        function getMontantNet() {
            return demandeRachat.modeDePaiement === rachatModePaiementEnum.depotBancaire && demandeRachat.montantNet !== undefined
                ? demandeRachat.montantNet
                : undefined
        }

        function getDestination() {
            if (demandeRachat.modeDePaiement === rachatModePaiementEnum.depotBancaire) {
                const numeroInstitution = demandeRachat.numeroInstitution
                const institution = institutionsFinancieres.filter(institution => institution.numero === numeroInstitution)[0]
                return institution?.nom ?? numeroInstitution
            }

            if (demandeRachat.modeDePaiement === rachatModePaiementEnum.transfert)
                return demandeRachat.beneficiaire
        }

        function getDateDemande() {
            return demandeRachat.dateCreation
        }

        function getOptionForTypeRachat() {
            if (demandeRachat.beneficiaire === 'Bâtirente')
                return 'batirente'
            if (demandeRachat.modeDePaiement === rachatModePaiementEnum.depotBancaire)
                return 'compteBancaire'
            return 'autreInstitution'
        }
    }
}
const DestinationFondsComponent = {
    selector: 'rachatsEtapesDestinationFonds',
    templateUrl: 'app/components/rachats/etapes/destination-fonds.html',
    bindings: {
        formulaire: '<'
    }
}

makeComponent(DestinationFondsComponent)
const DestinationAutreInstitutionGuideComponent = {
    selector: 'rachatsEtapesDestinationAutreInstitutionGuide',
    templateUrl: 'app/components/rachats/etapes/destination/destination-autre-institution-guide.html',
    bindings: {
        formulaire: '<'
    },

    controller: class {
        formulaire
        institutionsList
        institutionChoices
        critereRecherche

        static $inject = ['rachatsService', 'languageService', 'coordonneesService']

        constructor(rachatsService, languageService, coordonneesService) {
            this.rachats = rachatsService
            this.languageService = languageService
            this.coordonneesService = coordonneesService

            this.institutionChoices = []
            this.critereRecherche = ''
        }

        async $postLink() {
            await this.#chargementDesFournisseursServicesFinanciers()
            await this.#recupererCodePostalEtNumeroCivique()
        }

        get estCompteReerOuFeer() {
            return this.formulaire.transfert?.typeCompte === 'reerOuFerr'
        }

        get estCompteBancaire() {
            return this.formulaire.transfert?.typeCompte === 'compteBancaire'
        }

        get estCompteExistant() {
            return this.formulaire.transfert?.compteExistant === 'oui'
        }

        get estCompteInexistant() {
            return this.formulaire.transfert?.compteExistant === 'non'
        }

        get resultatRechercheVide() {
            return this.institutionChoices.length === 0
        }

        get estAdresseSimilaire() {
            const adresseTransfert = this.formulaire?.transfert?.adresse
            const adresseCoordonnees = this.coordonnees?.adresse

            if (adresseTransfert == null || adresseCoordonnees == null) {
                return false
            }
            
            return this.#upperCaseEtSansEspace(adresseTransfert.numeroCivique) === this.#upperCaseEtSansEspace(adresseCoordonnees.numeroCivique)
                && this.#upperCaseEtSansEspace(adresseTransfert.codePostal) === this.#upperCaseEtSansEspace(adresseCoordonnees.codePostal)
        }

        rechercheInstitution() {
            if (this.critereRecherche.length === 0) {
                this.institutionChoices = []
                return
            }

            const estAnglais = this.languageService.lang === langueEnum.anglais
            const champsConcatenes = item => [item.nomComplet, item.nomCompletAnglais, item.motsCles].map(c => this.#sansAccent(c)).join(' ')

            const mots = this.#sansAccent(this.critereRecherche).trim().split(/\s+/).map(m => new RegExp(m, 'i'))
            const correspondance = item => mots.every(critere => critere.test(champsConcatenes(item)))

            this.institutionChoices = this.institutionsList.filter(item => correspondance(item))
                .map(item => ({
                    value: estAnglais ? item.nomSurChequeAnglais : item.nomSurCheque,
                    label: estAnglais ? item.nomCompletAnglais : item.nomComplet
                }))
        }

        #sansAccent(str) {
            return str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ?? ''
        }
        
        #upperCaseEtSansEspace(str) {
            return (str ?? '').replace(/\s+/g, '').toUpperCase()
        }

        async #chargementDesFournisseursServicesFinanciers() {
            await this.rachats.getFournisseursServicesFinanciers()
                .then(response => {
                    this.institutionsList = response
                })
        }

        async #recupererCodePostalEtNumeroCivique() {
            await this.coordonneesService.getActionnaire()
                .then(this.#mapCodePostalEtNumeroCivique)
                .then(coordonnees => {
                    this.coordonnees = coordonnees
                })
        }

        #mapCodePostalEtNumeroCivique(actionnaire) {
            return {
                adresse: {
                    codePostal: actionnaire.adresse?.codePostal,
                    numeroCivique: actionnaire.adresse?.numeroCivique
                }
            }
        }
    }
}

makeComponent(DestinationAutreInstitutionGuideComponent)
const DestinationBatirenteComponent = {
    selector: 'rachatsEtapesDestinationBatirente',
    templateUrl: 'app/components/rachats/etapes/destination/destination-batirente.html',
    bindings: {
        formulaire: '<'
    },
    controller: class {
        formulaire
        #coordonneesService

        static $inject = ['coordonneesService']
        constructor(coordonneesService) {
            this.#coordonneesService = coordonneesService
        }

        async $onInit() {
            if (this.formulaire.batirente)
                return

            this.formulaire.batirente = {}
            this.formulaire.batirente.telephone = await this.#coordonneesService.getActionnaire()
                .then(actionnaire => actionnaire.telephones?.principal)
        }
    }
}

makeComponent(DestinationBatirenteComponent)
const DestinationCompteBancaireComponent = {
    selector: 'rachatsEtapesDestinationCompteBancaire',
    templateUrl: 'app/components/rachats/etapes/destination/destination-compte-bancaire.html',
    bindings: {
        compte: '<'
    },
    controller: class {
        compte
    }
}

makeComponent(DestinationCompteBancaireComponent)
const DetailsRachatComponent = {
    selector: 'rachatsEtapesDetailsRachat',
    templateUrl: 'app/components/rachats/etapes/details-rachat.html',
    bindings: {
        formulaire: '<'
    },

    controller: class {
        #rachatsService;
        #languageService;

        formulaire
        errorMontantTropGrand
        errorMontantTropPetit

        loading
        adhesions
        alwaysInvalid = undefined // used to produce an invalid input
        #periodeMeilleureValeur
        #motif

        static $inject = ['rachatsService', 'languageService']
        constructor(rachatsService, languageService) {
            this.#rachatsService = rachatsService
            this.#languageService = languageService
        }

        async $onInit() {
            this.#resetChoixMontant()
            this.loading = new Task(this.#load())
        }

        async #load() {
            const motifsEligibles = await this.#rachatsService.getEligibilite()
            const rachatsAdmissibles = motifsEligibles?.motifsEligibles[this.formulaire.motif?.key]

            this.adhesions = rachatsAdmissibles.adhesions.filter(a => a.regime === regimeEnum.enregistre && a.montantAdmissible > 0)
            this.#periodeMeilleureValeur = rachatsAdmissibles.periodeMeilleureValeur
            this.#motif = rachatsAdmissibles.motif

            const calculateur = new CalculateurImpotsRachat()
            calculateur.ajoutInformationsImpot(this.adhesions)

            if (!this.isPeriodeMeilleureValeur)
                this.formulaire.moment = 'immediatement'
        }

        #resetChoixMontant() {
            if (this.formulaire.choixMontant === null)
                return

            const valeursValides = this.isEncaissement
                ? ['actionsAdmissibles', 'montantAvantImpots', 'montantApresImpots']
                : ['actionsAdmissibles', 'montant']

            if (!valeursValides.includes(this.formulaire.choixMontant))
                this.formulaire.choixMontant = null
        }

        get isEncaissement() {
            return this.formulaire.option === 'compteBancaire'
        }

        get isPeriodeMeilleureValeur() {
            if (!this.#motif?.supporteMeilleureValeur || !this.#periodeMeilleureValeur)
                return false

            return DateUtils.isBetween(
                this.dateDuJour,
                this.#periodeMeilleureValeur.dateDebut,
                this.#periodeMeilleureValeur.dateFin
            )
        }

        getLang() {
            return this.#languageService.lang
        }

        get dateDuJour() {
            return DateUtils.today().toString()
        }

        get isMontant() {
            return this.formulaire.choixMontant === 'montant'
                || this.formulaire.choixMontant === 'montantAvantImpots'
                || this.formulaire.choixMontant === 'montantApresImpots'
        }

        get validateMontant() {
            if (!this.isMontant || (!this.formulaire.montantSaisi && this.formulaire.montantSaisi !== 0))
                return

            const montant = this.formulaire.choixMontant === 'montantApresImpots' ? this.formulaire.montantNet : this.formulaire.montantBrut

            if (this.formulaire.montantSaisi > montant)
                return this.errorMontantTropGrand

            if (this.formulaire.montantSaisi < 1000)
                return this.errorMontantTropPetit
        }

        adhesionChange(adhesion) {
            this.formulaire.montantBrut = adhesion.montantAdmissible
            this.formulaire.montantNet = adhesion.montantNet
            this.formulaire.regime = adhesion.regime
        }
    }
}

makeComponent(DetailsRachatComponent)
const ChoixOptionRachatComponent = {
    selector: 'rachatsEtapesChoixOptionRachat',
    templateUrl: 'app/components/rachats/etapes/option-rachat/choix-option-rachat.html',
    bindings: {
        formulaire: '<',
        onNext: '&',
        onBack: '&'
    },
    controller: class {
        onNext
        onBack

        formulaire
        static $inject = [GtmService.dependency]
        constructor(gtmService) {
            this.gtmService = gtmService
        }

        navigateBack(){
            this.#sendEvent('Retour')
            this.onBack()
        }

        setOption(option) {
            this.formulaire.option = option
            this.#sendEvent(option)

            if (option !== 'autreInstitution') return

            this.onNext()
        }

        #sendEvent(action) {
            const stepSuffix = this.formulaire.stepIndex > 0 ? ' - premier rachat' : ''
            this.gtmService.event({
                event: 'rachats_actions',
                step: `${this.formulaire.stepIndex + 1}|Option de rachat${stepSuffix}`,
                link_text: action,
                type_page: 'Generique'
            })
        }
    }
}

makeComponent(ChoixOptionRachatComponent)
let MinicardComponent = {
    selector: 'minicard',
    templateUrl: 'app/components/rachats/etapes/option-rachat/minicard.html',
    bindings: {
        imagePath: '@',
        titre: '@',
        text: '@'
    },
    controller: class MinicardController {

    }
}

makeComponent(MinicardComponent)
const OptionRachatComponent = {
    selector: 'rachatsEtapesOptionRachat',
    template: `
        <rachats-etapes-choix-option-rachat data-ng-if="$ctrl.formulaire.option !== 'compteBancaire' && $ctrl.formulaire.option !== 'batirente'" formulaire="$ctrl.formulaire" on-next="$ctrl.onNext()" on-back="$ctrl.onBack()">
        </rachats-etapes-choix-option-rachat>
        <rachats-etapes-parenthese-depot-direct data-ng-if="$ctrl.formulaire.option === 'compteBancaire'" formulaire="$ctrl.formulaire" on-next="$ctrl.onNext()">
        </rachats-etapes-parenthese-depot-direct>
        <rachats-etapes-parenthese-batirente data-ng-if="$ctrl.formulaire.option === 'batirente'" formulaire="$ctrl.formulaire" on-next="$ctrl.onNext()">
        </rachats-etapes-parenthese-batirente>`,
    bindings: {
        formulaire: '<',
        onNext: '&',
        onBack: '&'
    }
}

makeComponent(OptionRachatComponent)
const ParentheseBatirenteComponent = {
    selector: 'rachatsEtapesParentheseBatirente',
    templateUrl: 'app/components/rachats/etapes/option-rachat/parenthese-batirente.html',
    bindings: {
        formulaire: '<',
        onNext: '&'
    },
    controller: class {
        formulaire
        static $inject = [GtmService.dependency]
        constructor(gtmService) {
            this.gtmService = gtmService
        }

        back(){
            this.#sendEvent('Retour')
            this.formulaire.option = null
        }

        confirm() {
            this.onNext()
        }

        #sendEvent(action) {
            const stepSuffix = this.formulaire.stepIndex > 0 ? ' - premier rachat' : ''
            this.gtmService.event({
                event: 'rachats_actions',
                step: `${this.formulaire.stepIndex + 1}|Option de rachat${stepSuffix}`,
                link_text: action,
                type_page: 'batirente'
            })
        }
    }
}

makeComponent(ParentheseBatirenteComponent)
const ParentheseDepotDirectComponent = {
    selector: 'rachatsEtapesParentheseDepotDirect',
    templateUrl: 'app/components/rachats/etapes/option-rachat/parenthese-depot-direct.html',
    bindings: {
        formulaire: '<',
        onNext: '&'
    },
    controller: class {
        formulaire
        static $inject = [GtmService.dependency]
        constructor(gtmService) {
            this.gtmService = gtmService
        }

        goToBatirente() {
            this.#sendEvent('batirente')
            this.formulaire.option = 'batirente'
        }

        back(){
            this.#sendEvent('Retour')
            this.formulaire.option = null
        }

        confirm() {
            this.onNext()
        }

        #sendEvent(action) {
            const stepSuffix = this.formulaire.stepIndex > 0 ? ' - premier rachat' : ''
            this.gtmService.event({
                event: 'rachats_actions',
                step: `${this.formulaire.stepIndex + 1}|Option de rachat${stepSuffix}`,
                link_text: action,
                type_page: 'compteBancaire'
            })
        }
    }
}

makeComponent(ParentheseDepotDirectComponent)
const QuestionsReponsesComponent = {
    selector: 'rachatsEtapesQuestionsReponses',
    templateUrl: 'app/components/rachats/etapes/option-rachat/questions-reponses.html',
}

makeComponent(QuestionsReponsesComponent)
const RecapitulatifComponent = {
    selector: 'rachatsEtapesRecapitulatif',
    templateUrl: 'app/components/rachats/etapes/recapitulatif.html',
    bindings: {
        formulaire: '<'
    },
    controller: class {
        languageService;
        formulaire
        choixTotalite
        choixTotaliteMeilleureValeur
        choixMontant
        choixMontantBrut
        choixMontantNet
        immediatement
        meilleureValeur

        static $inject = ['languageService']
        constructor(languageService) {
            this.languageService = languageService
        }

        get isEncaissement() {
            return this.formulaire.option === 'compteBancaire'
        }

        getLang() {
            return this.languageService.lang
        }

        get dateDuJour() {
            return DateUtils.today().toString()
        }

        get isMontantAdmissible() {
            return this.formulaire.choixMontant === 'actionsAdmissibles'
        }

        get displayTelephone() {
            return verificationDisplayTelephone(this.formulaire.batirente.telephone, null)
        }

        get displayAddress() {
            return verificationDisplayAddress(this.formulaire.transfert.adresse)
        }

        afficherChoix() {
            if (this.formulaire.choixMontant === 'actionsAdmissibles' && this.formulaire.moment === 'meilleureValeur')
                return this.choixTotaliteMeilleureValeur

            if (this.formulaire.choixMontant === 'actionsAdmissibles')
                return this.choixTotalite

            if (this.formulaire.choixMontant === 'montantAvantImpots')
                return this.choixMontantBrut

            if (this.formulaire.choixMontant === 'montantApresImpots')
                return this.choixMontantNet

            return this.choixMontant
        }

        afficherMontant() {
            if (this.formulaire.choixMontant === 'montant'
                || this.formulaire.choixMontant === 'montantAvantImpots'
                || this.formulaire.choixMontant === 'montantApresImpots')
                return this.formulaire.montantSaisi

            return this.formulaire.montantBrut
        }

        afficherMoment() {
            if (this.formulaire.moment === 'meilleureValeur')
                return this.meilleureValeur

            return this.immediatement
        }
    }
}

makeComponent(RecapitulatifComponent)
const TransactionCompleteeComponent = {
    selector: 'rachatsEtapesTransactionCompletee',
    templateUrl: 'app/components/rachats/etapes/transaction-completee.html',
    bindings: {
        demandeRachatId: '<'
    },

    controller: class {
        #rachats
        #languageService
        #institutionFinanciereService
        #authenticationService

        demandeRachatId

        loading
        #demandeRachat
        #presentableDemandeRachat
        loggedEmail

        static $inject = [RachatsService.dependency, LanguageService.dependency, InstitutionFinanciereService.dependency, AuthenticationService.dependency, GtmService.dependency, '$window', '$location']

        constructor(rachatsService, languageService, institutionFinanciereService, authenticationService, gtmService, $window, $location) {
            this.#rachats = rachatsService
            this.#languageService = languageService
            this.#institutionFinanciereService = institutionFinanciereService
            this.#authenticationService = authenticationService
            this.gtmService = gtmService
            this.$window = $window
            this.$location = $location
        }

        async $onInit() {
            this.loggedEmail = this.#authenticationService.loggedEmail()
            this.loading = new Task(this.#load())
        }

        async #load() {
            const institutionsFinancieres = await this.#institutionFinanciereService.getInstitutionsFinancieres()
            this.#demandeRachat = await this.#rachats.getDemandeRachat(this.demandeRachatId)

            this.#presentableDemandeRachat = DemandeRachatBridge.asPresentable(this.#demandeRachat, this.#languageService, institutionsFinancieres)
        }

        get regime() {
            return this.#presentableDemandeRachat?.regime
        }

        get montantBrut() {
            return this.#presentableDemandeRachat?.montantBrut
        }

        get montantNet() {
            return this.#presentableDemandeRachat?.montantNet
        }

        get destination() {
            return this.#presentableDemandeRachat?.destination
        }

        get dateDemande() {
            return this.#presentableDemandeRachat?.dateDemande
        }

        get afficherMontant() {
            return this.#demandeRachat?.actionsAdmissibles === false
        }

        get afficherToutesLesActionsAdmissibles() {
            return this.#demandeRachat?.actionsAdmissibles === true && this.#demandeRachat?.meilleureValeur === false
        }

        get afficherToutesLesActionsAdmissiblesMeilleureValeur() {
            return this.#demandeRachat?.actionsAdmissibles === true && this.#demandeRachat?.meilleureValeur === true
        }

        get afficherMontantBrut() {
            return this.#demandeRachat?.montantBrut !== null && (this.#demandeRachat?.actionsAdmissibles === false || this.#demandeRachat?.actionsAdmissibles === true && this.#demandeRachat?.meilleureValeur === false)
        }

        get afficherMontantNet() {
            return this.#demandeRachat?.montantBrut === null
        }

        get afficherTextePourMontantBrut() {
            return this.#demandeRachat?.modeDePaiement === "depotBancaire" && this.#demandeRachat?.montantBrut !== null && this.#demandeRachat?.actionsAdmissibles === false
        }

        get afficherNouveauMembreBatirente() {
            return this.#demandeRachat?.ouvrirCompteBatirente === true
        }

        handleFinish() {
            this.#sendGtmEvent('Retour à mon portefeuille')
            this.$location.path('/')
        }

        handlePrint() {
            this.#sendGtmEvent('Imprimer cette page')
            this.$window.print()
        }

        #sendGtmEvent(action) {
            this.gtmService.event({
                event: 'rachats_actions',
                step: 'Demande finalisée',
                link_text: action,
                type_page: this.#presentableDemandeRachat?.typeRachat
            })
        }
    }
}

makeComponent(TransactionCompleteeComponent)
const IntroductionComponent = {
    selector: 'rachatsIntroduction',
    templateUrl: 'app/components/rachats/introduction.html',
    bindings: {
        demandesRachatNonCompletees: '='
    },

    controller: class IntroductionComponentController {
        adhesion
        featureSwitchService
        demandesRachatNonCompletees

        static $inject = ['rachatsService', 'languageService', '$location', GtmService.dependency]

        constructor(rachatsService, languageService, $location, gtmService) {
            this.rachatsService = rachatsService
            this.languageService = languageService
            this.$location = $location
            this.gtmService = gtmService
        }

        async $onInit() {
            await this.#chargerEligibilite()
        }

        getLang() {
            return this.languageService.lang
        }

        get dateDuJour() {
            return DateUtils.today().toString()
        }

        async #chargerEligibilite() {
            try {
                this.adhesion = await this.rachatsService.adhesionEligibleRachatLibreService()
            } catch (error) {
                console.error('Erreur lors du chargement des rachats admissibles', error)
            }
        }

        hasDemandesNonCompletees() {
            return this.demandesRachatNonCompletees.length > 0
        }

        startRachatProcess() {
            this.gtmService.event({
                event: 'rachats_actions',
                step: 'Clic Racheter vos actions',
                link_text: 'Racheter vos actions',
                type_page: 'Generique'
            })
            this.$location.path('/actionnaires/demandeRachat')
        }
    }
}

makeComponent(IntroductionComponent)
const ParcoursLibreServiceComponent = {
    selector: 'rachatsParcoursLibreService',
    templateUrl: 'app/components/rachats/parcours-libre-service.html',
    bindings: {rechargerPortefeuille: '&'},

    controller: class {
        #sessionStorage
        #location
        #rachatsService
        #gtmService
        show
        affichePagePreuves
        erreur
        rechargerPortefeuille

        static $inject = ['$sessionStorage', '$location', 'rachatsService', GtmService.dependency]
        constructor(sessionStorage, location, rachatsService, gtmService) {
            this.#sessionStorage = sessionStorage
            this.#location = location
            this.#rachatsService = rachatsService
            this.#gtmService = gtmService

            this.#sessionStorage.$default({formRachatLibreService: this.#getDefaultFormulaire()})
            this.show = false
            this.affichePagePreuves = false
        }

        async $onInit() {
            const eligibilite = await this.#rachatsService.getEligibilite()
            const motifs = Object.entries(eligibilite.motifsEligibles || {})

            if (motifs.length === 0) {
                this.#supprimeSessionEtRredirigeAuPortefeuille()
                return
            }

            if (motifs.length === 1) {
                const [motifKey, motifData] = motifs[0]
                const estSubsequent = motifData.adhesions[0].estRachatSubsequent
                this.affichePagePreuves = !(motifKey === 'motif65Ans' || estSubsequent);
                this.#updateMotifFormulaire(motifKey, estSubsequent)
            } else {
                this.affichePagePreuves = true
            }

            this.show = true
        }

        get formulaire() {
            return this.#sessionStorage.formRachatLibreService
        }

        #supprimeSessionEtRredirigeAuPortefeuille() {
            delete this.#sessionStorage.formRachatLibreService
            this.#location.path('/')
        }

        #getDefaultFormulaire() {
            return {
                stepIndex: 0,
                depotBancaire: {},
                motif: {
                    key:'',
                    subsequent:false
                }
            }
        }

        #updateMotifFormulaire(motif, subsequent) {
            this.formulaire.motif = {
                key: motif,
                subsequent: subsequent
            }
        }
    }
}

makeComponent(ParcoursLibreServiceComponent)
class _rachatsAbstractController {
    wizard
    #submitButtonLabel
    #sessionStorage
    #location
    #rachatsService
    #gtmService
    demandeRachatId
    transfertBatirente
    transfertAutre
    encaisser
    fichiers
    erreurFichierManquant
    erreurFichierTropVolumineux
    rechargerPortefeuille

    static $inject = ['$sessionStorage', '$location', 'rachatsService', GtmService.dependency]
    constructor(sessionStorage, location, rachatsService, gtmService) {
        this.#sessionStorage = sessionStorage
        this.#location = location
        this.#rachatsService = rachatsService
        this.#gtmService = gtmService
        this.fichiers = []
    }

    get formulaire() {
        return this.#sessionStorage.formRachatLibreService
    }

    get afficherTitreSelonOption() {
        switch (this.formulaire?.option) {
            case 'batirente':
                return this.transfertBatirente
            case 'autreInstitution':
                return this.transfertAutre
            case 'compteBancaire':
                return this.encaisser
        }
    }

    get nombreEtapes() {
        return 4
    }

    get destinationFondsStepIndex() {
        return 2
    }

    get optionRachatStepIndex() {
        return 0
    }

    #submitProgress(event) {
        if (event.lengthComputable) {
            const progress = Math.round((event.loaded / event.total) * 100)
            this.wizard.submitButtonLabel = `${this.#submitButtonLabel} - ${progress}%`
        }
    }

    async submit() {
        this.#submitButtonLabel = this.#submitButtonLabel ?? this.wizard.submitButtonLabel
        this.erreur = null

        if (this.#fichierRequis() && this.fichiers.length === 0) {
            this.erreur = this.erreurFichierManquant
            return false
        }

        try {
            const demande = DemandeRachatBridge.toDemandeRachat(this.formulaire)

            const creationData = await this.#rachatsService.createDemandeRachat(
                this.formulaire.numeroAdhesion,
                demande,
                this.fichiers,
                this.#submitProgress.bind(this)
            )

            this.#sendEvent('Finaliser')
            this.demandeRachatId = creationData.id
            delete this.#sessionStorage.formRachatLibreService
            this.fichiers = []
            this.rechargerPortefeuille()

            return true
        } catch (e) {
            this.erreur = e.status === 413 ? this.erreurFichierTropVolumineux : e.message
            return false
        }
    }

    onNext() {
        if (!this.#isDestinationAutreInstitutionGuide()) {
            this.#sendEvent('Continuer')
            return
        }

        if (this.formulaire.transfert.typeCompte === 'compteBancaire')
            this.#redirectTo('compteBancaire')

        else if (this.formulaire.transfert.compteExistant === 'non')
            this.#redirectTo('batirente')

        else
            this.#sendEvent('Continuer')
    }

    onBack() {
        this.#sendEvent('Retour')
    }

    cancel() {
        this.#sendEvent('Annuler')
        this.#supprimeSessionEtRedirigeAuPortefeuille()
    }

    #supprimeSessionEtRedirigeAuPortefeuille() {
        delete this.#sessionStorage.formRachatLibreService
        this.#location.path('/')
    }

    #isDestinationAutreInstitutionGuide()
    {
        return this.formulaire.stepIndex === this.destinationFondsStepIndex
            && this.formulaire.option === 'autreInstitution'
    }

    #redirectTo(option) {
        this.#sendEvent(option)

        this.formulaire.stepIndex = this.optionRachatStepIndex
        this.formulaire.option = option
    }

    #sendEvent(action) {
        this.#gtmService.event(asDemandeRachatEvent(this.formulaire, action, this.nombreEtapes))
    }

    #fichierRequis() {
        return !(this.formulaire.motif.key === 'motif65Ans' || this.formulaire.motif.subsequent)
    }
}
const AutresMotifsRetraiteComponent = {
    selector: 'rachatsAutresMotifsRetraite',
    templateUrl: 'app/components/rachats/wizards/autres-motifs-retraite.html',
    bindings: {rechargerPortefeuille: '&'},

    controller: class extends _rachatsAbstractController {
        get nombreEtapes() { return 5 }
        get destinationFondsStepIndex() { return 3 }
        get optionRachatStepIndex() { return 1 }
    }
}

makeComponent(AutresMotifsRetraiteComponent)
const SoixanteCinqAnsOuSubsequentComponent = {
    selector: 'rachatsSoixanteCinqAnsOuSubsequent',
    templateUrl: 'app/components/rachats/wizards/soixante-cinq-ou-subsequent.html',
    bindings: {rechargerPortefeuille: '&'},

    controller: class extends _rachatsAbstractController {
    }
}

makeComponent(SoixanteCinqAnsOuSubsequentComponent)
class DemandeRemboursementAbstractController {

    demandeRemboursement = {
        compte: {},
        erreurs: {}
    }

    constructor($uibModal) {
        this.$uibModal = $uibModal
    }

    #montantRemboursementsEnTraitement() {
        return this.transactionsEnTraitement
            .filter(t => t.typeCotisation === this.typeCotisation)
            .map(t => t.montant)
            .reduce((total, montant) => total + montant, 0)
    }

    soldeAnnuelIncluantLesRemboursementsEnTraitement() {
        return parseFloat((this.montantRestantAnnuel - this.#montantRemboursementsEnTraitement()).toFixed(2))
    }

    soldeApresCeRemboursement() {
        const solde = this.soldeAnnuelIncluantLesRemboursementsEnTraitement() - montantToDecimal(this.demandeRemboursement.montant)
        return solde < 0 ? 0 : solde
    }

    // Validation

    montantMaximum = () => this.soldeAnnuelIncluantLesRemboursementsEnTraitement()

    validerNouveauRemboursement () {
        if (this.#demandeValide()) {
            this.#confirmer()
        }
    }

    #confirmer() {
        this.$uibModal.open({
            component: RemboursementConfirmationModalComponent.selector,
            windowClass: 'confirmation-modal',
            resolve: {
                demande: () => this.demandeRemboursement,
                creerRemboursement: () => (demande) => this.creerRemboursement(demande),
                gtmStepName: () => this.gtmStepName,
                nextUrl: () => this.nextUrl,
                rechargerPortefeuille: () => this.rechargerPortefeuille
            }
        })
    }

    #demandeValide() {
        this.#validerMontant(this.demandeRemboursement.montant)
        this.#validerCompteBancaire()
        this.#validerConfirmation(this.demandeRemboursement.confirmationTitulaireCompte)
        return !this.formulaireEnErreur()
    }

    #validerMontant(montant) {
        this.demandeRemboursement.erreurs.montant = montant === undefined
        this.demandeRemboursement.erreurs.montantMin = montant !== undefined && montantToDecimal(montant) < Math.min(10, this.soldeAnnuelIncluantLesRemboursementsEnTraitement())
        this.demandeRemboursement.erreurs.montantMax = montant !== undefined && montantToDecimal(montant) > this.montantMaximum()
    }

    #validerCompteBancaire() {
        this.demandeRemboursement.erreurs.institution = this.demandeRemboursement.compte.institution === undefined
        this.demandeRemboursement.erreurs.transit = this.demandeRemboursement.compte.transit === undefined
        this.demandeRemboursement.erreurs.numeroCompte = this.demandeRemboursement.compte.numero === undefined
        this.demandeRemboursement.erreurs.transitDansInstitution = this.demandeRemboursement.compte.valid === false
    }

    #validerConfirmation(confirmation) {
        this.demandeRemboursement.erreurs.confirmationTitulaireCompte = (confirmation === undefined || confirmation === false)
    }

    formulaireEnErreur() {
        return this.demandeRemboursement.erreurs.montant || this.demandeRemboursement.erreurs.montantMin || this.demandeRemboursement.erreurs.montantMax
            || this.demandeRemboursement.erreurs.institution || this.demandeRemboursement.erreurs.transit || this.demandeRemboursement.erreurs.transitDansInstitution
            || this.demandeRemboursement.erreurs.numeroCompte || this.demandeRemboursement.erreurs.confirmationTitulaireCompte
    }
}


const DemandeRemboursementRapComponent = {
    selector: 'demandeRemboursementRap',
    templateUrl: 'app/components/rap-reep/demande-remboursement-rap.html',
    bindings: {
        loadingPortefeuille: '<',
        portefeuille: '<',
        sansAdhesion : '<',
        rap : '<',
        transactionsEnTraitement : '<',
        rechargerPortefeuille: '&'
    },
    controller: class DemandeRemboursementRapController extends DemandeRemboursementAbstractController {
        typeCotisation = 'pageRap'
        nextUrl = '/rap'
        gtmStepName = 'Remboursement RAP'

        static $inject = ['$uibModal', 'rapReepService']
        constructor($uibModal, rapReepService) {
            super($uibModal)
            this.rapReepService = rapReepService
        }

        get montantRestantAnnuel() {
            return this.rap.montantRestantAnnuel
        }

        creerRemboursement(demande) {
            return this.rapReepService.creerRemboursementRap(demande)
        }
    }
}

makeComponent(DemandeRemboursementRapComponent)

const DemandeRemboursementReepComponent = {
    selector: 'demandeRemboursementReep',
    templateUrl: 'app/components/rap-reep/demande-remboursement-reep.html',
    bindings: {
        loadingPortefeuille: '<',
        portefeuille: '<',
        sansAdhesion : '<',
        reep : '<',
        transactionsEnTraitement : '<',
        rechargerPortefeuille: '&'
    },
    controller: class DemandeRemboursementReepController extends DemandeRemboursementAbstractController {
        typeCotisation = 'pageReep'
        nextUrl = '/reep'
        gtmStepName = 'Remboursement REEP'

        static $inject = ['$uibModal', 'rapReepService']
        constructor($uibModal, rapReepService) {
            super($uibModal)
            this.rapReepService = rapReepService
        }

        get montantRestantAnnuel() {
            return this.reep.montantRestantAnnuel
        }

        creerRemboursement(demande) {
            return this.rapReepService.creerRemboursementReep(demande)
        }
    }
}

makeComponent(DemandeRemboursementReepComponent)

const RapComponent = {
    selector: 'rap',
    templateUrl: 'app/components/rap-reep/rap.html',
    bindings: {
        loadingPortefeuille: '<',
        portefeuille: '<',
        sansAdhesion: '<',
        rap: '<',
        documents: '<',
        transactionsEnTraitement: '<'
    },
    controller: class RapController {
        static $inject = ['$location']
        constructor($location) {
            this.$location = $location
        }

        demarrerDemande() {
            this.$location.path('/rap/remboursement')
        }

        dernierReleveRAP = () => {
            return this.documents
                .filter(d => d.type === documentTypeEnum.releveRapReep)
                .sort((a, b) => new Date(b.date) - new Date(a.date))[0]
        }

        estUnRemboursementsRap = (t) => t.typeCotisation === 'pageRap'

        afficherRemboursementsEnTraitement = () => this.transactionsEnTraitement.filter(this.estUnRemboursementsRap).length > 0

        soldeAnnuelIncluantLesRemboursementsEnTraitement() {
            const montantRemboursementsEnTraitement = this.transactionsEnTraitement
                .filter(this.estUnRemboursementsRap)
                .map(t => t.montant)
                .reduce((total, montant) => total + montant, 0)

            return this.rap.montantRestantAnnuel - montantRemboursementsEnTraitement
        }

        soldePlusQueZero = () => this.soldeAnnuelIncluantLesRemboursementsEnTraitement() > 0

        sansAdhesionEnregistree = () => this.portefeuille.adhesions2.some(a => a.regime === regimeEnum.enregistre)

        peutRembourser = () => this.soldePlusQueZero() && this.sansAdhesionEnregistree()

        estEnAnneeDeSursis = () => this.rap.estEnSursis

        estEnPremiereDeAnneeDeRemboursement = () => this.rap.anneeImposition === this.rap.premiereAnneeRembousement
    }
}

makeComponent(RapComponent)
const ReepComponent = {
    selector: 'reep',
    templateUrl: 'app/components/rap-reep/reep.html',
    bindings: {
        loadingPortefeuille: '<',
        portefeuille: '<',
        sansAdhesion: '<',
        rap: '<',
        reep: '<',
        documents: '<',
        transactionsEnTraitement: '<'
    },
    controller: class ReepController {
        static $inject = ['$location']
        constructor($location) {
            this.$location = $location
        }

        demarrerDemande() {
            this.$location.path('/reep/remboursement')
        }

        dernierReleveREEP = () => {
            return this.documents
                .filter(d => d.type === documentTypeEnum.releveRapReep)
                .sort((a, b) => new Date(b.date) - new Date(a.date))[0]
        }

        estUnRemboursementsReep = (t) => t.typeCotisation === 'pageReep'

        afficherRemboursementsEnTraitement = () => this.transactionsEnTraitement.filter(this.estUnRemboursementsReep).length > 0

        soldeAnnuelIncluantLesRemboursementsEnTraitement() {
            const montantRemboursementsEnTraitement = this.transactionsEnTraitement
                .filter(this.estUnRemboursementsReep)
                .map(t => t.montant)
                .reduce((total, montant) => total + montant, 0)

            return this.reep.montantRestantAnnuel - montantRemboursementsEnTraitement
        }

        soldePlusQueZero = () => this.soldeAnnuelIncluantLesRemboursementsEnTraitement() > 0

        sansAdhesionEnregistree = () => this.portefeuille.adhesions2.some(a => a.regime === regimeEnum.enregistre)

        peutRembourser = () => this.soldePlusQueZero() && this.sansAdhesionEnregistree()
    }
}

makeComponent(ReepComponent)
﻿let RemboursementConfirmationModalComponent = {
    selector: 'remboursementConfirmationModal',
    templateUrl: 'app/components/rap-reep/remboursement-confirmation-modal.html',
    bindings: {
        resolve: '<',
        close: '&'
    },
    controller: class RemboursementConfirmationModalController {
        static $inject = ['$location', 'gtmService']
        constructor($location, gtmService) {
            this.$location = $location
            this.gtmService = gtmService

            this.today = new Date()
            this.erreur = false
        }

        $onInit() {
            this.creerRemboursement = this.resolve.creerRemboursement
            this.demande = this.resolve.demande
            this.gtmStepName = this.resolve.gtmStepName
            this.nextUrl = this.resolve.nextUrl
            this.rechargerPortefeuille = this.resolve.rechargerPortefeuille
        }

        confirmer() {
            this.erreur = false
            this.submitted = true

            const apiDemandeRemboursement = {
                montant: montantToDecimal(this.demande.montant),
                institutionFinanciere: {
                    numero: this.demande.compte.institution,
                    transit: this.demande.compte.transit,
                    numeroCompte: this.demande.compte.numero
                }
            }
            this.creerRemboursement(apiDemandeRemboursement)
                .then(() => {
                    this.sendToGTM(apiDemandeRemboursement)
                    this.rechargerPortefeuille()
                    this.close()
                    this.$location.path(this.nextUrl)
                })
                .catch(() => this.erreur = true)
                .finally(() => this.submitted = false)
        }

        sendToGTM(demande) {
            this.gtmService.event({
                event: 'purchase',
                step: this.gtmStepName,
                contribution_plan: 'unique',
                amount: demande.montant,
                frequency: 'unique'
            })
        }
    }
}

makeComponent(RemboursementConfirmationModalComponent)
const ReleveTransactionsComponent = {
    selector: 'releveTransactions',
    // language=file-reference
    templateUrl: 'app/components/releve-transactions/releve-transactions.html',
    bindings: {
        loadingPortefeuille: '<',
        portefeuille: '<',
        sansAdhesion: '<'
    },
    controller: class ReleveTransactionsController {
        releveParam = {}
        showWaiting = false
        showError = false
        showBadDates = false

        static $inject = ['actionnaireService', 'gtmService', 'languageService']
        constructor(actionnaireService, gtmService, languageService) {
            this.actionnaireService = actionnaireService
            this.gtmService = gtmService
            this.languageService = languageService
        }

        getLang() {
            return this.languageService.lang
        }

        getReleverAsHtml() {
            this.gtmService.event({event: 'generate_lead', step: 'Téléchargement relevé de transactions'})

            this.#corrigerDates()
            this.#resetFlags()

            if (new Date(this.releveParam.dateDebut) > new Date(this.releveParam.dateFin)) {
                this.showBadDates = true
                return
            }

            this.showWaiting = true
            delete this.releveTransactions
            return this.actionnaireService.getReleveTransaction(this.releveParam.adhesion.numeroAdhesion, this.releveParam.dateDebut, this.releveParam.dateFin)
                .then(response => this.releveTransactions = response.data)
                .catch(() => this.showError = true)
                .finally(() => this.showWaiting = false)
        }

        #corrigerDates() {
            const today = new Date()
            const year = today.getFullYear()
            const month = String(today.getMonth() + 1).padStart(2, '0')
            const day = String(today.getDate()).padStart(2, '0')

            if (this.#dateInvalideOuFuture(this.releveParam.dateDebut, today)) {
                this.releveParam.dateDebut = `${year}-01-01`
            }
            if (this.#dateInvalideOuFuture(this.releveParam.dateFin, today)) {
                this.releveParam.dateFin = `${year}-${month}-${day}`
            }
        }

        #dateInvalideOuFuture(date, today) {
            const parsed = new Date(date)
            return parsed >= today || isNaN(parsed)
        }

        #resetFlags() {
            this.showError = false
            this.showWaiting = false
            this.showBadDates = false
        }
    }
}

makeComponent(ReleveTransactionsComponent)

class RssDemandeAbstractController {
    demande = {
        cotisationEmploye: {
            montantPaie: '',
            montantHoraire: '',
            pourcentagePaie: ''
        },
        employeur: undefined,
        intention: undefined,
        typeDeductionImpot: undefined,
        accepteConditions: false,
        erreurs: {}
    }

    constructor($sessionStorage, $location) {
        this.$sessionStorage = $sessionStorage
        this.$location = $location
    }

    $onInit() {
        const demandeRss = this.$sessionStorage.demandeRss
        if (!demandeRss) {
            this.$location.path('/')
            return
        }

        this.demande.employeur = demandeRss.employeur
        this.demande.intention = demandeRss.intention
        this.demande.utilisateurNonEligiblePourDeductionReer = demandeRss.utilisateurNonEligiblePourDeductionReer
        this.demande.cotisationEmploye = demandeRss.cotisationEmploye
        this.demande.typeDeductionImpot = demandeRss.typeDeductionImpot
    }
}

const RssAideDeductionsComponent = {
    selector: 'rssAideDeductions',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-aide-deductions.html'
}

makeComponent(RssAideDeductionsComponent)

const RssArretConfirmationComponent = {
    selector: 'rssArretConfirmation',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-arret-confirmation.html',
    controller: class RssArretConfirmationController {
        erreur = false
        submitted = false
        demande = {}
        raisons = Object.values(arretRssRaisons)

        static $inject = ['$location', 'rssService', 'gtmService', 'languageService']
        constructor($location, rssService, gtmService, languageService) {
            this.$location = $location
            this.rssService = rssService
            this.gtmService = gtmService
            this.languageService = languageService
        }

        // exposes getLang for filters in the template
        getLang() {
            return this.languageService.lang
        }

        arreterRss() {
            this.erreur = false
            this.submitted = true

            const raison = this.demande.raisonArret ? this.demande.raisonArret : arretRssRaisons.nonSpecifie
            this.rssService.arreterRss(raison)
                .then(() => {
                    this.sendToGTM()
                    this.$location.path('/rss')
                })
                .catch(() => this.erreur = true)
                .finally(() => this.submitted = false)
        }

        sendToGTM() {
            this.gtmService.event({
                event: 'stop_contribution',
                step: 'Arrêter RSS',
                contribution_plan: 'retenue sur le salaire'
            })
        }
    }
}

makeComponent(RssArretConfirmationComponent)

const RssArretValidationComponent = {
    selector: 'rssArretValidation',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-arret-validation.html',
    bindings: {
        loadingPortefeuille: '<',
        portefeuille: '<'
    },
    controller: class RssArretValidationController {
        static $inject = ['$location', '$sessionStorage', 'rssService']
        constructor($location, $sessionStorage, rssService) {
            this.$location = $location
            this.$sessionStorage = $sessionStorage
            this.rssService = rssService
        }

        $onInit() {
            this.rssService.getRss()
                .then(rssAvecEmployeur => this.rssAvecEmployeur = rssAvecEmployeur)
        }

        demarrerDemande() {
            this.$sessionStorage.demandeRss = creerDemandeRss(this.rssAvecEmployeur, this.portefeuille.adhesions)
            this.$location.path('/rss/nouvelle/employeur')
        }
    }
}

makeComponent(RssArretValidationComponent)

const RssConfirmationModalComponent = {
    selector: 'rssConfirmationModal',
    templateUrl: 'app/components/rss/rss-confirmation-modal.html',
    bindings: {
        resolve: '<',
        close: '&'
    },
    controller: class RssConfirmationModalController {
        submitted = false
        erreur = false

        static $inject = ['$location', 'rssService', 'languageService', 'gtmService']

        constructor($location, rssService, languageService, gtmService) {
            this.$location = $location
            this.rssService = rssService
            this.languageService = languageService
            this.gtmService = gtmService
        }

        $onInit() {
            this.demande = this.resolve.demande
            this.employeur = this.demande.employeur
            this.intention = this.demande.intention
        }

        creerRss() {
            this.erreur = false
            this.submitted = true

            const apiDemandeRss = {
                numeroResponsableDeRemise: this.employeur.numeroResponsableDeRemise,
                cotisationEmploye: this.cotisationEmployeEnDecimal(),
                typeDeductionImpot: this.demande.typeDeductionImpot
            }

            this.rssService.creerRss(apiDemandeRss)
                .then(() => {
                    this.#sendToGTM()
                    this.close()
                    this.$location.path('/rss')
                })
                .catch(() => this.erreur = true)
                .finally(() => this.submitted = false)
        }

        cotisationEmployeEnDecimal() {
            return {
                montantPaie: montantToDecimal(this.demande.cotisationEmploye.montantPaie),
                montantHoraire: montantToDecimal(this.demande.cotisationEmploye.montantHoraire),
                pourcentagePaie: montantToDecimal(this.demande.cotisationEmploye.pourcentagePaie)
            }
        }

        getLang() {
            return this.languageService.lang
        }

        #sendToGTM() {
            const intentions = {
                [intentionDemandeRss.modification]: 'Modification RSS',
                [intentionDemandeRss.reactivation]: 'Réactivation RSS',
                [intentionDemandeRss.activation]: 'Activation RSS',
                [intentionDemandeRss.demarrer]: 'Demarrer RSS'
            }
            const cotisationEmploye = this.cotisationEmployeEnDecimal()

            this.gtmService.event({
                event: 'purchase',
                step: intentions[this.intention],
                contribution_plan: 'retenue sur le salaire',
                amount_paie: cotisationEmploye.montantPaie,
                amount_heure: cotisationEmploye.montantHoraire,
                amount_pourcentage: cotisationEmploye.pourcentagePaie
            })
        }
    }
}

makeComponent(RssConfirmationModalComponent)

const RssEmployeurBloqueComponent = {
    selector: 'rssEmployeurBloque',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-employeur-bloque.html'
}

makeComponent(RssEmployeurBloqueComponent)

const RssEmployeurNonTrouveComponent = {
    selector: 'rssEmployeurNonTrouve',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-employeur-non-trouve.html',
    controller: class RssEmployeurNonTrouveController {
        static $inject = ['$location', '$sessionStorage']
        constructor($location, $sessionStorage) {
            this.$location = $location
            this.$sessionStorage = $sessionStorage
        }

        $onInit() {
            if (this.$sessionStorage.rechercheEmployeur) {
                this.recherche = this.$sessionStorage.rechercheEmployeur.recherche
            } else {
                this.$location.path('/')
            }
        }
    }
}

makeComponent(RssEmployeurNonTrouveComponent)

const RssEmployeurTrouveComponent = {
    selector: 'rssEmployeurTrouve',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-employeur-trouve.html',
    controller: class RssEmployeurTrouveController extends RssDemandeAbstractController {
        static $inject = ['$sessionStorage', '$location']
        constructor($sessionStorage, $location) {
            super($sessionStorage, $location)
        }
    }
}

makeComponent(RssEmployeurTrouveComponent)

const RssPanneauDetailsComponent = {
    selector: 'rssPanneauDetails',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-panneau-details.html',
    bindings: {
        rssAvecEmployeur: '<',
        rssContext: '<',
        demarrerDemande: '&'
    },
    controller: class RssPanneauDetailsController {
        static $inject = ['languageService']
        constructor(languageService) {
            this.languageService = languageService
        }

        // exposes getLang for filters in the template
        getLang() {
            return this.languageService.lang
        }
    }
}

makeComponent(RssPanneauDetailsComponent)

const RssPanneauRepartitionsComponent = {
    selector: 'rssPanneauRepartitions',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-panneau-repartitions.html',
    bindings: {
        rssAvecEmployeur: '<',
        portefeuille: '<'
    },
    controller: class RssPanneauRepartitionsController {
        colors = ['#E7EDF9', '#949599']

        static $inject = ['languageService']
        constructor(languageService) {
            this.languageService = languageService
        }

        // exposes getLang for filters in the template
        getLang() {
            return this.languageService.lang
        }

        stylePourBeigne() {
            const pourcentage = this.rssAvecEmployeur.rss.repartitions[0].pourcentage / 100
            return {
                'background': `conic-gradient(${this.colors[0]} 0deg calc(360deg * ${pourcentage}), ${this.colors[1]} calc(360deg * ${pourcentage}) 360deg)`,
                'width': '124px',
                'height': '124px',
                'border-radius': '50%',
                'display': 'flex',
                'align-items': 'center',
                'justify-content': 'center'
            }
        }

        isRepartitionVisible() {
            if (this.rssAvecEmployeur.etat === rssEtatEnum.jamaisActive
                || this.rssAvecEmployeur.etat === rssEtatEnum.sansEmployeur
                || this.rssAvecEmployeur.etat === rssEtatEnum.arretee) {
                return false
            }

            const nombreRepartitions = this.rssAvecEmployeur.rss.repartitions.length
            const nombreAdhesions = this.portefeuille.adhesions2.filter(a => a.role === adhesionRoleEnum.payeur).length

            return nombreAdhesions > 1 || nombreRepartitions > 1
        }
    }
}

makeComponent(RssPanneauRepartitionsComponent)

const RssRechercheEmployeurPageComponent = {
    selector: 'rssRechercheEmployeurPage',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-recherche-employeur-page.html',
    bindings: {
        portefeuille: '<',
        sansAdhesion: '<'
    },
    controller: class RssRechercheEmployeurPageController {
        recherche = {
            type: 'numeroEmployeur',
            numeroEmployeur: '',
            nomEmployeur: '',
            adresse: null,
            erreurs: {
                numeroEmployeurInvalide: false,
                nomEmployeurInvalide: false
            }
        }
        rechercheEnCours = false

        static $inject = ['$location', '$sessionStorage', 'employeursService', 'rssService']
        constructor($location, $sessionStorage, employeursService, rssService) {
            this.$location = $location
            this.$sessionStorage = $sessionStorage
            this.employeursService = employeursService
            this.rssService = rssService
        }

        $onInit() {
            this.rssService.getRss()
                .then(rssAvecEmployeur => this.rssAvecEmployeur = rssAvecEmployeur)
        }

        lienAnnuler() {
            return this.rssAvecEmployeur.etat === rssEtatEnum.sansEmployeur ? 'actionnaires/selectionTypeVersement' : 'rss'
        }

        rechercher() {
            this.validerRecherche()
            if (!this.demandeEnErreur()) {
                this.rechercherEmployeur()
            }
        }

        demandeEnErreur() {
            return this.recherche.erreurs.numeroEmployeurInvalide
                || this.recherche.erreurs.nomEmployeurInvalide
        }

        get estRechercheParNumero() {
            return this.recherche.type === 'numeroEmployeur'
        }

        rechercheEmployeurParNumero() {
            return this.employeursService.findByNumeroEmployeur(`A-${this.recherche.numeroEmployeur}`)
        }

        rechercheEmployeurParNomEtAdresse() {
            const nom = this.recherche.nomEmployeur
            const numeroCivique = this.recherche.adresse?.numeroCivique ?? null
            const codePostal = this.recherche.adresse?.codePostal ?? null

            return this.employeursService.findByNomEtAdresseEmployeur(nom, numeroCivique, codePostal)
        }

        rechercherEmployeur() {
            this.rechercheEnCours = true

            const recherche = this.estRechercheParNumero
                ? this.rechercheEmployeurParNumero()
                : this.rechercheEmployeurParNomEtAdresse()

            recherche
                .then(employeur => this.employeurTrouve(employeur))
                .catch(response => {
                    if (response?.status === 403) {
                        this.employeurBloque()
                    } else {
                        this.employeurNonTrouve()
                    }
                })
                .finally(() => this.rechercheEnCours = false)
        }

        employeurTrouve(employeur) {
            this.$sessionStorage.demandeRss = {
                employeur: employeur,
                intention: intentionDemandeRss.demarrer,
                utilisateurNonEligiblePourDeductionReer: !isUtilisateurEligiblePourDeductionReer(this.portefeuille.adhesions),
                cotisationEmploye: {montantPaie: '', montantHoraire: '', pourcentagePaie: ''}
            }
            this.$location.path('/rss/nouvelle/employeur/trouve')
        }

        employeurNonTrouve() {
            this.$sessionStorage.rechercheEmployeur = {
                recherche: this.estRechercheParNumero ? `A-${this.recherche.numeroEmployeur}` : this.recherche.nomEmployeur
            }
            this.$location.path('/rss/nouvelle/employeur/nontrouve')
        }

        employeurBloque() {
            this.$location.path('/rss/nouvelle/employeur/bloque')
        }

        validerRecherche() {
            if (this.estRechercheParNumero)
                this.recherche.erreurs.numeroEmployeurInvalide = this.recherche.numeroEmployeur === ''
            else
                this.recherche.erreurs.nomEmployeurInvalide = this.recherche.nomEmployeur === ''
        }
    }
}

makeComponent(RssRechercheEmployeurPageComponent)

const RssRechercheEmployeurComponent = {
    selector: 'rssRechercheEmployeur',
    templateUrl: 'app/components/rss/rss-recherche-employeur.html',
    bindings: {
        recherche: '='
    },
    controller: class {
        recherche

        get estRechercheParNumeroDeGroupe() {
            return this.recherche?.type === 'numeroEmployeur'
        }

        get estRechercheParCoordonnees() {
            return this.recherche?.type === 'nomEmployeur'
        }
    }
}

makeComponent(RssRechercheEmployeurComponent)

const RssSaisirDemandeComponent = {
    selector: 'rssSaisirDemande',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-saisir-demande.html',
    controller: class RssSaisirDemandeController extends RssDemandeAbstractController {
        nombreADeuxDecimal = /^\d+[\\.|,]?\d{0,2}/

        static $inject = ['$sessionStorage', '$location', '$uibModal']
        constructor($sessionStorage, $location, $uibModal) {
            super($sessionStorage, $location)
            this.$uibModal = $uibModal
        }

        formatMontantPaie() {
            this.demande.cotisationEmploye.montantPaie = this.#formatDeuxDecimales(this.demande.cotisationEmploye.montantPaie)
        }

        formatMontantHoraire() {
            this.demande.cotisationEmploye.montantHoraire = this.#formatDeuxDecimales(this.demande.cotisationEmploye.montantHoraire)
        }

        formatPourcentagePaie() {
            this.demande.cotisationEmploye.pourcentagePaie = this.#formatDeuxDecimales(this.demande.cotisationEmploye.pourcentagePaie)
        }

        #formatDeuxDecimales(valeur) {
            const match = valeur.match(this.nombreADeuxDecimal)
            return match === null ? '' : match[0]
        }

        plusDuneValeurSaisie() {
            const cotisation = this.demande.cotisationEmploye
            return [cotisation.montantHoraire, cotisation.montantPaie, cotisation.pourcentagePaie]
                .filter(v => v !== '')
                .length > 1
        }

        lienAnnuler() {
            return this.isIntentionDemarrer() ? 'actionnaires/selectionTypeVersement' : 'rss'
        }

        valider() {
            this.validerCotisationEmploye(this.demande.cotisationEmploye)
            this.validerMaximumPourcentageCotisationEmploye(this.demande.cotisationEmploye.pourcentagePaie)
            this.validerTypeDeduction(this.demande.typeDeductionImpot)
            this.validerAcceptation(this.demande.accepteConditions)

            if (!this.demandeEnErreur()) {
                this.#confirmer()
            }
        }

        demandeEnErreur() {
            return this.demande.erreurs.acceptation
                || this.demande.erreurs.typeDeductionImpot
                || this.demande.erreurs.aucuneCotisationEmploye
                || this.demande.erreurs.maximumPourcentageCotisationEmploye
        }

        isIntentionModification() {
            return this.demande.intention === intentionDemandeRss.modification
        }

        isIntentionReactivation() {
            return this.demande.intention === intentionDemandeRss.reactivation
        }

        isIntentionActivation() {
            return this.demande.intention === intentionDemandeRss.activation
        }

        isIntentionDemarrer() {
            return this.demande.intention === intentionDemandeRss.demarrer
        }

        #confirmer() {
            this.$uibModal.open({
                component: RssConfirmationModalComponent.selector,
                windowClass: 'confirmation-modal',
                resolve: {
                    demande: () => this.demande
                }
            })
        }

        validerCotisationEmploye(cotisationEmploye) {
            this.demande.erreurs.aucuneCotisationEmploye = this.valeurNonSaisie(cotisationEmploye.montantPaie)
                && this.valeurNonSaisie(cotisationEmploye.montantHoraire)
                && this.valeurNonSaisie(cotisationEmploye.pourcentagePaie)
        }

        valeurNonSaisie(valeur) {
            return valeur === '' || parseFloat(valeur.replace(',', '.')) === 0
        }

        validerMaximumPourcentageCotisationEmploye(pourcentage) {
            this.demande.erreurs.maximumPourcentageCotisationEmploye = parseFloat(pourcentage.replace(',', '.')) > 100
        }

        validerTypeDeduction(typeDeductionImpot) {
            this.demande.erreurs.typeDeductionImpot = typeDeductionImpot === undefined
        }

        validerAcceptation(acceptation) {
            this.demande.erreurs.acceptation = acceptation === false
        }
    }
}

makeComponent(RssSaisirDemandeComponent)

const RssTableauTransactionsComponent = {
    selector: 'rssTableauTransactions',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-tableau-transactions.html',
    bindings: {
        transactions: '<'
    },
    controller: class RssTableauTransactionsController {
        static $inject = ['languageService']
        constructor(languageService) {
            this.languageService = languageService
        }

        // exposes getLang for filters in the template
        getLang() {
            return this.languageService.lang
        }
    }
}

makeComponent(RssTableauTransactionsComponent)

const RssValiderEmployeurComponent = {
    selector: 'rssValiderEmployeur',
    // language=file-reference
    templateUrl: 'app/components/rss/rss-valider-employeur.html',
    controller: class RssValiderEmployeurController extends RssDemandeAbstractController {
        static $inject = ['$sessionStorage', '$location']
        constructor($sessionStorage, $location) {
            super($sessionStorage, $location)
        }
    }
}

makeComponent(RssValiderEmployeurComponent)

const RssComponent = {
    selector: 'rss',
    // language=file-reference
    templateUrl: 'app/components/rss/rss.html',
    bindings: {
        loadingPortefeuille: '<',
        portefeuille: '<',
        sansAdhesion: '<'
    },
    controller: class RssController {
        rssAvecEmployeur
        rssContext
        transactions

        static $inject = ['$location', '$sessionStorage', 'rssService', 'languageService']
        constructor($location, $sessionStorage, rssService, languageService) {
            this.$location = $location
            this.$sessionStorage = $sessionStorage
            this.rssService = rssService
            this.languageService = languageService
        }

        $onInit() {
            this.rssService.getRss()
                .then(rssAvecEmployeur => {
                    this.rssAvecEmployeur = rssAvecEmployeur
                    this.rssContext = rssContext(rssAvecEmployeur)
                    this.redirigerSelonCasSpecial()
                })

            this.rssService.getVersementsRss()
                .then(versements => this.transactions = versements.transactions)
        }

        $onChanges(changes) {
            if (changes.portefeuille)
                this.redirigerSelonCasSpecial()
        }

        // exposes getLang for filters in the template
        getLang() {
            return this.languageService.lang
        }

        avecContributionEmployeur(lang) {
            if (this.transactions.reduce((somme, t) => somme + t.montantEmployeur, 0) > 0) {
                return lang === 'francais' ? 'Oui' : 'Yes'
            }
            return lang === 'francais' ? 'Non' : 'No'
        }

        adhesionsAvecCotisationsRss() {
            return this.portefeuille.adhesions.some(adhesion => this.adhesionAvecCotisationsRss(adhesion))
        }

        adhesionAvecCotisationsRss(adhesion) {
            return valeurAccumuleeParRssFilter(adhesion) > 0
        }

        demarrerDemande() {
            this.$sessionStorage.demandeRss = creerDemandeRss(this.rssAvecEmployeur, this.portefeuille.adhesions)
            this.$location.path('/rss/nouvelle/employeur')
        }

        redirigerSelonCasSpecial() {
            if (!this.portefeuille || !this.rssAvecEmployeur)
                return

            if (!this.portefeuille.adhesions2.some(a => a.role === adhesionRoleEnum.payeur)) {
                this.$location.path('/rss/nondisponible')
            } else if (this.rssAvecEmployeur.etat === rssEtatEnum.sansEmployeur) {
                this.$location.path('/rss/nouvelle/employeur/recherche')
            }
        }
    }
}

makeComponent(RssComponent)

const SelectionTypeVersementComponent = {
    selector: 'selectionTypeVersement',
    // language=file-reference
    templateUrl: 'app/components/selection-type-versement/selection-type-versement.html',
    bindings: {
        portefeuille: '<',
        isLimiteVersementsActive: '&',
        limiteVersementsMessage: '&'
    },
    controller: class SelectionTypeVersementController {
        rssAvecEmployeur
        rssContext

        static $inject = ['$location', '$sessionStorage', 'rssService', 'languageService']
        constructor($location, $sessionStorage, rssService, languageService) {
            this.$location = $location
            this.$sessionStorage = $sessionStorage
            this.rssService = rssService
            this.languageService = languageService
        }

        $onInit() {
            this.rssService.getRss()
                .then(rssAvecEmployeur => {
                    this.rssAvecEmployeur = rssAvecEmployeur
                    this.rssContext = rssContext(rssAvecEmployeur)
                })
        }

        getLang() {
            return this.languageService.lang
        }

        demarrerDemande() {
            this.$sessionStorage.demandeRss = creerDemandeRss(this.rssAvecEmployeur, this.portefeuille.adhesions)
            this.$location.path('/rss/nouvelle/employeur')
        }
    }
}

makeComponent(SelectionTypeVersementComponent)

class Task {
    pending = true
    resolved = false
    rejected = false

    constructor(promise) {
        promise
            .then(() => this.resolved = true)
            .catch(() => this.rejected = true)
            .finally(() => this.pending = false)
    }
}
const TranslationComponent = {
    selector: 'translation',
    bindings: {
        inject: '=',
        message: '@'
    },
    controller: class {
        $postLink() {
            this.inject = this.message
        }
    }
}

makeComponent(TranslationComponent)
const VersementBancaireComponent = {
    selector: 'versementBancaire',
    // language=file-reference
    templateUrl: 'app/components/versement-bancaire.html',
    bindings: {
        versement: '=',
        periodique: '<?',
        limite: '<?',
        etape: '@'
    },
    controller: class {
        versement
        periodique = false
        limite
        etape
        #limiteVersementService
        limiteVersementsParFrequence
        warningDatePrelevement
        errorMontantTooSmall
        errorMontantTooLarge
        errorMontantLimite

        static $inject = [LimiteVersementService.dependency]

        constructor(limiteVersementService) {
            this.#limiteVersementService = limiteVersementService
        }

        $postLink() {
            this.#loadLimiteVersementParFrequence()
        }

        get warningDatePremierVersement() {
            if (!this.versement.frequence || !this.datePremierPrelevement)
                return

            if (this.versement.frequence === 'mensuelle' && this.datePremierPrelevement.day > 28)
                return this.warningDatePrelevement
        }

        get datePremierPrelevement() {
            return DateUtils.from(this.versement.datePremierPrelevement)
        }

        get validateMontant() {
            if (!this.versement.montant)
                return

            if (this.versement.montant < 10)
                return this.errorMontantTooSmall

            if (this.versement.montant >= 100000)
                return this.errorMontantTooLarge

            if (!this.versement.frequence)
                return

            if (this.limite && this.limiteVersementsParFrequence && this.versement.montant > this.limiteVersementsParFrequence[this.versement.frequence])
                return this.errorMontantLimite
        }

        get etapeSuivante() {
            return parseInt(this.etape) + 1
        }

        #loadLimiteVersementParFrequence() {
            this.#limiteVersementService.getLimiteVersements()
                .then(result => this.limiteVersementsParFrequence = result)
        }
    }
}

makeComponent(VersementBancaireComponent)
const VersementRssIntentionComponent = {
    selector: 'versementRssIntention',
    // language=file-reference
    templateUrl: 'app/components/versement-rss-intention.html',
    bindings: {
        etape: '@'
    }
}

makeComponent(VersementRssIntentionComponent)

const VersementRssComponent = {
    selector: 'versementRss',
    // language=file-reference
    templateUrl: 'app/components/versement-rss.html',
    bindings: {
        versement: '=',
        regime: '=',
        rssPrecedente: '<',
        etape: '@'
    },
    controller: class {
        #employeursService
        rechercheEnCours
        versement
        regime
        form
        rssPrecedente
        etape
        displayRssExistanteMessage = false
        deductionsPossibles = {
            nonEnregistre: ['creditImpot', 'aucune'],
            enregistre: ['tout', 'reer', 'creditImpot', 'aucune']
        }

        static $inject = ['employeursService', '$window', '$timeout']

        constructor(employeursService, $window, $timeout) {
            this.#employeursService = employeursService
            this.$window = $window
            this.$timeout = $timeout
        }

        $onInit() {
            if(this.rssPrecedente) {
                this.displayRssExistanteMessage = true
                if(!this.versement?.recherche) {
                    this.initialiseVersementInfoFromPreviousRss()
                }
            }
        }

        initialiseVersementInfoFromPreviousRss () {
            this.versement.recherche = {
                type: "numeroEmployeur",
                numeroEmployeur: this.rssPrecedente.employeur.numeroResponsableDeRemise.substring(2)
            }
            this.versement.contributionParPaie = this.rssPrecedente.rss.cotisationEmploye.montantPaie > 0 ? this.rssPrecedente.rss.cotisationEmploye.montantPaie : null
            this.versement.contributionParPourcentageSalaire = this.rssPrecedente.rss.cotisationEmploye.pourcentagePaie > 0 ? this.rssPrecedente.rss.cotisationEmploye.pourcentagePaie : null
            this.versement.contributionParHeure = this.rssPrecedente.rss.cotisationEmploye.montantHoraire > 0 ? this.rssPrecedente.rss.cotisationEmploye.montantHoraire : null
            this.versement.deduction = this.findPreviouslySelectedDeduction()
        }

        findPreviouslySelectedDeduction() {
            let value=null;
            this.deductionsPossibles[this.regime].find(val => {
                if(typeDeductionEnum[val] === this.rssPrecedente.rss.typeDeductionImpot)
                    value = val
            })
            return value
        }

        get displayMessageRssExistante() {
            return !!(this.rssPrecedente) && this.displayRssExistanteMessage
        }

        giveConsentToOverwriteRssExistante() {
            this.displayRssExistanteMessage = false;
        }

        rechercherEmployeur() {
            this.rechercheEnCours = true
            this.#reinitaliseLesInformationsDeVersement()

            const rechercheEmployeur = this.rechercheParNumero
                ? () => this.#rechercheEmployeurParNumero()
                : () => this.#rechercheEmployeurParNomEtAdresse()

            rechercheEmployeur()
                .then(response => {
                    this.versement.employeur = response.nom
                    this.versement.numeroResponsableDeRemise = response.numeroResponsableDeRemise
                    this.versement.responsableRemiseId = response.responsableRemiseId
                    this.versement.recherche.resultat = true
                    this.versement.bloque = false
                    this.versement.recherche.resultatAccepte = undefined
                })
                .catch(response => {
                    this.versement.recherche.resultat = false
                    this.versement.recherche.resultatAccepte = false
                    this.versement.bloque = response?.status === 403
                    this.#reinitaliseLesInformationsDeVersement()
                })
                .finally(() => {
                    this.rechercheEnCours = false
                    this.#scrollIntoView('#resultat-message');
                })
        }

        get rechercheParNumero() {
            return this.versement.recherche?.type === 'numeroEmployeur'
        }

        get rechercherParNom() {
            return this.versement.recherche?.type === 'nomEmployeur'
        }

        get resultatPositif() {
           return this.versement.recherche?.resultat === true
        }

        get resultatNegatif() {
            return this.versement.recherche?.resultat === false
        }

        get resultatNegatifParNumero() {
            return this.rechercheParNumero && this.resultatNegatif && !this.resultatBloque
        }

        get resultatNegatifParNomEtAdresse() {
            return this.rechercherParNom && this.resultatNegatif && !this.resultatBloque
        }

        get resultatBloque() {
            return this.versement.bloque === true
        }

        get resultatPasEncoreAccepteOuRefuse() {
            return this.versement.recherche?.resultatAccepte == null
        }

        get doitAfficherErreurRechercheIncomplete() {
            return this.form?.$submitted && this.resultatPasEncoreAccepteOuRefuse
        }

        get afficherAutresSections() {
            return this.versement.recherche?.resultatAccepte && !this.displayRssExistanteMessage
        }

        get isContributionRequired() {
            return !(this.versement.contributionParPaie > 0 || this.versement.contributionParPourcentageSalaire > 0 || this.versement.contributionParHeure > 0)
        }

        accepter() {
            this.versement.recherche.resultatAccepte = true
            this.#scrollIntoView('#section-montants');
        }

        refuser() {
            this.versement.recherche.resultatAccepte = false
            this.versement.recherche.resultat = null
            this.#reinitaliseLesInformationsDeVersement()
        }

        get estRegimeNonEnregistre() {
            return this.regime === regimeEnum.nonEnregistre
        }

        etapeSuivante(increment) {
            return parseInt(this.etape) + increment
        }

        #scrollIntoView(element) {
            this.$timeout(() => {
                const targetElement = document.querySelector(element);

                targetElement?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            })
        }

        #reinitaliseLesInformationsDeVersement() {
            this.versement.employeur = null
            this.versement.responsableRemiseId = null
            this.versement.numeroResponsableDeRemise = null
        }

        #rechercheEmployeurParNumero() {
            const apiNumeroEmployeur = 'A-' + this.versement.recherche.numeroEmployeur

            return this.#employeursService.findByNumeroEmployeur(apiNumeroEmployeur)
        }

        #rechercheEmployeurParNomEtAdresse() {
            const apiNom = this.versement.recherche.nomEmployeur
            const apiNumeroCivique = this.versement.recherche.adresse?.numeroCivique
            const apiCodePostal = this.versement.recherche.adresse?.codePostal

            return this.#employeursService.findByNomEtAdresseEmployeur(apiNom, apiNumeroCivique, apiCodePostal)
        }
    }
}

makeComponent(VersementRssComponent)
const WizardStepComponent = {
    selector: 'wizardStep',
    templateUrl: 'app/components/wizard/wizard-step.html',
    transclude: true,
    require: {
      wizard: '^wizard'
    },
    bindings: {
        stepTitle: "@",
        hideNavigation: "<?"
    },
    controller: class {
        wizard
        form
        $element

        static $inject = ['$element']
        constructor($element) {
            this.$element = $element
        }

        $onInit() {
            this.wizard.addStep(this)
        }

        $onDestroy() {
            this.wizard.removeStep(this)
        }

        get isCurrentStep() {
            return this.wizard.isCurrentStep(this)
        }

        checkValidity() {
            this.form.$setSubmitted()

            if (!this.form.$valid) {
                this.$element.find('form .ng-invalid')
                    .get(0)
                    .scrollIntoView({behavior: 'smooth', block: 'center'})
            }

            return this.form.$valid
        }
    }
}

makeComponent(WizardStepComponent)
const WizardComponent = {
    selector: 'wizard',
    template: `
    <div data-ng-if="!$ctrl.done">
        <h3 ng-bind-html="$ctrl.stepTitle | format:$ctrl.titleFormatParams"></h3>
        <div class="progress wizard-progress">
            <div class="progress-bar"
                 role="progressbar"
                 aria-valuenow="{{ $ctrl.stepIndex }}"
                 aria-valuemin="1"
                 aria-valuemax="{{ $ctrl.steps.length - 1 }}"
                 data-ng-style="$ctrl.progressStyle"></div>
        </div>
        <ng-transclude ng-transclude-slot="steps"></ng-transclude>
        <ng-transclude ng-transclude-slot="errors"></ng-transclude>
        <div data-ng-hide="$ctrl.hideNavigation" class="navigation">
            <button id="navigate-previous"
                    aria-label="{{ $ctrl.backStepButtonLabel }}"
                    class="btn btn-default pull-left"
                    data-ng-disabled="$ctrl.submitting"
                    data-ng-show="$ctrl.hasPreviousStep"
                    data-ng-click="$ctrl.navigateBack()">
                <span class="pull-left"><i class="fa fa-chevron-left"></i></span>
                <span class="visible-md visible-lg pull-right">{{ $ctrl.backStepButtonLabel }}</span>
            </button>
            <div class="pull-right">
                <button id="cancel"
                        class="btn btn-default"
                        data-ng-click="$ctrl.cancel()">
                    <span class="pull-left">{{ $ctrl.cancelButtonLabel }}</span>
                </button>
                <button id="navigate-next"
                        aria-label="{{ $ctrl.nextStepButtonLabel }}"
                        class="btn btn-primary"
                        data-ng-show="$ctrl.hasNextStep"
                        data-ng-click="$ctrl.navigateNext()">
                    <span class="visible-md visible-lg pull-left">{{ $ctrl.nextStepButtonLabel }}</span>
                    <span class="pull-right"><i class="fa fa-chevron-right"></i></span>
                </button>
                <button id="submit"
                        class="btn btn-primary"
                        data-ng-disabled="$ctrl.submitting"
                        data-ng-show="!$ctrl.hasNextStep"
                        data-ng-click="$ctrl.submit()">
                    <span class="pull-left">{{ $ctrl.submitButtonLabel }}</span>
                    <span class="pull-right"><i data-ng-show="$ctrl.submitting" class="fa fa-spinner fa-spin"></i></span>
                </button>
            </div>
        </div>
        <modal-confirmation-dialog
            id="cancelConfirmationDialog"
            data-ng-ref="$ctrl.cancelConfirmationDialog"
            title="{{$ctrl.cancelDialogTitle}}"
            confirm-button-label="{{$ctrl.cancelYesButtonLabel}}"
            cancel-button-label="{{$ctrl.cancelNoButtonLabel}}"
            confirm-button-action="$ctrl.onCancel()">
                <ng-transclude ng-transclude-slot="cancelMessage"></ng-transclude>
        </modal-confirmation-dialog>
    </div>
    <ng-transclude data-ng-if="$ctrl.done" ng-transclude-slot="completed"></ng-transclude>
`,
    transclude: {
        steps: 'wizardSteps',
        completed: 'wizardCompleted',
        errors: '?wizardErrors',
        cancelMessage: 'wizardCancelMessage'
    },
    bindings: {
        stepTitle: '@',
        backStepButtonLabel: '@',
        nextStepButtonLabel: '@',
        cancelButtonLabel: '@',
        submitButtonLabel: '@',
        cancelDialogTitle: '@',
        cancelYesButtonLabel: '@',
        cancelNoButtonLabel: '@',
        onCancel: '&',
        onSubmit: '&',
        stepIndex: '='
    },
    controller: class {
        done = false
        stepIndex = 0
        steps = []

        static $inject = ['$window', '$element']
        constructor($window, $element) {
            this.$window = $window
            this.$element = $element
        }

        addStep(step) {
            this.steps.push(step)
        }

        removeStep(step) {
            this.steps = this.steps.filter(s => s !== step)
        }

        get hideNavigation() {
            return this.currentStep?.hideNavigation
        }

        get hasPreviousStep() {
            return this.stepIndex !== 0
        }

        get hasNextStep() {
            return this.stepIndex < this.steps.length - 1
        }

        async submit() {
            if (!this.currentStep.checkValidity()) return

            this.submitting = true
            this.done = await this.onSubmit()
            this.submitting = false
        }

        cancel() {
            this.cancelConfirmationDialog.show()
        }

        navigateNext() {
            if (this.currentStep.checkValidity())
            {
                this.#dispatchEvent('wizard-navigate-next')

                this.stepIndex++;
                this.$window.scrollTo(0, 0)
            }
        }

        navigateBack() {
            this.#dispatchEvent('wizard-navigate-back')

            this.stepIndex--;
            this.$window.scrollTo(0, 0)
        }

        isCurrentStep(step) {
            return this.currentStep === step
        }

        get currentStep() {
            return this.steps[this.stepIndex]
        }

        get titleFormatParams() {
            return {
                number: this.stepIndex + 1,
                count: this.steps.length,
                title: this.currentStep?.stepTitle
            }
        }

        get progressStyle() {
            return {
                width: `${(this.stepIndex + 1) / (this.steps.length) * 100}%`
            }
        }

        #dispatchEvent(event) {
            this.$element[0].dispatchEvent(new CustomEvent(event, { bubbles: true }))
        }
    }
}

makeComponent(WizardComponent)
class NgDropZoneDirective {
    restrict = 'A'
    link(scope, element, attrs) {
        element.on('dragover dragenter', function (e) {
            e.preventDefault()
            e.stopPropagation()
            element.addClass('drag-over')
        })

        element.on('dragleave dragend', function (e) {
            e.preventDefault()
            e.stopPropagation()
            element.removeClass('drag-over')
        })

        element.on('drop', function (e) {
            e.preventDefault()
            e.stopPropagation()
            element.removeClass('drag-over')

            const files = Array.from(e.originalEvent.dataTransfer.files)
            scope.$apply(() => {
                scope.$eval(attrs.ngDropZone, {$files: files})
            })
        })
    }
}

angular.module('paf')
    .directive('ngDropZone', () => new NgDropZoneDirective())

class NgFileChangeDirective {
    restrict = 'A'
    link(scope, element, attrs) {
        element.on('change', function () {
            scope.$apply(() => {
                scope.$eval(attrs.ngFileChange, {$files: Array.from(this.files)})
                this.value = ''
            })
        })
    }
}

angular.module('paf')
    .directive('ngFileChange', () => new NgFileChangeDirective())

class ScrollToDirective {
    restrict = 'A'
    link(scope, element, attrs) {
        element.on('click', () => {
            let target = document.querySelector(attrs.scrollTo)
            target.scrollIntoView({behavior: 'smooth', block: 'start'})
            target.focus()
        })
    }
}

angular.module('paf')
    .directive('scrollTo', () => new ScrollToDirective())
﻿angular
    .module('paf')
    .config(['$routeProvider', '$httpProvider', '$locationProvider', function ($routeProvider, $httpProvider, $locationProvider) {
        $locationProvider.html5Mode({enabled: true})

        $routeProvider
            .when('/actionnaires/connexion', {template: '<connexion></connexion>'})
            .when('/callback', {template: '<authentication></authentication>'})
            .when('/actionnaires/identification', {template: '<identification-epargnant recharger-portefeuille="rechargerPortefeuille()"></identification-epargnant>'})
            .when('/actionnaires/verificationAdresseCourriel', {template: '<verification-adresse-courriel></verification-adresse-courriel>'})

            // Nouvelle adhésion pour un nouvel actionnaire
            .when('/visiteur/adhesion', {template: '<nouvelle-adhesion-intro></nouvelle-adhesion-intro>'})
            .when('/visiteur/nouvelleAdhesion', {template: '<nouvelle-adhesion-visiteur></nouvelle-adhesion-visiteur>'})

            // Nouvelle adhésion pour un actionnaire existant
            .when('/actionnaires/adhesion', {template: '<nouvelle-adhesion-actionnaire recharger-portefeuille="rechargerPortefeuille()"></nouvelle-adhesion-actionnaire>'})

            // Pages Mon dossier
            .when('/', {templateUrl: 'portefeuille/portefeuille.html', controller: 'portefeuilleController'})
            .when('/actionnaires/releveTransactions', {template: `<releve-transactions loading-portefeuille="loadingPortefeuille" portefeuille="portefeuille" sans-adhesion="sansAdhesion"></releve-transactions>`})
            .when('/documents', {template: '<documents></documents>'})
            .when('/actionnaires/selectionTypeVersement', {template: `<selection-type-versement portefeuille="portefeuille" is-limite-versements-active="isLimiteVersementsActive()" limite-versements-message="limiteVersementsMessage()"></selection-type-versement>`})
            .when('/acceptationLegale', {template: '<acceptation-legale recharger-portefeuille="rechargerPortefeuille()"></acceptation-legale>'})

            // RSS
            .when('/rss', {template: `<rss loading-portefeuille="loadingPortefeuille" portefeuille="portefeuille" sans-adhesion="sansAdhesion"></rss>`})
            .when('/rss/nondisponible', {templateUrl: 'rss/voir/pageRssNonDisponible.html'})
            .when('/rss/nouvelle/employeur', {template: '<rss-valider-employeur></rss-valider-employeur>'})
            .when('/rss/nouvelle/employeur/recherche', {template: `<rss-recherche-employeur-page portefeuille="portefeuille" sans-adhesion="sansAdhesion"></rss-recherche-employeur-page>`})
            .when('/rss/nouvelle/employeur/trouve', {template: '<rss-employeur-trouve></rss-employeur-trouve>'})
            .when('/rss/nouvelle/employeur/nontrouve', {template: '<rss-employeur-non-trouve></rss-employeur-non-trouve>'})
            .when('/rss/nouvelle/employeur/bloque', {template: '<rss-employeur-bloque></rss-employeur-bloque>'})
            .when('/rss/nouvelle/demande', {template: '<rss-saisir-demande></rss-saisir-demande>'})
            .when('/rss/arret/validation', {template: `<rss-arret-validation loading-portefeuille="loadingPortefeuille" portefeuille="portefeuille"></rss-arret-validation>`})
            .when('/rss/arret/confirmation', {template: '<rss-arret-confirmation></rss-arret-confirmation>'})

            // DPU
            .when('/actionnaires/creationDpu', {
                template: `<dpu-creation
                    loading-portefeuille="loadingPortefeuille"
                    portefeuille="portefeuille"
                    sans-adhesion="sansAdhesion"
                    is-limite-versements-active="isLimiteVersementsActive()"
                    limite-versements-message="limiteVersementsMessage()"
                    recharger-portefeuille="rechargerPortefeuille()">
                </dpu-creation>`
            })
            .when('/actionnaires/creationDpu/annuler', {template: '<dpu-annuler-transaction></dpu-annuler-transaction>'})
            .when('/actionnaires/droitsRecours', {templateUrl: 'template/actionnaire/droitsRecours.html'})

            // DPA
            .when('/actionnaires/dpas', {
                template: `<dpas
                    loading-portefeuille="loadingPortefeuille"
                    portefeuille="portefeuille"
                    sans-adhesion="sansAdhesion"
                    is-limite-versements-active="isLimiteVersementsActive()"
                    limite-versements-message="limiteVersementsMessage()">
                </dpas>`
            })
            .when('/actionnaires/dpas/nouveau', {
                template: `<dpa-formulaire
                    portefeuille="portefeuille"
                    is-limite-versements-active="isLimiteVersementsActive()"
                    limite-versements-message="limiteVersementsMessage()">
                </dpa-formulaire>`
            })

            // RAP/REEP
            .when('/rap', {
                template: `<rap
                            loading-portefeuille="loadingPortefeuille"
                            portefeuille="portefeuille"
                            sans-adhesion="sansAdhesion"
                            rap="rap"
                            documents="documents"
                            transactions-en-traitement="transactionsEnTraitement"
                        </rap>`
            })
            .when('/rap/remboursement', {
                template: `<demande-remboursement-rap
                    loading-portefeuille="loadingPortefeuille"
                    portefeuille="portefeuille"
                    sans-adhesion="sansAdhesion"
                    rap="rap"
                    transactions-en-traitement="transactionsEnTraitement"
                    recharger-portefeuille="rechargerPortefeuille()">
                </demande-remboursement-rap>`
            })
            .when('/reep', {
                template: `<reep
                            loading-portefeuille="loadingPortefeuille"
                            portefeuille="portefeuille"
                            sans-adhesion="sansAdhesion"
                            rap="rap"
                            reep="reep"
                            documents="documents"
                            transactions-en-traitement="transactionsEnTraitement"
                        </reep>`
            })
            .when('/reep/remboursement', {
                template: `<demande-remboursement-reep
                    loading-portefeuille="loadingPortefeuille"
                    portefeuille="portefeuille"
                    sans-adhesion="sansAdhesion"
                    reep="reep"
                    transactions-en-traitement="transactionsEnTraitement"
                    recharger-portefeuille="rechargerPortefeuille()">
                </demande-remboursement-reep>`
            })

            // Pages Mon Profil
            .when('/actionnaires/changementCoordonnees', {template: '<changement-coordonnees recharger-portefeuille="rechargerPortefeuille()"></changement-coordonnees>'})
            .when('/actionnaires/gererCommunications', {template: '<gerer-communications recharger-portefeuille="rechargerPortefeuille()"></gerer-communications>'})
            .when('/actionnaires/gererSecurite', {template: '<gerer-securite></gerer-securite>'})

            // Demandes de rachat
            .when('/actionnaires/demandeRachat', {template: '<rachats-parcours-libre-service recharger-portefeuille="rechargerPortefeuille()"></rachats-parcours-libre-service>'})

            // Pages Liens utiles
            .when('/actionnaires/documentation', {templateUrl: 'template/actionnaire/documentation.html'})

            .otherwise({redirectTo: '/'})
        $httpProvider.interceptors.push('authenticationInterceptor')
    }])
